// @ts-nocheck
import { MOCK, invalidateAndRefresh } from "@/state/app-store";
import { UI } from "@/components/ui";
import { Icon } from "@/components/icons";
import { api, contentApi, shareConfigsApi } from "@/api/index";

const { $, $$, fmtNum, fmtMoney, fmtPercent, toast, confirmModal, hasPerm, statusBadge, trendArrow, statCard, channelChip, capabilityBadge, pageHeader, emptyState, primaryBtn, ghostBtn, stepIndicator, BUSINESS_COLORS, chartTooltip, chartXAxis, chartYAxis, chartLineSeries, chartBarSeries } = UI;

declare const echarts: any;
declare const Pages: Record<string, any>;
declare const PageHooks: { mounted?: ((path: string) => void) | null };
declare function navigate(path: string): void;
declare function getCurrentPath(): string;
declare function getCurrentPathWithQuery(): string;
declare function renderRoute(): void;

if (typeof window !== "undefined") {
  (window as any).Pages = (window as any).Pages || {};
}

const Pages = (window as any).Pages;

// __legacy_global_aliases__
// Resolve cross-module helpers via window (legacy SPA globals)
const escapeShareCardValue = (...args: any[]) => (window as any).escapeShareCardValue(...args);
const getShareCardOgFormState = (...args: any[]) => (window as any).getShareCardOgFormState(...args);
const getShareCardPostChannelNames = (...args: any[]) => (window as any).getShareCardPostChannelNames(...args);
const getShareCardPreviewImageHtml = (...args: any[]) => (window as any).getShareCardPreviewImageHtml(...args);
const getShareCardStyles = (...args: any[]) => (window as any).getShareCardStyles(...args);
const getShareLanguageCatalog = (...args: any[]) => (window as any).getShareLanguageCatalog(...args);
const getShareLanguageChineseName = (...args: any[]) => (window as any).getShareLanguageChineseName(...args);
const getShareRegionCountrySelection = (...args: any[]) => (window as any).getShareRegionCountrySelection(...args);
const renderShareCardUnifiedConfig = (...args: any[]) => (window as any).renderShareCardUnifiedConfig(...args);
const saveShareCardOgFormState = (...args: any[]) => (window as any).saveShareCardOgFormState(...args);
const saveShareCardPostFormState = (...args: any[]) => (window as any).saveShareCardPostFormState(...args);
const setShareRegionCountrySelection = (...args: any[]) => (window as any).setShareRegionCountrySelection(...args);


// ============================================================
// 分享配置页（PRD 4.2 + 渠道字段抽象）
// 快速模式 / 专家模式 / 配置列表
// ============================================================

window.Pages = window.Pages || {};

const OPS_MODULES = [
  { key: "landing", title: "分享落地页配置", path: "/ops/share-landing-config", icon: "globe", desc: "创建落地页" },
  { key: "landing_manage", title: "已配置落地页管理", path: "/ops/configured-landing-pages", icon: "globe", desc: "落地页资产" },
  { key: "template_library", title: "模版库", path: "/ops/template-library", icon: "layers", desc: "落地页预制模版" },
  { key: "card", title: "分享卡片配置", path: "/ops/share-card-config", icon: "image", desc: "创建卡片" },
  { key: "card_manage", title: "已配置卡片管理", path: "/ops/configured-cards", icon: "image", desc: "分享卡片资产" },
  { key: "activity", title: "分享活动配置", path: "/ops/share-config", icon: "calendar", desc: "活动方案" },
  { key: "package", title: "包体运营", path: "/ops/package-config", icon: "package", desc: "配置历史" },
  { key: "share", title: "分享管理", path: "/ops/share-manager", icon: "send", desc: "分享流水" },
  { key: "analytics", title: "数据分析", path: "/ops/analytics", icon: "chart", desc: "漏斗 / 渠道 / 路径" },
];

function renderOpsModuleTabs() {
  return "";
}

function renderOpsWorkflowHint() {
  return "";
}

Pages.shareLandingConfigList = function () {
  const query = location.hash.includes("?") ? location.hash.split("?")[1] : "";
  const selectedTemple = new URLSearchParams(query).get("temple") || "";
  const selectedTemplate = (MOCK.TEMPLATES || []).find((t) => (t.temple_id || t.id) === selectedTemple);
  const selectedTemplateUrl = selectedTemple ? `https://share.easyshare.com/landing/template/${selectedTemple}` : "";
  const requestedMethod = new URLSearchParams(query).get("method") || (selectedTemple ? "template" : "existing");
  const activeLandingMethod = ["existing", "template", "ai"].includes(requestedMethod) ? requestedMethod : "existing";
  const tabClass = (method) => activeLandingMethod === method ? "bg-brand-900 text-white shadow-soft" : "text-ink-600 hover:bg-ink-50";
  return `
    ${UI.pageHeader({
      title: "创建落地页",
      desc: "用一个页面完成落地页资产创建：先填写名称，再选择页面 URL 来源，最后保存为可复用落地页资产。",
      actions: `
        <button onclick="navigate('/ops/configured-landing-pages')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">查看落地页管理</button>
        <button onclick="navigate('/ops/share-config')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">去配置分享活动</button>
      `,
    })}

    <section class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">1. 落地页名称</h3>
          <p class="text-xs text-ink-500 mt-0.5">给这条落地页资产起一个运营可识别的名称。</p>
        </div>
        <span class="badge bg-ink-100 text-ink-700">必填</span>
      </div>
      <div class="p-5">
        <label class="block max-w-2xl">
          <span class="block text-sm font-medium text-ink-700 mb-1.5">落地页名称</span>
          <input id="landing-page-name-input" placeholder="请输入落地页名称" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm" />
        </label>
      </div>
    </section>

    <section class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100">
        <h3 class="text-sm font-semibold text-ink-900">2. URL 获取方式</h3>
        <p class="text-xs text-ink-500 mt-0.5">先选择来源，再在下方完成该来源的操作；成功后自动回填到「页面 URL」。</p>
      </div>
      <div class="p-5 space-y-4">
        <div class="grid grid-cols-3 gap-3">
          <button type="button" onclick="navigate('/ops/share-landing-config?method=existing')" class="text-left rounded-xl border p-4 transition ${activeLandingMethod === "existing" ? "border-purple-300 bg-purple-50 shadow-soft" : "border-ink-100 bg-white hover:border-purple-200 hover:bg-purple-50/40"}">
            <div class="flex items-center justify-between gap-2">
              <span class="text-[11px] font-semibold text-purple-700">方式一</span>
              <span class="badge bg-white text-purple-700 border border-purple-100">推荐</span>
            </div>
            <div class="mt-2 text-sm font-semibold text-ink-900">游戏已有 URL</div>
            <div class="mt-1 text-xs text-ink-500 leading-relaxed">粘贴 URL 并校验，最快完成。</div>
          </button>
          <button type="button" onclick="navigate('/ops/share-landing-config?method=template${selectedTemple ? `&temple=${encodeURIComponent(selectedTemple)}` : ""}')" class="text-left rounded-xl border p-4 transition ${activeLandingMethod === "template" ? "border-brand-300 bg-brand-50 shadow-soft" : "border-ink-100 bg-white hover:border-brand-200 hover:bg-brand-50/40"}">
            <div class="flex items-center justify-between gap-2">
              <span class="text-[11px] font-semibold text-brand-700">方式二</span>
              <span class="badge bg-white text-brand-700 border border-brand-100">模版库</span>
            </div>
            <div class="mt-2 text-sm font-semibold text-ink-900">系统模版 URL</div>
            <div class="mt-1 text-xs text-ink-500 leading-relaxed">去模版库选择后生成 URL。</div>
          </button>
          <button type="button" disabled class="text-left rounded-xl border border-emerald-100 bg-emerald-50/40 p-4 opacity-70 cursor-not-allowed">
            <div class="flex items-center justify-between gap-2">
              <span class="text-[11px] font-semibold text-emerald-700">方式三</span>
              <span class="badge bg-white text-emerald-700 border border-emerald-100">Beta</span>
            </div>
            <div class="mt-2 text-sm font-semibold text-ink-900">Share AI URL</div>
            <div class="mt-1 text-xs text-ink-500 leading-relaxed">保留入口，暂不可点击。</div>
          </button>
        </div>

        <div class="rounded-xl border border-ink-100 bg-white p-4">
          ${activeLandingMethod === "template" ? `
            <div class="space-y-3">
              <div class="flex items-start justify-between gap-4">
                <div class="min-w-0">
                  <div class="flex items-center gap-2">
                    <span class="w-6 h-6 rounded-full bg-brand-900 text-white text-[11px] font-semibold flex items-center justify-center">2</span>
                    <div class="text-sm font-semibold text-ink-900">从模版库选择落地页模版</div>
                  </div>
                  <div class="text-xs text-ink-500 mt-2">选择模版后，系统会生成该模版对应的页面 URL。</div>
                </div>
                <button type="button" onclick="navigate('/ops/template-library?selectFor=landing')" class="px-3 py-2 text-sm rounded-lg border border-brand-200 bg-brand-50 text-brand-700 hover:bg-brand-100 whitespace-nowrap">去模版库选择</button>
              </div>
              <div class="rounded-lg bg-brand-50 border border-brand-100 px-3 py-2.5 flex items-center justify-between gap-3">
                <div class="min-w-0">
                  <div class="text-xs font-medium text-ink-900 truncate">${selectedTemplate ? `已选择：${selectedTemplate.name}` : "尚未选择落地页模版"}</div>
                  <div class="text-[11px] text-ink-400 font-mono truncate mt-1">${selectedTemplateUrl || "从模版库选择后自动生成 URL"}</div>
                </div>
                ${selectedTemplateUrl ? `<button type="button" onclick="applyLandingPageUrlValue('${selectedTemplateUrl}')" class="px-3 py-2 text-sm rounded-lg bg-brand-900 text-white hover:bg-brand-800 flex-shrink-0">使用 URL</button>` : ""}
              </div>
            </div>
          ` : `
            <div class="space-y-3">
              <div class="flex items-start justify-between gap-4">
                <div class="flex items-center gap-2">
                  <span class="w-6 h-6 rounded-full bg-purple-700 text-white text-[11px] font-semibold flex items-center justify-center">1</span>
                  <div>
                    <div class="text-sm font-semibold text-ink-900">校验游戏方已有 URL</div>
                    <div class="text-xs text-ink-500 mt-0.5">校验通过后，URL 会自动回填到「页面 URL 保存」区。</div>
                  </div>
                </div>
                <button type="button" onclick="validateExistingLandingUrl()" class="px-3 py-2 text-sm rounded-lg bg-purple-700 text-white hover:bg-purple-800 whitespace-nowrap">校验 URL</button>
              </div>
              <label class="block">
                <span class="block text-sm font-medium text-ink-700 mb-1.5">游戏方已有 URL</span>
                <input id="existing-landing-url-input" type="url" placeholder="https://example.com/landing-page" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm font-mono" />
              </label>
            </div>
          `}
        </div>
      </div>
    </section>

    <section class="card overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">3. 页面 URL 保存</h3>
          <p class="text-xs text-ink-500 mt-0.5">确认最终页面 URL 后保存为落地页资产。</p>
        </div>
        <span class="badge bg-brand-50 text-brand-700">最终确认</span>
      </div>
      <div class="p-5 grid grid-cols-12 gap-3 items-end">
        <label class="col-span-12 md:col-span-10 block">
          <span class="block text-sm font-medium text-ink-700 mb-1.5">页面 URL</span>
          <input id="landing-page-url-input" type="url" placeholder="校验或选择后自动填入页面 URL" value="${selectedTemplateUrl}" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm font-mono" />
        </label>
        <button onclick="confirmAction('保存落地页', '确认保存该落地页资产吗？后续可在分享活动配置中引用。', '确认保存', '落地页已保存')" class="col-span-12 md:col-span-2 px-4 py-2.5 bg-brand-900 text-white text-sm rounded-lg hover:bg-brand-800">保存落地页</button>
      </div>
    </section>

    <div class="card p-4 mt-5 bg-amber-50 border-amber-200">
      <div class="flex items-start gap-3">
        <div class="w-8 h-8 rounded-lg bg-white border border-amber-200 flex items-center justify-center">${Icon.info({ size: 15, color: "#B45309" })}</div>
        <div>
          <div class="text-sm font-semibold text-amber-900">统一资产逻辑</div>
          <div class="text-xs text-amber-800 leading-relaxed mt-1">无论 URL 来源是哪一种，最终只保存为一条落地页资产。落地页本身不绑定活动，后续在「分享活动配置」中与分享卡片组合，并绑定到目标包体。</div>
        </div>
      </div>
    </div>
  `;
};

window.applyLandingPageUrlValue = function (url) {
  const target = document.getElementById("landing-page-url-input");
  if (!target || !url) return;
  target.value = url;
  UI.toast("页面 URL 已填入", "success");
};

window.validateExistingLandingUrl = function () {
  const input = document.getElementById("existing-landing-url-input");
  const url = (input?.value || "").trim();
  if (!url) {
    UI.toast("请先输入游戏方已有 URL", "warning");
    return;
  }
  if (!/^https:\/\//i.test(url)) {
    UI.toast("请使用 HTTPS URL", "warning");
    return;
  }
  applyLandingPageUrlValue(url);
  UI.toast("URL 校验通过", "success");
};

function landingPageIdForLandingPage(landingPage) {
  const suffix = String(landingPage?.id || "unknown").replace(/^lp_/, "");
  return `${landingPage?.source_type === "url" ? "lp_url" : "lp_tpl"}_${suffix}`;
}

function cardIdForConfig(cfg) {
  return `card_${configId(cfg).replace(/^cfg_/, "")}`;
}

function getLinkedShareConfigsForLandingPage(landingPageId) {
  return (MOCK.SHARE_CONFIGS || []).filter((cfg) => (cfg.landing_page_ids || [cfg.landing_page_id]).filter(Boolean).includes(landingPageId));
}

function configuredAssetTime(value) {
  const time = Date.parse(String(value || "").replace(" ", "T"));
  return Number.isNaN(time) ? 0 : time;
}

function getSortedConfiguredLandingPages() {
  return [...(MOCK.LANDING_PAGES || [])].sort((a, b) => configuredAssetTime(b.updated_at || b.created_at) - configuredAssetTime(a.updated_at || a.created_at));
}

// 按"创建时间从新到旧"排序：以 created_at 为主键；缺失时回退 updated_at（保持稳定的降序）
function getLandingPagesByCreatedDesc() {
  return [...(MOCK.LANDING_PAGES || [])].sort((a, b) => configuredAssetTime(b.created_at || b.updated_at) - configuredAssetTime(a.created_at || a.updated_at));
}

function getConfiguredLandingSearchText(landingPage, linkedConfigs, sourceText) {
  return [
    landingPage.name,
    landingPage.title,
    landingPage.audience_rule,
    sourceText,
    landingPage.url,
    landingPage.status,
    ...linkedConfigs.map((cfg) => configId(cfg)),
  ].filter(Boolean).join(" ").toLowerCase();
}

function getConfiguredCardSearchText(cfg, landingPages, targetPackages) {
  return [
    cfg.name,
    cfg.title,
    cfg.status,
    cfg.scope,
    ...(cfg.channels || []),
    ...landingPages.flatMap((p) => [p.name, p.title, p.audience_rule, p.temple_id, p.url]),
    ...targetPackages.map((p) => packageSearchText(p)),
  ].filter(Boolean).join(" ").toLowerCase();
}

window.filterConfiguredAssets = function (type) {
  const keyword = (document.getElementById(`${type}-keyword-filter`)?.value || "").trim().toLowerCase();
  const idKeyword = (document.getElementById(`${type}-id-filter`)?.value || "").trim().toLowerCase();
  const status = document.getElementById(`${type}-status-filter`)?.value || "all";
  const category = document.getElementById(`${type}-category-filter`)?.value || "all";
  const rows = document.querySelectorAll(`[data-configured-asset='${type}']`);
  // 卡片管理支持「卡片 / 列表」双视图，计数仅统计当前视图，避免重复
  const activeView = type === "card" ? (window.__cardListView || "grid") : null;
  let visible = 0;
  rows.forEach((row) => {
    const matchedKeyword = !keyword || row.dataset.search.includes(keyword);
    const matchedId = !idKeyword || row.dataset.ids.includes(idKeyword);
    const matchedStatus = status === "all" || row.dataset.status === status;
    const matchedCategory = category === "all" || (type === "landing" ? row.dataset.source === category : row.dataset.channels.includes(category));
    const matched = matchedKeyword && matchedId && matchedStatus && matchedCategory;
    row.classList.toggle("hidden", !matched);
    if (matched && (!activeView || row.dataset.view === activeView)) visible += 1;
  });
  const count = document.getElementById(`${type}-filtered-count`);
  if (count) count.textContent = String(visible);
};

// 已配置卡片：切换「卡片视图 / 列表视图」
window.toggleCardListView = function (view) {
  if (view !== "grid" && view !== "table") return;
  window.__cardListView = view;
  const grid = document.getElementById("card-gallery-grid");
  const table = document.getElementById("card-list-table");
  const emptyGrid = document.getElementById("card-gallery-empty");
  if (grid) grid.classList.toggle("hidden", view !== "grid");
  if (emptyGrid) emptyGrid.classList.toggle("hidden", view !== "grid");
  if (table) table.classList.toggle("hidden", view !== "table");
  // 同步按钮态
  document.querySelectorAll("[data-card-view-btn]").forEach((btn) => {
    const active = btn.dataset.cardViewBtn === view;
    btn.classList.toggle("bg-brand-900", active);
    btn.classList.toggle("text-white", active);
    btn.classList.toggle("border-brand-900", active);
    btn.classList.toggle("text-ink-600", !active);
    btn.classList.toggle("border-ink-100", !active);
    btn.classList.toggle("bg-white", !active);
  });
  // 重新计算可见数量
  filterConfiguredAssets("card");
};

function renderConfiguredLandingRow(landingPage) {
  const linkedConfigs = getLinkedShareConfigsForLandingPage(landingPage.id);
  const linkedCards = linkedConfigs.map((cfg) => cardIdForConfig(cfg));
  const temple = getTemple(landingPage.temple_id);
  const landingId = landingPageIdForLandingPage(landingPage);
  const isUrlSource = landingPage.source_type === "url" || landingPage.content_type === "url";
  const sourceText = isUrlSource
    ? landingPage.url || landingPage.title || "外部 URL"
    : `${landingPage.temple_id || "—"} · ${temple?.name || "模版生成"}`;
  const idText = [landingId, landingPage.id, landingPage.temple_id, ...linkedCards, ...linkedConfigs.map((cfg) => configId(cfg))].filter(Boolean).join(" ").toLowerCase();
  const searchText = getConfiguredLandingSearchText(landingPage, linkedConfigs, sourceText);
  return `
    <tr class="border-t border-ink-100 row-hover align-top" data-configured-asset="landing" data-search="${escapeShareCardValue(searchText)}" data-ids="${escapeShareCardValue(idText)}" data-status="${escapeShareCardValue(landingPage.status || "")}" data-source="${isUrlSource ? "url" : "temple"}">
      <td class="px-4 py-3 min-w-[250px]">
        <div class="font-medium text-ink-900">${landingPage.name}</div>
        <div class="mt-1 text-xs text-ink-500">${isUrlSource ? "外部 URL 注册" : "模板生成"}</div>
      </td>
      <td class="px-4 py-3 min-w-[220px]">
        ${landingPageSourceLabel(landingPage)}
        <div class="mt-2 text-xs text-ink-500 font-mono truncate max-w-[260px]" title="${sourceText}">${sourceText}</div>
      </td>
      <td class="px-4 py-3 min-w-[220px]">
        <div class="text-xs text-ink-700 line-clamp-2">${landingPage.title || "未配置标题"}</div>
        <div class="mt-1 text-[11px] text-ink-400">${landingPage.audience_rule || "默认被分享者规则"}</div>
      </td>
      <td class="px-4 py-3 min-w-[180px]">
        <div class="flex flex-wrap gap-1">
          ${linkedCards.length ? `<span class="text-xs text-ink-700">已关联 ${linkedCards.length} 张卡片</span>` : `<span class="text-xs text-ink-400">暂未被卡片引用</span>`}
        </div>
      </td>
      <td class="px-4 py-3 min-w-[160px]">${renderConfigIdChips(linkedConfigs)}</td>
      <td class="px-4 py-3">${UI.statusBadge(landingPage.status)}</td>
      <td class="px-4 py-3 text-xs text-ink-500 whitespace-nowrap">${landingPage.updated_at || landingPage.created_at || "—"}</td>
      <td class="px-4 py-3 text-right whitespace-nowrap">
        <button onclick="navigate('/ops/configured-landing-pages/${encodeURIComponent(landingPage.id)}')" class="text-xs text-brand-600 hover:underline mr-2">编辑</button>
        <button onclick="UI.toast('已复制落地页编号', 'success')" class="text-xs text-ink-500 hover:text-brand-700">复制编号</button>
      </td>
    </tr>
  `;
}

function renderConfiguredCardLandingCombos(cardId, landingPages) {
  if (!landingPages.length) return `<span class="text-xs text-ink-400">暂未关联落地页</span>`;
  return `
    <div class="space-y-1">
      ${landingPages.slice(0, 3).map((p) => `<div class="text-[11px] text-ink-600"><code class="font-mono text-brand-700">${cardId}</code><span class="mx-1 text-ink-300">+</span><code class="font-mono text-purple-700">${landingPageIdForLandingPage(p)}</code></div>`).join("")}
      ${landingPages.length > 3 ? `<div class="text-[11px] text-ink-400">+${landingPages.length - 3} 组组合</div>` : ""}
    </div>
  `;
}

function renderPackageConfigAssetSummary(cfg) {
  const landingPages = getLandingPagesForConfig(cfg);
  if (!landingPages.length) return `<span class="text-xs text-ink-400">暂未关联落地页</span>`;
  return `
    <div class="space-y-1">
      ${landingPages.slice(0, 3).map((p) => `<div class="text-[11px] text-ink-600 truncate">${cfg.title || cfg.name} + ${p.name || p.title || "落地页"}</div>`).join("")}
      ${landingPages.length > 3 ? `<div class="text-[11px] text-ink-400">+${landingPages.length - 3} 组组合</div>` : ""}
    </div>
  `;
}

function renderPackageLandingCards(landingPages) {
  if (!landingPages.length) return `<div class="text-xs text-ink-400">暂无落地页</div>`;
  return landingPages.map((p) => `
    <div class="rounded-xl border border-ink-100 bg-white p-3">
      <div class="flex items-start justify-between gap-2">
        <div class="min-w-0">
          <div class="text-sm font-semibold text-ink-900 truncate">${p.name || p.title || "落地页"}</div>
          <div class="text-xs text-ink-500 mt-1 truncate">${p.audience_rule || "默认用户"}</div>
        </div>
        ${landingPageSourceLabel(p)}
      </div>
    </div>
  `).join("");
}

function renderConfiguredCardRow(cfg) {
  const landingPages = getLandingPagesForConfig(cfg);
  const targetPackages = getOpsVisiblePackages().filter((p) => cfg.package_ids.includes(p.id));
  const cardId = cardIdForConfig(cfg);
  const landingIds = landingPages.map((p) => landingPageIdForLandingPage(p));
  const idText = [cardId, configId(cfg), ...landingIds, ...(cfg.landing_page_ids || [cfg.landing_page_id]).filter(Boolean), cfg.temple_id].filter(Boolean).join(" ").toLowerCase();
  const searchText = getConfiguredCardSearchText(cfg, landingPages, targetPackages);
  return `
    <tr class="border-t border-ink-100 row-hover align-top" data-configured-asset="card" data-view="table" data-search="${escapeShareCardValue(searchText)}" data-ids="${escapeShareCardValue(idText)}" data-status="${escapeShareCardValue(cfg.status || "")}" data-channels="${escapeShareCardValue((cfg.channels || []).join(" ").toLowerCase())}">
      <td class="px-4 py-3 min-w-[250px]">
        <div class="font-medium text-ink-900">${cfg.name}</div>
        <div class="mt-1 text-xs text-ink-500">${cfg.scope === "package_set" ? "活动级卡片" : "包体级卡片"}</div>
      </td>
      <td class="px-4 py-3 min-w-[220px]">
        <div class="text-xs text-ink-700 line-clamp-2">${cfg.title || landingPages[0]?.title || "分享卡片标题"}</div>
        <div class="mt-2">${renderLandingPageIdChips(cfg)}</div>
      </td>
      <td class="px-4 py-3 min-w-[150px]">${renderChannelIcons(cfg.channels)}</td>
      <td class="px-4 py-3 min-w-[220px]">
        <div class="flex flex-wrap gap-1">
          <span class="badge bg-emerald-50 text-emerald-700">WhatsApp 1:1</span>
          <span class="badge bg-brand-50 text-brand-700">Discord PC 4:3</span>
          <span class="badge bg-purple-50 text-purple-700">Discord 移动 3:4</span>
        </div>
      </td>
      <td class="px-4 py-3 min-w-[240px]">
        ${renderConfiguredCardLandingCombos(cardId, landingPages)}
        <div class="mt-2 text-[11px] text-ink-400">适用 ${targetPackages.length} 个包体${cfg.scope === "package_set" ? " · 方案级" : " · 包体级"}</div>
      </td>
      <td class="px-4 py-3">${UI.statusBadge(cfg.status)}</td>
      <td class="px-4 py-3 text-xs text-ink-500 whitespace-nowrap">${cfg.updated || "—"}</td>
      <td class="px-4 py-3 text-right whitespace-nowrap">
        <button onclick="navigate('/ops/configured-cards/${encodeURIComponent(cardId)}')" class="text-xs text-brand-600 hover:underline mr-2">编辑卡片</button>
        <button onclick="UI.toast('已复制卡片编号', 'success')" class="text-xs text-ink-500 hover:text-brand-700">复制编号</button>
      </td>
    </tr>
  `;
}

// ---------- 已配置卡片：卡片网格视图 ----------
function configuredCardGalleryGradient(cfg) {
  // 用卡片编号哈希到固定渐变，避免每次渲染漂移
  const palettes = [
    "from-brand-100 via-brand-50 to-white",
    "from-purple-100 via-purple-50 to-white",
    "from-emerald-100 via-emerald-50 to-white",
    "from-amber-100 via-amber-50 to-white",
    "from-blue-100 via-blue-50 to-white",
    "from-pink-100 via-pink-50 to-white",
  ];
  const key = cardIdForConfig(cfg) || cfg.id || "x";
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  return palettes[h % palettes.length];
}

function configuredCardGalleryEmoji(cfg, landingPages) {
  const temple = getTemple(cfg.temple_id || landingPages[0]?.temple_id);
  if (temple?.icon) return temple.icon;
  const firstChannel = (cfg.channels || []).map((code) => MOCK.CHANNELS.find((c) => c.code === code)).filter(Boolean)[0];
  return firstChannel?.icon || "🃏";
}

// 把 tailwind "from-xxx-400 to-yyy-500" 映射到 SVG 用的两个十六进制颜色
function templeGradientToHex(colorClass) {
  const STOPS = {
    "amber-400": "#fbbf24", "orange-500": "#f97316",
    "pink-400": "#f472b6", "rose-500": "#f43f5e",
    "emerald-400": "#34d399", "teal-500": "#14b8a6",
    "yellow-400": "#facc15", "amber-500": "#f59e0b",
    "purple-400": "#c084fc", "indigo-500": "#6366f1",
    "blue-400": "#60a5fa", "blue-500": "#3b82f6",
    "sky-400": "#38bdf8", "cyan-500": "#06b6d4",
  };
  const m = String(colorClass || "").match(/from-([a-z]+-\d{3})\s+to-([a-z]+-\d{3})/);
  const c1 = (m && STOPS[m[1]]) || "#6366f1";
  const c2 = (m && STOPS[m[2]]) || "#a855f7";
  return [c1, c2];
}

// 基于模板配色 + emoji + 卡片标题文字，构造一张 SVG 封面图（dataURL）
function buildCardCoverDataUrl(cfg, landingPages) {
  const temple = getTemple(cfg.temple_id || landingPages?.[0]?.temple_id);
  const emoji = configuredCardGalleryEmoji(cfg, landingPages || []);
  const [c1, c2] = templeGradientToHex(temple?.color);
  const title = (cfg.title || landingPages?.[0]?.title || cfg.name || "").slice(0, 28);
  const safeTitle = String(title).replace(/[<>&]/g, (ch) => ({ "<": "&lt;", ">": "&gt;", "&": "&amp;" }[ch]));
  const id = String(cfg.id || "x").replace(/[^a-z0-9]/gi, "");
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'>`
    + `<defs>`
    + `<linearGradient id='g${id}' x1='0' y1='0' x2='1' y2='1'>`
    + `<stop offset='0%' stop-color='${c1}'/><stop offset='100%' stop-color='${c2}'/>`
    + `</linearGradient>`
    + `<radialGradient id='r${id}' cx='30%' cy='25%' r='65%'>`
    + `<stop offset='0%' stop-color='#ffffff' stop-opacity='0.55'/>`
    + `<stop offset='100%' stop-color='#ffffff' stop-opacity='0'/>`
    + `</radialGradient>`
    + `</defs>`
    + `<rect width='200' height='200' fill='url(#g${id})'/>`
    + `<rect width='200' height='200' fill='url(#r${id})'/>`
    + `<circle cx='168' cy='28' r='40' fill='#ffffff' fill-opacity='0.18'/>`
    + `<circle cx='32' cy='180' r='30' fill='#000000' fill-opacity='0.10'/>`
    + `<text x='100' y='118' font-size='86' text-anchor='middle' dominant-baseline='middle' font-family='Apple Color Emoji, Segoe UI Emoji, Noto Color Emoji, sans-serif'>${emoji}</text>`
    + `<text x='100' y='178' font-size='13' fill='#ffffff' fill-opacity='0.92' text-anchor='middle' font-family='-apple-system, Segoe UI, sans-serif' font-weight='600'>${safeTitle}</text>`
    + `</svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

function renderConfiguredCardTile(cfg) {
  const landingPages = getLandingPagesForConfig(cfg);
  const targetPackages = getOpsVisiblePackages().filter((p) => cfg.package_ids.includes(p.id));
  const cardId = cardIdForConfig(cfg);
  const cfgId = configId(cfg);
  const landingIds = landingPages.map((p) => landingPageIdForLandingPage(p));
  const idText = [cardId, cfgId, ...landingIds, ...(cfg.landing_page_ids || [cfg.landing_page_id]).filter(Boolean), cfg.temple_id].filter(Boolean).join(" ").toLowerCase();
  const searchText = getConfiguredCardSearchText(cfg, landingPages, targetPackages);
  const gradient = configuredCardGalleryGradient(cfg);
  const emoji = configuredCardGalleryEmoji(cfg, landingPages);
  // 优先使用创建卡片时上传的 og:image 标准图作为封面，便于一眼分辨；缺失时回退到渐变 + emoji 占位图
  const uploadedImage = cfg.image_data_url || cfg.image_url || cfg.imageUrl || "";
  const hasUploadedImage = !!uploadedImage;
  const cardTitle = cfg.title || landingPages[0]?.title || "分享卡片标题";
  const channelIconsHTML = renderChannelIcons(cfg.channels);

  return `
    <div class="group card overflow-hidden flex flex-col hover:shadow-soft hover:-translate-y-0.5 transition cursor-pointer"
         data-configured-asset="card"
         data-view="grid"
         data-search="${escapeShareCardValue(searchText)}"
         data-ids="${escapeShareCardValue(idText)}"
         data-status="${escapeShareCardValue(cfg.status || "")}"
         data-channels="${escapeShareCardValue((cfg.channels || []).join(" ").toLowerCase())}"
         onclick="navigate('/ops/configured-cards/${encodeURIComponent(cardId)}')">
      <!-- 缩略图 / 预览区（优先使用创建卡片时上传的 og 标准图） -->
      <div class="relative h-32 ${hasUploadedImage ? "bg-white" : `bg-gradient-to-br ${gradient}`} border-b border-ink-100">
        ${hasUploadedImage
          ? `<img src="${escapeShareCardValue(uploadedImage)}" alt="${escapeShareCardValue(cfg.name)}" class="absolute inset-0 w-full h-full object-contain p-2 select-none" draggable="false" />`
          : `<div class="absolute inset-0 flex items-center justify-center text-5xl select-none drop-shadow-sm">${emoji}</div>`}
        <div class="absolute top-1.5 left-1.5 flex items-center gap-1">
          <code class="px-1 py-0.5 rounded bg-white/85 border border-brand-100 text-[9px] font-mono text-brand-700 backdrop-blur">${cardId}</code>
        </div>
        <div class="absolute top-1.5 right-1.5">${UI.statusBadge(cfg.status)}</div>
        <div class="absolute bottom-1.5 left-1.5 right-1.5 flex items-center justify-between gap-1">
          <div class="flex items-center gap-0.5 px-1.5 py-0.5 rounded-full bg-white/85 border border-ink-100 backdrop-blur min-w-0 overflow-hidden">${channelIconsHTML}</div>
          <span class="shrink-0 px-1.5 py-0.5 rounded-full bg-white/85 border border-ink-100 text-[9px] text-ink-600 backdrop-blur">${(cfg.channels || []).length} 渠道</span>
        </div>
      </div>

      <!-- 信息区 -->
      <div class="px-3 py-2.5 flex-1 flex flex-col">
        <div class="text-[13px] font-semibold text-ink-900 truncate" title="${escapeShareCardValue(cfg.name)}">${cfg.name}</div>
        <div class="mt-1 text-[11px] text-ink-500 line-clamp-2 leading-snug" title="${escapeShareCardValue(cardTitle)}">${cardTitle}</div>
      </div>

      <!-- 底部操作 -->
      <div class="px-3 py-2 border-t border-ink-100 flex items-center justify-between bg-ink-50/40">
        <div class="text-[10px] text-ink-400 truncate">更新 ${cfg.updated || "—"}</div>
        <div class="flex items-center gap-1.5 shrink-0" onclick="event.stopPropagation()">
          <button onclick="navigate('/ops/configured-cards/${encodeURIComponent(cardId)}')" class="px-2 py-0.5 rounded-md text-[10px] bg-brand-900 text-white hover:bg-brand-800">详情</button>
        </div>
      </div>
    </div>
  `;
}

Pages.configuredLandingPages = function () {
  const landingPages = getSortedConfiguredLandingPages();
  const urlLandingPages = landingPages.filter((p) => p.source_type === "url" || p.content_type === "url");
  const templeLandingPages = landingPages.filter((p) => !(p.source_type === "url" || p.content_type === "url"));
  const releasedCount = landingPages.filter((p) => p.status === "released").length;
  const linkedConfigCount = new Set(landingPages.flatMap((p) => getLinkedShareConfigsForLandingPage(p.id).map((cfg) => configId(cfg)))).size;
  return `
    ${UI.pageHeader({
      title: "已配置落地页管理",
      desc: "集中查看已生成或已注册的落地页资产，包括模版生成页和外部 URL 注册页，支持追踪使用关系。",
      actions: `
        <button onclick="navigate('/ops/share-landing-config')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">+ 新增落地页</button>
        <button onclick="UI.toast('开始导出落地页清单', 'info')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">导出</button>
      `,
    })}
    ${renderOpsModuleTabs("landing_manage")}
    ${renderOpsWorkflowHint("landing")}

    <div class="grid grid-cols-4 gap-4 mb-5">
      ${UI.statCard({ label: "落地页资产", value: landingPages.length, delta: 0, icon: "globe", color: "brand" })}
      ${UI.statCard({ label: "模版生成", value: templeLandingPages.length, delta: 0, icon: "layers", color: "blue" })}
      ${UI.statCard({ label: "外部 URL 注册", value: urlLandingPages.length, delta: 0, icon: "link", color: "amber" })}
      ${UI.statCard({ label: "已发布", value: releasedCount, delta: 0, icon: "check", color: "green" })}
    </div>

    <div class="card p-4 mb-4 flex items-center gap-3 flex-wrap">
      <select id="landing-category-filter" oninput="filterConfiguredAssets('landing')" class="text-sm border border-ink-100 rounded-lg px-2.5 py-2 bg-white">
        <option value="all">全部来源</option>
        <option value="temple">模版 生成</option>
        <option value="url">外部 URL 注册</option>
      </select>
      <select id="landing-status-filter" oninput="filterConfiguredAssets('landing')" class="text-sm border border-ink-100 rounded-lg px-2.5 py-2 bg-white">
        <option value="all">全部状态</option>
        <option value="released">已发布</option>
        <option value="draft">草稿</option>
      </select>
      <input id="landing-keyword-filter" oninput="filterConfiguredAssets('landing')" class="w-72 text-xs border border-ink-100 rounded-lg px-3 py-2" placeholder="按关键字筛选：名称 / URL / 标题 / 规则" />
      <input id="landing-id-filter" oninput="filterConfiguredAssets('landing')" class="w-64 text-xs border border-ink-100 rounded-lg px-3 py-2" placeholder="高级筛选：编号 / 关联配置" />
      <div class="flex-1"></div>
      <span class="text-xs text-ink-500">显示 <b id="landing-filtered-count" class="text-ink-800">${landingPages.length}</b> / ${landingPages.length} 条 · 已关联 ${linkedConfigCount} 个活动配置 · 新 → 旧</span>
    </div>

    <div class="card overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">落地页资产列表</h3>
          <p class="text-xs text-ink-500 mt-0.5">落地页资产可在分享活动配置中被引用；默认按更新时间从新到旧排列。</p>
        </div>
        <span class="badge bg-brand-50 text-brand-700">共 ${landingPages.length} 条</span>
      </div>
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-4 py-2.5 font-medium">落地页</th>
            <th class="text-left px-4 py-2.5 font-medium">来源</th>
            <th class="text-left px-4 py-2.5 font-medium">标题 / 规则</th>
            <th class="text-left px-4 py-2.5 font-medium">关联卡片</th>
            <th class="text-left px-4 py-2.5 font-medium">关联活动</th>
            <th class="text-left px-4 py-2.5 font-medium">状态</th>
            <th class="text-left px-4 py-2.5 font-medium">更新时间</th>
            <th class="text-right px-4 py-2.5 font-medium">操作</th>
          </tr>
        </thead>
        <tbody>${landingPages.map((p) => renderConfiguredLandingRow(p)).join("")}</tbody>
      </table>
    </div>
  `;
};

function renderLandingPageLinkedConfigTable(linkedConfigs) {
  if (!linkedConfigs.length) return `<div class="rounded-xl border border-dashed border-ink-200 bg-ink-50 p-6 text-center text-sm text-ink-400">暂无关联活动配置</div>`;
  return `
    <div class="overflow-hidden rounded-xl border border-ink-100">
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-4 py-2.5 font-medium">活动配置编号</th>
            <th class="text-left px-4 py-2.5 font-medium">配置名称</th>
            <th class="text-left px-4 py-2.5 font-medium">卡片编号</th>
            <th class="text-left px-4 py-2.5 font-medium">状态</th>
            <th class="text-left px-4 py-2.5 font-medium">更新时间</th>
          </tr>
        </thead>
        <tbody>
          ${linkedConfigs.map((cfg) => `
            <tr class="border-t border-ink-100 row-hover">
              <td class="px-4 py-3"><code class="font-mono text-xs text-ink-700">${configId(cfg)}</code></td>
              <td class="px-4 py-3 text-ink-800">${cfg.name}</td>
              <td class="px-4 py-3"><code class="font-mono text-xs text-brand-700">${cardIdForConfig(cfg)}</code></td>
              <td class="px-4 py-3">${UI.statusBadge(cfg.status)}</td>
              <td class="px-4 py-3 text-xs text-ink-500">${cfg.updated || "—"}</td>
            </tr>
          `).join("")}
        </tbody>
      </table>
    </div>
  `;
}

function renderLandingPageMobilePreview(landingPage, sourceText) {
  const title = landingPage.title || landingPage.name || "落地页 Title";
  const subtitle = landingPage.audience_rule || "默认访问规则";
  const url = landingPage.url || `https://landing.easyshare.demo/${landingPageIdForLandingPage(landingPage)}`;
  return `
    <div class="mx-auto w-[280px] rounded-[28px] border border-ink-200 bg-ink-900 p-3 shadow-soft">
      <div class="mb-2 flex items-center justify-center gap-1">
        <span class="h-1.5 w-1.5 rounded-full bg-ink-500"></span>
        <span class="h-1.5 w-10 rounded-full bg-ink-700"></span>
      </div>
      <div class="overflow-hidden rounded-[20px] bg-white">
        <div class="bg-brand-900 px-4 py-3 text-white">
          <div class="text-[10px] uppercase opacity-70">EasyShare Landing</div>
          <div class="mt-1 text-base font-semibold leading-snug">${escapeShareCardValue(title)}</div>
        </div>
        <div class="p-4">
          <div class="flex h-28 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-50 to-purple-50 text-4xl">🎁</div>
          <div class="mt-4 text-sm font-semibold text-ink-900">${escapeShareCardValue(landingPage.name)}</div>
          <div class="mt-1 text-xs leading-relaxed text-ink-500">${escapeShareCardValue(subtitle)}</div>
          <div class="mt-3 rounded-lg bg-ink-50 px-2 py-1.5 text-[10px] font-mono text-ink-500 truncate">${escapeShareCardValue(url)}</div>
          <button class="mt-4 w-full rounded-xl bg-brand-900 py-2 text-xs font-semibold text-white">立即查看</button>
        </div>
      </div>
      <div class="mt-2 text-center text-[10px] text-white/40 truncate">${escapeShareCardValue(sourceText)}</div>
    </div>
  `;
}

Pages.configuredLandingPageDetail = function (landingPageKey) {
  const key = decodeURIComponent(landingPageKey || "");
  const landingPage = (MOCK.LANDING_PAGES || []).find((item) => item.id === key || landingPageIdForLandingPage(item) === key);
  if (!landingPage) {
    return UI.emptyState({ icon: "🌐", title: "落地页不存在", desc: `未找到 <code class="px-1 bg-ink-100 rounded text-xs">${escapeShareCardValue(key)}</code>`, action: `<button onclick="navigate('/ops/configured-landing-pages')" class="px-4 py-2 bg-brand-900 text-white rounded-lg text-sm">返回落地页管理</button>` });
  }
  const landingId = landingPageIdForLandingPage(landingPage);
  const linkedConfigs = getLinkedShareConfigsForLandingPage(landingPage.id);
  const linkedCards = linkedConfigs.map((cfg) => cardIdForConfig(cfg));
  const temple = getTemple(landingPage.temple_id);
  const isUrlSource = landingPage.source_type === "url" || landingPage.content_type === "url";
  const isReleased = landingPage.status === "released";
  const sourceText = isUrlSource ? (landingPage.url || landingPage.title || "外部 URL") : `${landingPage.temple_id || "—"} · ${temple?.name || "模版生成"}`;
  return `
    ${UI.pageHeader({
      title: "落地页详情",
      desc: "查看和编辑历史已配置的 落地页 资产，并确认其关联的 卡片编号 / 活动配置编号。",
      actions: `
        <button onclick="navigate('/ops/configured-landing-pages')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回列表</button>
        ${!isUrlSource && landingPage.temple_id ? `<button onclick="openTempleEditorFromLanding('${escapeShareCardValue(landingPage.temple_id)}', '${escapeShareCardValue(landingPage.id)}')" class="px-3 py-1.5 text-sm border border-brand-200 text-brand-700 bg-brand-50 rounded-lg hover:bg-brand-100">编辑来源 模版</button>` : ""}
        ${!isReleased ? `<button onclick="publishLandingPage('${landingPage.id}')" class="px-4 py-1.5 text-sm bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 shadow-soft">发布 落地页</button>` : ""}
        <button onclick="UI.toast('落地页 已保存', 'success')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">保存修改</button>
      `,
    })}

    <div class="grid grid-cols-4 gap-4 mb-5">
      ${UI.statCard({ label: "落地页编号", value: landingId, delta: 0, icon: "globe", color: "brand" })}
      ${UI.statCard({ label: "来源", value: isUrlSource ? "URL" : "模版", delta: 0, icon: "link", color: isUrlSource ? "amber" : "blue" })}
      ${UI.statCard({ label: "关联卡片", value: linkedCards.length, delta: 0, icon: "image", color: "green" })}
      ${UI.statCard({ label: "关联活动", value: linkedConfigs.length, delta: 0, icon: "database", color: "amber" })}
    </div>

    <div class="grid grid-cols-12 gap-5 items-start">
      <div class="col-span-8 space-y-5">
        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
            <div>
              <h3 class="text-sm font-semibold text-ink-900">基础信息编辑</h3>
              <p class="text-xs text-ink-500 mt-0.5">编辑 落地页 的名称、标题、目标 URL 与访问规则。</p>
            </div>
            ${UI.statusBadge(landingPage.status)}
          </div>
          <div class="p-5 grid grid-cols-2 gap-4">
            <label class="block col-span-2">
              <span class="block text-xs font-medium text-ink-500 mb-1">落地页编号</span>
              <input value="${escapeShareCardValue(landingId)}" readonly class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm font-mono bg-ink-50 text-ink-600" />
            </label>
            <label class="block col-span-2">
              <span class="block text-xs font-medium text-ink-500 mb-1">落地页名称</span>
              <input value="${escapeShareCardValue(landingPage.name)}" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm" />
            </label>
            <label class="block col-span-2">
              <span class="block text-xs font-medium text-ink-500 mb-1">页面标题</span>
              <input value="${escapeShareCardValue(landingPage.title || "")}" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm" />
            </label>
            <div class="block">
              <span class="flex items-center justify-between text-xs font-medium text-ink-500 mb-1">
                <span>来源类型</span>
                <span class="badge bg-ink-100 text-ink-600">不可修改</span>
              </span>
              <div class="rounded-lg border border-ink-200 bg-ink-50 px-3 py-2.5 text-sm text-ink-700">${isUrlSource ? "外部 URL 注册" : "模版生成"}</div>
            </div>
            <div class="block">
              <span class="block text-xs font-medium text-ink-500 mb-1">发布状态</span>
              ${isReleased
                ? `<div class="rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2.5">
                    <div class="flex items-center justify-between gap-3">
                      <span class="badge bg-emerald-100 text-emerald-700">已发布</span>
                      <span class="text-[11px] text-emerald-700">持续保持发布状态</span>
                    </div>
                    <p class="mt-2 text-[11px] text-emerald-700">已发布的 落地页 不支持改回草稿状态。</p>
                  </div>`
                : `<div class="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5">
                    <div class="flex items-center justify-between gap-3">
                      <span class="badge bg-amber-100 text-amber-700">草稿</span>
                      <button type="button" onclick="publishLandingPage('${landingPage.id}')" class="px-4 py-2 rounded-lg bg-emerald-600 text-xs font-semibold text-white hover:bg-emerald-700 shadow-soft">发布 落地页</button>
                    </div>
                    <p class="mt-2 text-[11px] text-amber-700">点击发布后将进入已发布状态，且不能再改回草稿。</p>
                  </div>`}
            </div>
            <div class="block col-span-2">
              <span class="block text-xs font-medium text-ink-500 mb-1">目标 URL / 来源</span>
              <div class="rounded-lg border border-ink-200 bg-ink-50 px-3 py-2.5 text-sm font-mono text-ink-700 break-all">${escapeShareCardValue(isUrlSource ? (landingPage.url || "") : (landingPage.temple_id || ""))}</div>
              ${!isUrlSource && landingPage.temple_id
                ? `<div class="mt-2 flex items-center justify-between gap-3 rounded-lg border border-brand-100 bg-brand-50 px-3 py-2 text-[11px] text-brand-700">
                    <span>该 落地页 由 模版 <code class="font-mono">${escapeShareCardValue(landingPage.temple_id)}</code>${temple?.name ? `（${escapeShareCardValue(temple.name)}）` : ""} 生成。</span>
                    <button type="button" onclick="openTempleEditorFromLanding('${escapeShareCardValue(landingPage.temple_id)}', '${escapeShareCardValue(landingPage.id)}')" class="px-2.5 py-1 rounded-md bg-white border border-brand-200 text-brand-700 hover:bg-brand-100 font-medium">编辑来源 模版 →</button>
                  </div>`
                : `<p class="mt-1 text-[11px] text-ink-400">目标 URL / 来源在生成 落地页 时确定，不支持修改。</p>`}
            </div>
            <label class="block col-span-2">
              <span class="block text-xs font-medium text-ink-500 mb-1">访问 / 人群规则</span>
              <textarea rows="3" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm">${escapeShareCardValue(landingPage.audience_rule || "")}</textarea>
            </label>
          </div>
        </div>

        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100">
            <h3 class="text-sm font-semibold text-ink-900">关联配置</h3>
            <p class="text-xs text-ink-500 mt-0.5">该落地页可被多个卡片和活动配置复用。</p>
          </div>
          <div class="p-5">${renderLandingPageLinkedConfigTable(linkedConfigs)}</div>
        </div>
      </div>

      <div class="col-span-4 space-y-5">
        <div class="card p-5">
          <div class="mb-4 flex items-center justify-between">
            <div>
              <h3 class="text-sm font-semibold text-ink-900">移动端预览</h3>
              <p class="text-xs text-ink-500 mt-0.5">用于检查落地页首屏标题与跳转目标。</p>
            </div>
            ${landingPageSourceLabel(landingPage)}
          </div>
          ${renderLandingPageMobilePreview(landingPage, sourceText)}
        </div>

        <div class="card p-5">
          <h3 class="text-sm font-semibold text-ink-900">关联卡片</h3>
          <div class="mt-3 flex flex-wrap gap-1">
            ${linkedCards.length ? linkedCards.map((id) => `<code class="px-1.5 py-0.5 rounded bg-brand-50 border border-brand-100 text-[10px] font-mono text-brand-700">${id}</code>`).join("") : `<span class="text-xs text-ink-400">暂无关联卡片</span>`}
          </div>
          <div class="mt-4 rounded-lg bg-ink-50 px-3 py-2 text-xs text-ink-500 leading-relaxed">卡片与落地页可被不同活动组合复用。</div>
        </div>
      </div>
    </div>
  `;
};

window.publishLandingPage = async function (landingPageId) {
  const landingPage = (MOCK.LANDING_PAGES || []).find((item) => item.id === landingPageId);
  if (!landingPage) {
    UI.toast("落地页不存在", "error");
    return;
  }
  if (landingPage.status === "released") {
    UI.toast("该 落地页 已发布，状态保持已发布", "info");
    return;
  }
  try {
    await contentApi.publishLandingPage(landingPageId);
    await invalidateAndRefresh();
    UI.toast("落地页已发布", "success");
    renderRoute();
  } catch (err) {
    UI.toast(err?.message || "发布失败", "error");
  }
};

function getConfigByCardKey(cardKey) {
  const key = decodeURIComponent(cardKey || "");
  return (MOCK.SHARE_CONFIGS || []).find((cfg) => cfg.id === key || configId(cfg) === key || cardIdForConfig(cfg) === key);
}

function renderCardLandingTable(cfg) {
  const cardId = cardIdForConfig(cfg);
  const landingPages = getLandingPagesForConfig(cfg);
  if (!landingPages.length) return `<div class="rounded-xl border border-dashed border-ink-200 bg-ink-50 p-6 text-center text-sm text-ink-400">暂无关联落地页</div>`;
  return `
    <div class="overflow-hidden rounded-xl border border-ink-100">
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-4 py-2.5 font-medium">卡片编号</th>
            <th class="text-left px-4 py-2.5 font-medium">落地页编号</th>
            <th class="text-left px-4 py-2.5 font-medium">落地页名称</th>
            <th class="text-left px-4 py-2.5 font-medium">来源</th>
            <th class="text-left px-4 py-2.5 font-medium">规则</th>
          </tr>
        </thead>
        <tbody>
          ${landingPages.map((landingPage) => `
            <tr class="border-t border-ink-100 row-hover">
              <td class="px-4 py-3"><code class="font-mono text-xs text-brand-700">${cardId}</code></td>
              <td class="px-4 py-3"><code class="font-mono text-xs text-purple-700">${landingPageIdForLandingPage(landingPage)}</code></td>
              <td class="px-4 py-3 text-ink-800">${landingPage.name}</td>
              <td class="px-4 py-3">${landingPageSourceLabel(landingPage)}</td>
              <td class="px-4 py-3 text-xs text-ink-500">${landingPage.audience_rule || "默认用户"}</td>
            </tr>
          `).join("")}
        </tbody>
      </table>
    </div>
  `;
}

function renderCardDetailPreview(cfg) {
  const title = cfg.title || "分享卡片标题";
  const site = getTemple(cfg.temple_id)?.name || "EasyShare";
  return `
    <div class="rounded-2xl border border-ink-200 bg-white shadow-soft overflow-hidden">
      <div class="h-40 bg-gradient-to-br from-brand-50 via-purple-50 to-emerald-50 flex items-center justify-center">
        <div class="text-center">
          <div class="text-5xl">🖼️</div>
          <div class="mt-2 text-xs font-mono text-ink-400">卡片 Preview</div>
        </div>
      </div>
      <div class="p-4">
        <div class="text-[10px] text-ink-400 uppercase truncate">${escapeShareCardValue(site)}</div>
        <div class="mt-1 text-sm font-semibold text-ink-900 line-clamp-2">${escapeShareCardValue(title)}</div>
        <div class="mt-2 text-xs leading-relaxed text-ink-500">该卡片可在多个 活动配置编号 中与不同 落地页编号 组合使用。</div>
        <div class="mt-3 flex flex-wrap gap-1">${renderChannelIcons(cfg.channels || [])}</div>
      </div>
    </div>
  `;
}

function renderCardConfigLandingPicker(cfg) {
  const selectedLandingIds = new Set(cfg?.landing_page_ids || (cfg?.landing_page_id ? [cfg.landing_page_id] : []));
  return (MOCK.LANDING_PAGES || []).map((landingPage) => {
    const checked = selectedLandingIds.has(landingPage.id);
    const displayId = landingPageIdForLandingPage(landingPage);
    const sourceText = landingPage.source_type === "url" || landingPage.content_type === "url"
      ? (landingPage.url || landingPage.title || "外部 URL")
      : (getTemple(landingPage.temple_id)?.name || landingPage.temple_id || "模版生成");
    return `
      <label class="block rounded-xl border ${checked ? "border-purple-200 bg-purple-50/60" : "border-ink-200 bg-white"} p-3 cursor-pointer hover:border-purple-300">
        <div class="flex items-start gap-3">
          <input type="checkbox" name="card-config-landing" value="${escapeShareCardValue(landingPage.id)}" class="mt-1" ${checked ? "checked" : ""} />
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-2 flex-wrap">
              <span class="text-sm font-semibold text-ink-900">${escapeShareCardValue(landingPage.name)}</span>
              ${landingPageSourceLabel(landingPage)}
            </div>
            <div class="mt-1 font-mono text-[11px] text-purple-700">${escapeShareCardValue(displayId)}</div>
            <div class="mt-1 text-xs text-ink-500 truncate" title="${escapeShareCardValue(sourceText)}">${escapeShareCardValue(sourceText)}</div>
            <div class="mt-2 text-[11px] text-ink-400">${escapeShareCardValue(landingPage.audience_rule || "默认用户")}</div>
          </div>
        </div>
      </label>
    `;
  }).join("");
}

function renderCardConfigPackagePicker(cfg) {
  const selectedPackageIds = new Set(cfg?.package_ids || []);
  return getOpsVisiblePackages().map((pkg) => {
    const checked = selectedPackageIds.has(pkg.id);
    const game = getShareGame(pkg.game_id);
    return `
      <label class="block rounded-xl border ${checked ? "border-brand-200 bg-brand-50/60" : "border-ink-200 bg-white"} p-3 cursor-pointer hover:border-brand-300">
        <div class="flex items-start gap-3">
          <input type="checkbox" name="card-config-package" value="${escapeShareCardValue(pkg.id)}" class="mt-1" ${checked ? "checked" : ""} />
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-1.5 text-sm font-semibold text-ink-900">
              ${renderGameIcon(game, "w-5 h-5")}
              <span>${escapeShareCardValue(game?.name || pkg.game_id)}</span>
              <span class="text-ink-300">/</span>
              <span class="font-mono text-xs text-ink-600">${escapeShareCardValue(pkg.name)}</span>
            </div>
            <div class="flex items-center gap-1.5 mt-1">
              <span class="badge bg-blue-50 text-blue-700">${escapeShareCardValue(pkg.region)}</span>
              <span class="badge bg-ink-100 text-ink-700">${escapeShareCardValue(pkg.platform)}</span>
              <code class="font-mono text-[10px] text-ink-400">${escapeShareCardValue(pkg.id)}</code>
            </div>
          </div>
        </div>
      </label>
    `;
  }).join("");
}

// 用当前 卡片 的配置预填「创建卡片」同款的信息输入区状态
function seedShareCardStateFromConfig(cfg) {
  const site = getTemple(cfg.temple_id)?.name || cfg.name || "EasyShare";
  window.shareCardOgFormState = {
    title: cfg.title || "",
    url: cfg.share_url || cfg.url || "",
    desc: cfg.desc || cfg.share_desc || "",
    site,
    imageUrl: cfg.image_url || cfg.imageUrl || "",
    imageDataUrl: cfg.image_data_url || "",
    imageFileName: "",
  };
  window.shareCardOgImageDataUrl = window.shareCardOgFormState.imageDataUrl || "";
  window.shareCardPostFormState = {
    postCopy: cfg.share_copy || cfg.post_copy || "",
    commonImageAlt: cfg.image_alt || "",
    publisherName: cfg.owner || "Player",
    fbOgType: "website",
    twitterCreator: "",
  };
}

Pages.cardConfigEditor = function (cardKey) {
  const cfg = getConfigByCardKey(cardKey);
  if (!cfg) {
    return UI.emptyState({ icon: "🖼️", title: "卡片配置不存在", desc: `未找到 <code class="px-1 bg-ink-100 rounded text-xs">${escapeShareCardValue(cardKey)}</code>`, action: `<button onclick="navigate('/ops/configured-cards')" class="px-4 py-2 bg-brand-900 text-white rounded-lg text-sm">返回卡片管理</button>` });
  }
  const cardId = cardIdForConfig(cfg);
  const landingPages = getLandingPagesForConfig(cfg);
  const targetPackages = getOpsVisiblePackages().filter((pkg) => (cfg.package_ids || []).includes(pkg.id));

  // 与「创建卡片」保持同一信息结构：信息输入区 + 三类预览区
  seedShareCardStateFromConfig(cfg);
  const ogState = getShareCardOgFormState();
  const ogImagePreviewHtml = getShareCardPreviewImageHtml(ogState, `
    <div class="text-sm font-medium text-ink-600">上传分享图</div>
    <div class="text-[11px] mt-1">WhatsApp 推荐 1:1（1200×1200）· PNG/JPG/WebP · &lt;2MB</div>
  `);
  const styles = getShareCardStyles();
  const postChannelNames = getShareCardPostChannelNames();
  const baseChatPreviews = styles.filter((s) => !postChannelNames.includes(s.channel) || ["Discord", "Telegram"].includes(s.channel));
  const priorityChatChannels = ["WhatsApp", "Discord"];
  const chatPreviews = [
    ...priorityChatChannels.map((channel) => baseChatPreviews.find((s) => s.channel === channel)).filter(Boolean),
    ...baseChatPreviews.filter((s) => !priorityChatChannels.includes(s.channel)),
  ];
  const postPreviews = styles.filter((s) => postChannelNames.includes(s.channel));

  // 复用创建页的实时预览绑定
  window.PageHooks = window.PageHooks || {};
  window.PageHooks.mounted = (path) => {
    if (path === `/ops/configured-cards/${cardId}/config`) {
      updateOgCardPreviews();
      bindShareCardPostRealtime();
      bindFieldHelpTooltips();
    }
  };

  return `
    ${UI.pageHeader({
      title: "卡片配置",
      desc: "拉取该 卡片 下的配置文件；信息结构与「创建卡片」一致，可重新维护分享文字信息与基础图。启用渠道、落地页 组合、适用包体请前往对应的运营管理页面调整。",
      actions: `
        <button onclick="navigate('/ops/configured-cards/${encodeURIComponent(cardId)}')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回 卡片 详情</button>
        <button onclick="saveCardConfig('${cardId}')" class="px-4 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800 shadow-soft">保存配置</button>
      `,
    })}

    <div class="card p-4 mb-5 flex items-center justify-between gap-4 flex-wrap bg-gradient-to-r from-brand-50 to-white">
      <div class="flex items-center gap-5 flex-wrap">
        <div>
          <div class="text-[11px] text-ink-400 uppercase tracking-wide">卡片编号</div>
          <div class="font-mono text-sm font-semibold text-brand-700">${escapeShareCardValue(cardId)}</div>
        </div>
        <div class="h-8 w-px bg-ink-100"></div>
        <div>
          <div class="text-[11px] text-ink-400 uppercase tracking-wide">活动配置编号</div>
          <div class="font-mono text-sm text-ink-700">${escapeShareCardValue(configId(cfg))}</div>
        </div>
        <div class="h-8 w-px bg-ink-100"></div>
        <div>
          <div class="text-[11px] text-ink-400 uppercase tracking-wide">更新时间</div>
          <div class="text-sm text-ink-700">${escapeShareCardValue(cfg.updated || "—")}</div>
        </div>
      </div>
      <div class="flex items-center gap-3">
        ${UI.statusBadge(cfg.status)}
        <span class="badge bg-ink-100 text-ink-600">系统生成字段不可修改</span>
      </div>
    </div>

    <div class="card p-4 mb-5">
      <div class="grid grid-cols-2 gap-4">
        <label class="block">
          <span class="block text-xs font-medium text-ink-500 mb-1">卡片名称</span>
          <input id="card-config-name" value="${escapeShareCardValue(cfg.name)}" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm" />
        </label>
        <label class="block">
          <span class="block text-xs font-medium text-ink-500 mb-1">发布状态</span>
          <select id="card-config-status" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm bg-white">
            <option value="draft" ${cfg.status === "draft" ? "selected" : ""}>草稿</option>
            <option value="released" ${cfg.status === "released" ? "selected" : ""}>已发布</option>
          </select>
        </label>
      </div>
    </div>

    ${renderShareCardUnifiedConfig(ogState, ogImagePreviewHtml, chatPreviews, postPreviews)}

    <div class="mt-5 flex justify-end">
      <button onclick="saveCardConfig('${cardId}')" class="px-5 py-2.5 bg-brand-900 text-white text-sm rounded-lg hover:bg-brand-800 shadow-soft">保存 卡片配置</button>
    </div>
  `;
};

window.saveCardConfig = async function (cardKey) {
  const cfg = getConfigByCardKey(cardKey);
  if (!cfg) {
    UI.toast("卡片配置不存在", "error");
    return;
  }
  const ogState = saveShareCardOgFormState();
  const postState = saveShareCardPostFormState();
  if (!ogState.title.trim()) {
    UI.toast("请填写 og:title 分享标题", "error");
    return;
  }
  const payload = {
    name: document.getElementById("card-config-name")?.value.trim() || cfg.name,
    status: document.getElementById("card-config-status")?.value || cfg.status,
    title: ogState.title.trim(),
    desc: ogState.desc,
    url: ogState.url,
    share_url: ogState.url,
    image_url: ogState.imageUrl,
    image_data_url: ogState.imageDataUrl || "",
    share_copy: postState.postCopy,
    image_alt: postState.commonImageAlt,
  };
  try {
    await shareConfigsApi.update(cfg.id, payload);
    await invalidateAndRefresh();
    UI.toast("卡片配置已保存", "success");
    renderRoute();
  } catch (err) {
    UI.toast(err?.message || "保存失败", "error");
  }
};

Pages.configuredCardDetail = function (cardKey) {
  const cfg = getConfigByCardKey(cardKey);
  if (!cfg) {
    return UI.emptyState({ icon: "🖼️", title: "卡片 不存在", desc: `未找到 <code class="px-1 bg-ink-100 rounded text-xs">${escapeShareCardValue(cardKey)}</code>`, action: `<button onclick="navigate('/ops/configured-cards')" class="px-4 py-2 bg-brand-900 text-white rounded-lg text-sm">返回卡片管理</button>` });
  }
  const cardId = cardIdForConfig(cfg);
  const landingPages = getLandingPagesForConfig(cfg);
  const targetPackages = getOpsVisiblePackages().filter((pkg) => cfg.package_ids.includes(pkg.id));
  return `
    ${UI.pageHeader({
      title: "卡片 详情",
      desc: "查看历史已配置的分享卡片资产，基础信息直接呈现 卡片配置时填写的参数，并确认其关联的 落地页编号 / 活动配置编号。",
      actions: `
        <button onclick="navigate('/ops/configured-cards')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回列表</button>
        <button onclick="navigate('/ops/configured-cards/${encodeURIComponent(cardId)}/config')" class="px-4 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800 shadow-soft">卡片编辑</button>
      `,
    })}

    <div class="grid grid-cols-4 gap-4 mb-5">
      ${UI.statCard({ label: "卡片编号", value: cardId, delta: 0, icon: "image", color: "brand" })}
      ${UI.statCard({ label: "活动配置编号", value: configId(cfg), delta: 0, icon: "database", color: "blue" })}
      ${UI.statCard({ label: "关联 落地页编号", value: landingPages.length, delta: 0, icon: "globe", color: "green" })}
      ${UI.statCard({ label: "适用包体", value: targetPackages.length, delta: 0, icon: "package", color: "amber" })}
    </div>

    <div class="grid grid-cols-12 gap-5 items-start">
      <div class="col-span-8 space-y-5">
        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
            <div>
              <h3 class="text-sm font-semibold text-ink-900">基础信息</h3>
              <p class="text-xs text-ink-500 mt-0.5">以下内容直接呈现「卡片配置」时填写的参数；如需修改请进入 卡片配置。</p>
            </div>
            ${UI.statusBadge(cfg.status)}
          </div>
          <div class="p-5 grid grid-cols-2 gap-4">
            <div class="block">
              <span class="block text-xs font-medium text-ink-500 mb-1">卡片编号</span>
              <div class="rounded-lg border border-ink-200 bg-ink-50 px-3 py-2.5 text-sm font-mono text-ink-700">${escapeShareCardValue(cardId)}</div>
            </div>
            <div class="block">
              <span class="block text-xs font-medium text-ink-500 mb-1">活动配置编号</span>
              <div class="rounded-lg border border-ink-200 bg-ink-50 px-3 py-2.5 text-sm font-mono text-ink-700">${configId(cfg)}</div>
            </div>
            <div class="block col-span-2">
              <span class="block text-xs font-medium text-ink-500 mb-1">卡片名称</span>
              <div class="rounded-lg border border-ink-200 bg-ink-50 px-3 py-2.5 text-sm text-ink-800">${escapeShareCardValue(cfg.name || "—")}</div>
            </div>
            <div class="block col-span-2">
              <span class="flex items-center gap-2 text-xs font-medium text-ink-500 mb-1"><span>分享文案</span><span class="badge bg-ink-100 text-ink-500">share_copy</span></span>
              <div class="rounded-lg border border-ink-200 bg-ink-50 px-3 py-2.5 text-sm text-ink-800 whitespace-pre-wrap min-h-[44px]">${escapeShareCardValue(cfg.share_copy || cfg.post_copy || "—")}</div>
            </div>
            <div class="block col-span-2">
              <span class="flex items-center gap-2 text-xs font-medium text-ink-500 mb-1"><span>分享标题</span><span class="badge bg-ink-100 text-ink-500">og:title</span></span>
              <div class="rounded-lg border border-ink-200 bg-ink-50 px-3 py-2.5 text-sm text-ink-800">${escapeShareCardValue(cfg.title || "—")}</div>
            </div>
            <div class="block col-span-2">
              <span class="flex items-center gap-2 text-xs font-medium text-ink-500 mb-1"><span>分享描述</span><span class="badge bg-ink-100 text-ink-500">og:description</span></span>
              <div class="rounded-lg border border-ink-200 bg-ink-50 px-3 py-2.5 text-sm text-ink-800 whitespace-pre-wrap min-h-[44px]">${escapeShareCardValue(cfg.desc || cfg.share_desc || "—")}</div>
            </div>
            <div class="block">
              <span class="flex items-center gap-2 text-xs font-medium text-ink-500 mb-1"><span>分享链接</span><span class="badge bg-ink-100 text-ink-500">og:url</span></span>
              <div class="rounded-lg border border-ink-200 bg-ink-50 px-3 py-2.5 text-sm font-mono text-ink-700 truncate">${escapeShareCardValue(cfg.url || cfg.share_url || "—")}</div>
            </div>
            <div class="block">
              <span class="flex items-center gap-2 text-xs font-medium text-ink-500 mb-1"><span>站点名称</span><span class="badge bg-ink-100 text-ink-500">og:site_name</span></span>
              <div class="rounded-lg border border-ink-200 bg-ink-50 px-3 py-2.5 text-sm text-ink-800 truncate">${escapeShareCardValue(getTemple(cfg.temple_id)?.name || cfg.site || cfg.name || "EasyShare")}</div>
            </div>
            <div class="block col-span-2">
              <span class="flex items-center gap-2 text-xs font-medium text-ink-500 mb-1"><span>标准上传图</span><span class="badge bg-ink-100 text-ink-500">og:image</span></span>
              ${(cfg.image_data_url || cfg.image_url || cfg.imageUrl)
                ? `<div class="flex items-center gap-3 rounded-lg border border-ink-200 bg-ink-50 p-3">
                     <img src="${escapeShareCardValue(cfg.image_data_url || cfg.image_url || cfg.imageUrl)}" class="w-16 h-16 rounded-lg object-cover border border-ink-100" alt="og:image" />
                     <div class="min-w-0">
                       <div class="text-xs text-ink-700 truncate">${escapeShareCardValue(cfg.image_url || cfg.imageUrl || "本地上传图")}</div>
                       ${cfg.image_alt ? `<div class="text-[11px] text-ink-400 mt-0.5 truncate">alt：${escapeShareCardValue(cfg.image_alt)}</div>` : ""}
                     </div>
                   </div>`
                : `<div class="rounded-lg border border-dashed border-ink-200 bg-ink-50 px-3 py-2.5 text-sm text-ink-400">未上传基础图（og:image）</div>`}
            </div>
            <div class="col-span-2">
              <span class="block text-xs font-medium text-ink-500 mb-2">启用渠道</span>
              <div class="flex flex-wrap gap-2">
                ${(cfg.channels || []).length
                  ? MOCK.CHANNELS.filter((channel) => (cfg.channels || []).includes(channel.code)).map((channel) => `
                      <span class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs bg-brand-50 border border-brand-200 text-brand-700">
                        <span>${channel.icon}</span><span>${escapeShareCardValue(channel.name)}</span>
                      </span>
                    `).join("")
                  : `<span class="text-xs text-ink-400">暂未启用渠道</span>`}
              </div>
            </div>
            <div class="col-span-2 rounded-xl border border-amber-200 bg-amber-50 p-3 text-xs text-amber-800">
              <div class="font-semibold mb-1">最佳尺寸策略</div>
              <div>WhatsApp 推荐 1:1；Discord PC 推荐 4:3；Discord 移动推荐 3:4。上传非最佳尺寸时会触发 Double Check。</div>
            </div>
          </div>
        </div>

        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100">
            <h3 class="text-sm font-semibold text-ink-900">关联 落地页 组合</h3>
            <p class="text-xs text-ink-500 mt-0.5">卡片与 落地页 是 N×N 关系；同一个 卡片 可搭配多个 落地页编号。</p>
          </div>
          <div class="p-5">${renderCardLandingTable(cfg)}</div>
        </div>
      </div>

      <div class="col-span-4 space-y-5">
        <div class="card p-5">
          <div class="mb-4">
            <h3 class="text-sm font-semibold text-ink-900">卡片预览</h3>
            <p class="text-xs text-ink-500 mt-0.5">用于检查渠道内卡片标题和视觉比例策略。</p>
          </div>
          ${renderCardDetailPreview(cfg)}
        </div>
        <div class="card p-5">
          <h3 class="text-sm font-semibold text-ink-900">适用包体</h3>
          <div class="mt-3 space-y-1.5">
            ${targetPackages.length ? targetPackages.map((pkg) => `<div class="rounded-lg bg-ink-50 px-3 py-2 text-xs text-ink-600"><span class="font-medium text-ink-800">${packageFullName(pkg)}</span><span class="ml-2 font-mono text-ink-400">${pkg.id}</span></div>`).join("") : `<span class="text-xs text-ink-400">暂无适用包体</span>`}
          </div>
        </div>
      </div>
    </div>
  `;
};

Pages.configuredCards = function () {
  const configs = getSortedShareConfigs(MOCK.SHARE_CONFIGS || []);
  const releasedCount = configs.filter((cfg) => cfg.status === "released").length;
  const channelCount = new Set(configs.flatMap((cfg) => cfg.channels || [])).size;
  const landingPageCount = new Set(configs.flatMap((cfg) => cfg.landing_page_ids || [cfg.landing_page_id]).filter(Boolean)).size;
  // 默认进入卡片视图
  window.__cardListView = "grid";
  return `
    ${UI.pageHeader({
      title: "已配置卡片管理",
      desc: "用卡片墙的方式集中浏览已配置的分享卡片资产；点击卡片可直接进入「卡片详情」。",
      actions: `
        <button onclick="navigate('/ops/share-card-config')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">+ 新增卡片</button>
        <button onclick="UI.toast('开始导出卡片清单', 'info')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">导出</button>
      `,
    })}
    ${renderOpsModuleTabs("card_manage")}
    ${renderOpsWorkflowHint("card")}

    <div class="grid grid-cols-4 gap-4 mb-5">
      ${UI.statCard({ label: "分享卡片", value: configs.length, delta: 0, icon: "image", color: "brand" })}
      ${UI.statCard({ label: "已发布", value: releasedCount, delta: 0, icon: "check", color: "green" })}
      ${UI.statCard({ label: "覆盖渠道", value: channelCount, delta: 0, icon: "share", color: "blue" })}
      ${UI.statCard({ label: "关联落地页", value: landingPageCount, delta: 0, icon: "database", color: "amber" })}
    </div>

    <div class="card p-4 mb-4 flex items-center gap-3 flex-wrap">
      <select id="card-category-filter" oninput="filterConfiguredAssets('card')" class="text-sm border border-ink-100 rounded-lg px-2.5 py-2 bg-white">
        <option value="all">全部渠道</option>
        <option value="whatsapp">WhatsApp</option>
        <option value="discord">Discord</option>
        <option value="facebook">Facebook</option>
        <option value="line">LINE</option>
      </select>
      <select id="card-status-filter" oninput="filterConfiguredAssets('card')" class="text-sm border border-ink-100 rounded-lg px-2.5 py-2 bg-white">
        <option value="all">全部状态</option>
        <option value="released">已发布</option>
        <option value="draft">草稿</option>
      </select>
      <input id="card-keyword-filter" oninput="filterConfiguredAssets('card')" class="w-72 text-xs border border-ink-100 rounded-lg px-3 py-2" placeholder="按关键字筛选：名称 / 标题 / 渠道 / 规则" />
      <input id="card-id-filter" oninput="filterConfiguredAssets('card')" class="w-72 text-xs border border-ink-100 rounded-lg px-3 py-2 font-mono" placeholder="按 ID 筛选：卡片编号 / 落地页编号 / 活动配置编号" />
      <div class="flex-1"></div>
      <span class="text-xs text-ink-500 mr-2">显示 <b id="card-filtered-count" class="text-ink-800">${configs.length}</b> / ${configs.length} 条 · 新 → 旧</span>
      <div class="inline-flex items-center rounded-lg border border-ink-100 overflow-hidden text-xs">
        <button data-card-view-btn="grid" onclick="toggleCardListView('grid')" class="px-2.5 py-1.5 flex items-center gap-1 bg-brand-900 text-white border border-brand-900" title="卡片视图">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM13 6a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2h-3a2 2 0 01-2-2V6zM4 15a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2H6a2 2 0 01-2-2v-3zM13 15a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-2 2h-3a2 2 0 01-2-2v-3z"/></svg>
          卡片
        </button>
        <button data-card-view-btn="table" onclick="toggleCardListView('table')" class="px-2.5 py-1.5 flex items-center gap-1 bg-white text-ink-600 border-l border-ink-100" title="列表视图">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/></svg>
          列表
        </button>
      </div>
    </div>

    <!-- 卡片视图 -->
    <div id="card-gallery-grid" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3">
      ${configs.length ? configs.map((cfg) => renderConfiguredCardTile(cfg)).join("") : ""}
    </div>
    ${configs.length ? "" : `
      <div id="card-gallery-empty" class="card p-10 text-center text-sm text-ink-500">
        暂无已配置的卡片，点击右上角「+ 新增卡片」创建第一张分享卡片。
      </div>`}

    <!-- 列表视图（默认隐藏） -->
    <div id="card-list-table" class="card overflow-hidden hidden">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">卡片资产列表</h3>
          <p class="text-xs text-ink-500 mt-0.5">分享卡片可被活动配置引用；渠道独立图片优先于基础 og:image；默认按更新时间从新到旧排列。</p>
        </div>
        <span class="badge bg-brand-50 text-brand-700">共 ${configs.length} 条</span>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead class="bg-ink-50 text-xs text-ink-500">
            <tr>
              <th class="text-left px-4 py-2.5 font-medium">卡片</th>
              <th class="text-left px-4 py-2.5 font-medium">标题 / 落地页</th>
              <th class="text-left px-4 py-2.5 font-medium">启用渠道</th>
              <th class="text-left px-4 py-2.5 font-medium">最佳尺寸策略</th>
              <th class="text-left px-4 py-2.5 font-medium">关联落地页 / 适用范围</th>
              <th class="text-left px-4 py-2.5 font-medium">状态</th>
              <th class="text-left px-4 py-2.5 font-medium">更新时间</th>
              <th class="text-right px-4 py-2.5 font-medium">操作</th>
            </tr>
          </thead>
          <tbody>${configs.map((cfg) => renderConfiguredCardRow(cfg)).join("")}</tbody>
        </table>
      </div>
    </div>
  `;
};

// ---------- 配置模型治理：Schema / 兼容性 / 发布边界 ----------
Pages.shareModelMap = function () {
  if (!UI.hasPerm("admin")) {
    return UI.emptyState({ icon: "lock", title: "权限不足", desc: "配置模型治理仅 SDK 管理员可访问" });
  }
  const schemas = [
    { name: "ShareContent", version: "v2.4", status: "active", owner: "SDK 平台", fields: 18, desc: "分享卡片、渠道字段、落地页引用与追踪参数的核心模型" },
    { name: "LandingPageAsset", version: "v1.8", status: "active", owner: "运营平台", fields: 14, desc: "URL 注册、模版生成、移动端适配与来源声明" },
    { name: "ActivityConfig", version: "v2.1", status: "testing", owner: "运营平台", fields: 22, desc: "活动配置、卡片+落地页组合、包体绑定与实验分流" },
    { name: "AttributionEvent", version: "v1.6", status: "active", owner: "数据平台", fields: 16, desc: "分享、打开、安装、回流、LTV 归因事件字段" },
  ];
  const changes = [
    { time: "2026-06-14", model: "ActivityConfig", change: "新增语言维度生效策略", impact: "向后兼容", status: "已发布" },
    { time: "2026-06-10", model: "LandingPageAsset", change: "补充 URL 来源类型与移动端校验字段", impact: "向后兼容", status: "已发布" },
    { time: "2026-06-02", model: "ShareContent", change: "渠道平台 overrides 字段收敛为 Schema 管理", impact: "需 SDK v2.4+", status: "灰度中" },
    { time: "2026-05-28", model: "AttributionEvent", change: "增加 sdkUID 与新下载 UID 日志字段", impact: "新增字段", status: "评审中" },
  ];
  const checklist = [
    "字段新增默认向后兼容，不破坏旧 SDK 读取",
    "字段废弃需保留至少 2 个 SDK minor 版本",
    "涉及归因、LTV、渠道能力的字段需同步数据平台",
    "配置模型发布前需完成测试包体与至少 2 个渠道回归",
  ];

  return `
    ${UI.pageHeader({
      title: "配置模型治理",
      desc: "管理员侧维护 EasyShare 核心配置 Schema、字段兼容性、模型版本和发布边界；不承载运营日常配置创建。",
      actions: `<button onclick="confirmAction('提交模型变更评审', '确认提交新的配置模型变更评审吗？变更会进入 SDK、运营平台和数据平台联合评审流程。', '确认提交', '模型变更已提交评审', '', 'info')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">提交模型变更</button>`,
    })}

    <div class="grid grid-cols-4 gap-4 mb-5">
      ${UI.statCard({ label: "核心模型", value: schemas.length, delta: 0, icon: "database", color: "brand" })}
      ${UI.statCard({ label: "活跃模型", value: schemas.filter(s => s.status === "active").length, delta: 0, icon: "check", color: "green" })}
      ${UI.statCard({ label: "灰度/测试", value: schemas.filter(s => s.status !== "active").length, delta: 0, icon: "activity", color: "amber" })}
      ${UI.statCard({ label: "本月变更", value: changes.length, delta: 0, icon: "fileText", color: "blue" })}
    </div>

    <div class="card p-4 mb-5 border-l-4 border-l-brand-700">
      <div class="text-sm font-semibold text-ink-900">职责边界</div>
      <div class="text-xs text-ink-600 mt-1 leading-relaxed">运营工具负责创建落地页、卡片和活动配置；研发工具负责接入 SDK 和包体。管理员这里只治理模型结构、字段兼容性、Schema 版本和发布审批，避免变更影响所有接入游戏。</div>
    </div>

    <div class="grid grid-cols-12 gap-5">
      <div class="col-span-8 card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100">
          <div class="text-sm font-semibold text-ink-900">核心 Schema</div>
          <div class="text-xs text-ink-500 mt-1">用于定义 SDK、运营平台、数据平台之间共同遵循的配置模型。</div>
        </div>
        <table class="w-full text-sm table-fixed">
          <thead class="bg-ink-50 text-xs text-ink-500">
            <tr>
              <th class="text-left px-4 py-2.5 font-medium w-[20%]">模型</th>
              <th class="text-left px-4 py-2.5 font-medium w-[12%]">版本</th>
              <th class="text-left px-4 py-2.5 font-medium w-[14%]">状态</th>
              <th class="text-left px-4 py-2.5 font-medium w-[14%]">Owner</th>
              <th class="text-left px-4 py-2.5 font-medium">说明</th>
            </tr>
          </thead>
          <tbody>
            ${schemas.map((schema) => `
              <tr class="border-t border-ink-100 align-top">
                <td class="px-4 py-3 font-semibold text-ink-900">${schema.name}<div class="text-[11px] text-ink-400 mt-1">${schema.fields} 字段</div></td>
                <td class="px-4 py-3 font-mono text-xs text-ink-700">${schema.version}</td>
                <td class="px-4 py-3">${UI.statusBadge(schema.status)}</td>
                <td class="px-4 py-3 text-xs text-ink-600">${schema.owner}</td>
                <td class="px-4 py-3 text-xs text-ink-500 leading-relaxed">${schema.desc}</td>
              </tr>
            `).join("")}
          </tbody>
        </table>
      </div>

      <div class="col-span-4 space-y-5">
        <div class="card p-5">
          <div class="text-sm font-semibold text-ink-900">变更准入规则</div>
          <div class="mt-3 space-y-2">
            ${checklist.map((item) => `<div class="flex gap-2 text-xs text-ink-600 leading-relaxed"><span class="text-ok-600">✓</span><span>${item}</span></div>`).join("")}
          </div>
        </div>
        <div class="card p-5 bg-amber-50 border-amber-200">
          <div class="text-sm font-semibold text-amber-900">高风险变更</div>
          <div class="text-xs text-amber-800 mt-2 leading-relaxed">删除字段、修改字段语义、改变默认归因窗口、影响 SDK 缓存结构的变更，必须走评审和灰度流程。</div>
        </div>
      </div>
    </div>

    <div class="card overflow-hidden mt-5">
      <div class="px-5 py-4 border-b border-ink-100">
        <div class="text-sm font-semibold text-ink-900">近期模型变更</div>
        <div class="text-xs text-ink-500 mt-1">记录配置模型、归因事件和渠道字段的 Schema 变更历史。</div>
      </div>
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr><th class="text-left px-5 py-2.5 font-medium">时间</th><th class="text-left px-5 py-2.5 font-medium">模型</th><th class="text-left px-5 py-2.5 font-medium">变更</th><th class="text-left px-5 py-2.5 font-medium">影响</th><th class="text-left px-5 py-2.5 font-medium">状态</th></tr>
        </thead>
        <tbody>
          ${changes.map((item) => `<tr class="border-t border-ink-100"><td class="px-5 py-3 text-xs text-ink-500">${item.time}</td><td class="px-5 py-3 font-medium">${item.model}</td><td class="px-5 py-3 text-ink-600">${item.change}</td><td class="px-5 py-3 text-xs text-ink-500">${item.impact}</td><td class="px-5 py-3"><span class="badge ${item.status === "已发布" ? "bg-ok-50 text-ok-700" : item.status === "灰度中" ? "bg-brand-50 text-brand-700" : "bg-amber-50 text-amber-700"}">${item.status}</span></td></tr>`).join("")}
        </tbody>
      </table>
    </div>
  `;
};

// ---------- 包体运营：按包体查看累计配置历史（工作流 1） ----------
Pages.packageConfigList = function () {
  const selectedGame = getPackageConfigSelectedGame();
  const selectedGameId = selectedGame?.id || "";
  const packages = getOpsVisiblePackages().filter((p) => p.game_id === selectedGameId);
  const configHistoryCount = packages.reduce((sum, p) => sum + getAllShareConfigsForPackage(p).length, 0);
  const packagesWithHistory = packages.filter((p) => getAllShareConfigsForPackage(p).length > 0).length;
  const multiConfigCount = packages.filter((p) => getAllShareConfigsForPackage(p).length > 1).length;
  const latestConfig = getSortedShareConfigs((MOCK.SHARE_CONFIGS || []).filter((cfg) => (cfg.package_ids || []).some((id) => packages.some((p) => p.id === id))))[0];

  return `
    ${UI.pageHeader({
      title: "包体运营",
      desc: "面向运营人员查看同一个包体下累计产生的分享配置历史，按更新时间从新到旧排序；多个配置可并行运行。",
      actions: `
        <button onclick="navigate('/ops/share-config')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">查看分享活动配置</button>
      `,
    })}
    ${renderOpsModuleTabs("package")}
    ${renderOpsWorkflowHint("package")}

    <div class="card p-4 mb-5">
      <div class="grid grid-cols-12 gap-3 items-end">
        <label class="col-span-4 block">
          <span class="block text-xs font-medium text-ink-500 mb-1.5">游戏</span>
          <select onchange="changePackageConfigGame(this.value)" class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white">
            ${getPackageConfigGames().map((game) => `<option value="${game.id}" ${game.id === selectedGameId ? "selected" : ""}>${game.name}</option>`).join("")}
          </select>
        </label>
        <div class="col-span-8 rounded-lg border border-brand-100 bg-brand-50 px-4 py-2.5">
          <div class="text-xs font-semibold text-brand-700">当前仅查看单游戏</div>
          <div class="text-sm text-brand-900 mt-0.5">${selectedGame?.name || "—"} · ${packages.length} 个包体 · 按游戏维度聚合</div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-4 gap-4 mb-5">
      ${UI.statCard({ label: "当前游戏包体", value: packages.length, delta: 0, icon: "package", color: "brand" })}
      ${UI.statCard({ label: "累计配置历史", value: configHistoryCount, delta: 0, icon: "fileText", color: "green" })}
      ${UI.statCard({ label: "已有配置包体", value: packagesWithHistory, delta: 0, icon: "check", color: "amber" })}
      ${UI.statCard({ label: "多配置包体", value: multiConfigCount, delta: 0, icon: "layers", color: "blue" })}
    </div>

    <div class="card p-4 mb-5 bg-amber-50 border-amber-200">
      <div class="flex items-start gap-3">
        <div class="w-8 h-8 rounded-lg bg-white border border-amber-200 flex items-center justify-center text-sm">!</div>
        <div>
          <div class="text-sm font-semibold text-amber-900">配置历史查看规则</div>
          <div class="text-xs text-amber-800 leading-relaxed mt-1">同一个包体下累计配置按更新时间新 → 旧展示。配置之间不存在优先级；客户端按指定配置读取已发布的卡片与落地页组合。</div>
        </div>
      </div>
    </div>

    <div class="card overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">${selectedGame?.name || "当前游戏"} 包体配置历史</h3>
          <p class="text-xs text-ink-500 mt-0.5">仅展示当前游戏下的包体及累计配置记录，最新配置在最上方。</p>
        </div>
        <span class="badge bg-brand-50 text-brand-700">最新：${latestConfig?.updated || "暂无"}</span>
      </div>
      <div class="px-5 py-3 border-b border-ink-100 bg-ink-50/60 flex items-center gap-3 flex-wrap">
        <div class="flex items-center gap-2">
          <span class="text-xs text-ink-500">筛选</span>
          <select class="text-sm border border-ink-100 rounded-lg px-2.5 py-1.5 bg-white">
            <option>全部包体</option>
            <option>仅有历史配置</option>
            <option>多配置包体</option>
          </select>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-xs text-ink-500">排序</span>
          <select class="text-sm border border-ink-100 rounded-lg px-2.5 py-1.5 bg-white">
            <option>最新配置时间倒序</option>
            <option>配置历史数量倒序</option>
            <option>包体名称 A-Z</option>
          </select>
        </div>
        <div class="flex-1"></div>
        <input class="w-64 text-xs border border-ink-100 rounded-lg px-3 py-1.5" placeholder="搜索包体 / 配置名称" />
      </div>
      <table class="w-full text-sm table-fixed">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-4 py-2.5 font-medium w-[23%]">Region / Platform</th>
            <th class="text-left px-4 py-2.5 font-medium w-[20%]">历史分享配置概览</th>
            <th class="text-left px-4 py-2.5 font-medium w-[22%]">实际分享运营概览</th>
            <th class="text-left px-4 py-2.5 font-medium w-[25%]">最新配置</th>
            <th class="text-right px-4 py-2.5 font-medium w-[10%]">操作</th>
          </tr>
        </thead>
        <tbody>
          ${packages.map((p) => renderPackageConfigRow(p)).join("")}
        </tbody>
      </table>
    </div>
  `;
};

function getPackageConfigGames() {
  const visibleGameIds = [...new Set(getOpsVisiblePackages().map((p) => p.game_id))];
  return (MOCK.GAMES || []).filter((game) => visibleGameIds.includes(game.id) && game.status === "active");
}

function getPackageConfigSelectedGame() {
  const query = location.hash.includes("?") ? location.hash.split("?")[1] : "";
  const params = new URLSearchParams(query);
  const games = getPackageConfigGames();
  const gameId = params.get("game") || games[0]?.id || "";
  return games.find((game) => game.id === gameId) || games[0] || (MOCK.GAMES || [])[0];
}

window.changePackageConfigGame = function (gameId) {
  navigate(`/ops/package-config?game=${encodeURIComponent(gameId || "")}`);
};

Pages.packageConfigHistory = function (packageId) {
  const pkg = MOCK.PACKAGES.find((p) => p.id === packageId) || MOCK.PACKAGES[0];
  const game = getShareGame(pkg.game_id);
  const history = getAllShareConfigsForPackage(pkg);
  const latest = history[0];
  const releasedCount = history.filter((cfg) => cfg.status === "released").length;
  const draftCount = history.filter((cfg) => cfg.status === "draft").length;
  const query = location.hash.includes("?") ? location.hash.split("?")[1] : "";
  const params = new URLSearchParams(query);
  const requestedSortMode = params.get("sort") || "config_new";
  const sortMode = ["config_new", "called_count"].includes(requestedSortMode) ? requestedSortMode : "config_new";
  const sortedHistory = sortPackageConfigHistory(history, sortMode);
  const pageSize = 10;
  const totalPages = Math.max(1, Math.ceil(sortedHistory.length / pageSize));
  const currentPage = Math.min(Math.max(parseInt(params.get("page") || "1"), 1), totalPages);
  const startIndex = (currentPage - 1) * pageSize;
  const pageHistory = sortedHistory.slice(startIndex, startIndex + pageSize);
  const pageStart = sortedHistory.length ? startIndex + 1 : 0;
  const pageEnd = Math.min(startIndex + pageSize, sortedHistory.length);

  return `
    ${UI.pageHeader({
      title: `${game?.name || "未知游戏"} / ${pkg.name}`,
      desc: `<span class="badge bg-blue-50 text-blue-700 mr-1">${pkg.region}</span><span class="badge bg-ink-100 text-ink-700">${pkg.platform}</span>`,
      actions: `
        <button onclick="navigate('/ops/package-config')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回包体运营</button>
      `,
    })}

    <div class="grid grid-cols-4 gap-4 mb-5">
      ${UI.statCard({ label: "累计配置", value: history.length, delta: 0, icon: "fileText", color: "brand" })}
      ${UI.statCard({ label: "已发布", value: releasedCount, delta: 0, icon: "check", color: "green" })}
      ${UI.statCard({ label: "草稿", value: draftCount, delta: 0, icon: "edit", color: "amber" })}
      ${UI.statCard({ label: "最新更新", value: latest?.updated?.slice(5, 16) || "—", delta: 0, icon: "clock", color: "blue" })}
    </div>

    <div class="space-y-4">
      <div class="card p-4 flex items-center gap-3 flex-wrap">
        <select class="w-56 text-sm border border-ink-100 rounded-lg px-2.5 py-2 bg-white">
          <option>全部历史</option>
          <option>仅已发布</option>
          <option>仅草稿</option>
          <option>仅当前包体配置</option>
          <option>仅配置方案</option>
          <option>URL 落地页</option>
        </select>
        <input class="w-72 text-xs border border-ink-100 rounded-lg px-3 py-2" placeholder="搜索配置名称 / 卡片 / 落地页" />
        <select onchange="navigate('/ops/package-config/${pkg.id}/history?sort=' + this.value)" class="text-sm border border-ink-100 rounded-lg px-2.5 py-2 bg-white">
          <option value="config_new" ${sortMode === "config_new" ? "selected" : ""}>配置新旧：新 → 旧</option>
          <option value="called_count" ${sortMode === "called_count" ? "selected" : ""}>配置被调用次数：多 → 少</option>
        </select>
        <select class="text-sm border border-ink-100 rounded-lg px-2.5 py-2 bg-white">
          <option>全部来源</option>
          <option>当前包体配置</option>
          <option>配置方案</option>
        </select>
        <div class="flex-1"></div>
        <span class="text-xs text-ink-500">每页 ${pageSize} 条 · 当前 ${pageStart}-${pageEnd} / ${history.length}</span>
      </div>

      <div class="card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
          <div>
            <h3 class="text-sm font-semibold text-ink-900">历史配置列表</h3>
            <p class="text-xs text-ink-500 mt-0.5">列表保持紧凑；点击展开查看 卡片 + 落地页 + 启用渠道 组合与规则明细。</p>
          </div>
          <span class="badge bg-brand-50 text-brand-700">${packageConfigHistorySortLabel(sortMode)}</span>
        </div>
        <div class="divide-y divide-ink-100">
          ${history.length ? pageHistory.map((cfg, idx) => renderPackageHistoryItem(cfg, startIndex + idx, startIndex + idx === 0)).join("") : UI.emptyState({ icon: "🧾", title: "暂无配置历史", desc: "该包体尚未关联任何配置。" })}
        </div>
        ${sortedHistory.length > pageSize ? renderHistoryPagination(pkg.id, currentPage, totalPages, pageStart, pageEnd, sortedHistory.length, sortMode) : ""}
      </div>
    </div>
  `;
};

function packageConfigHistorySortLabel(sortMode) {
  const map = {
    config_new: "按配置新旧排序",
    called_count: "按调用次数排序",
  };
  return map[sortMode] || map.config_new;
}

function getPackageConfigCallStats(cfg) {
  const records = (MOCK.SHARE_RECORDS || []).filter((record) => record.config_id === configId(cfg));
  const latestRecordTime = records.reduce((max, record) => Math.max(max, Date.parse(String(record.time || "").replace(" ", "T")) || 0), 0);
  const seed = String(configId(cfg)).split("").reduce((sum, ch) => sum + ch.charCodeAt(0), 0);
  const fallbackCount = cfg.status === "released" ? (seed % 120) + 12 : (seed % 8);
  const fallbackCalledAt = fallbackCount ? configUpdatedTime(cfg) + (seed % 72) * 60 * 60 * 1000 : 0;
  return {
    count: records.length || fallbackCount,
    latestCalledAt: latestRecordTime || fallbackCalledAt,
  };
}

function formatPackageConfigCallTime(timestamp) {
  if (!timestamp) return "暂无调用";
  const date = new Date(timestamp);
  const pad = (value) => String(value).padStart(2, "0");
  return `${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

function sortPackageConfigHistory(history, sortMode) {
  const sorters = {
    config_new: (a, b) => configUpdatedTime(b) - configUpdatedTime(a),
    called_count: (a, b) => getPackageConfigCallStats(b).count - getPackageConfigCallStats(a).count || getPackageConfigCallStats(b).latestCalledAt - getPackageConfigCallStats(a).latestCalledAt,
  };
  return [...history].sort(sorters[sortMode] || sorters.config_new);
}

function packageHistoryPath(packageId, page, sortMode) {
  return `/ops/package-config/${packageId}/history?page=${page}&sort=${encodeURIComponent(sortMode || "config_new")}`;
}

function renderHistoryPagination(packageId, currentPage, totalPages, pageStart, pageEnd, total, sortMode = "config_new") {
  const pageButton = (page) => `
    <button onclick="navigate('${packageHistoryPath(packageId, page, sortMode)}')" class="px-2.5 py-1 rounded ${page === currentPage ? "bg-brand-900 text-white" : "hover:bg-ink-50 text-ink-600"}">${page}</button>
  `;
  return `
    <div class="px-5 py-4 border-t border-ink-100 bg-ink-50 flex items-center justify-between text-xs text-ink-500">
      <div>显示 <strong>${pageStart}-${pageEnd}</strong> / ${total} 条 · 每页 10 条</div>
      <div class="flex items-center gap-1">
        <button ${currentPage === 1 ? "disabled" : ""} onclick="navigate('${packageHistoryPath(packageId, currentPage - 1, sortMode)}')" class="px-2.5 py-1 rounded hover:bg-ink-100 disabled:opacity-40 disabled:cursor-not-allowed">上一页</button>
        ${Array.from({ length: totalPages }, (_, i) => pageButton(i + 1)).join("")}
        <button ${currentPage === totalPages ? "disabled" : ""} onclick="navigate('${packageHistoryPath(packageId, currentPage + 1, sortMode)}')" class="px-2.5 py-1 rounded hover:bg-ink-100 disabled:opacity-40 disabled:cursor-not-allowed">下一页</button>
      </div>
    </div>
  `;
}

function renderPackageHistoryItem(cfg, idx, open = false) {
  const landingPages = getLandingPagesForConfig(cfg);
  const primaryLanding = landingPages[0];
  const callStats = getPackageConfigCallStats(cfg);
  return `
    <details class="group" ${open ? "open" : ""}>
      <summary class="px-5 py-4 cursor-pointer hover:bg-ink-50 flex items-center gap-4">
        <span class="w-8 h-8 rounded-full ${idx === 0 ? "bg-brand-900 text-white" : "bg-ink-100 text-ink-600"} flex items-center justify-center text-xs font-semibold">${idx === 0 ? "新" : idx + 1}</span>
        <div class="flex-1 min-w-0">
          <div class="flex items-center gap-2 min-w-0">
            <div class="text-sm font-semibold text-ink-900 truncate">${cfg.name}</div>
            ${UI.statusBadge(cfg.status)}
          </div>
          <div class="text-xs text-ink-500 mt-1">更新 ${cfg.updated || "—"} · ${primaryLanding?.name || primaryLanding?.title || "暂无落地页"}</div>
        </div>
        <div class="hidden md:flex items-center gap-6 text-xs text-ink-500">
          <div><span class="block text-ink-400">最近调用</span><span class="font-mono text-ink-700">${formatPackageConfigCallTime(callStats.latestCalledAt)}</span></div>
          <div><span class="block text-ink-400">调用次数</span><span class="font-mono text-ink-700">${UI.fmtNum(callStats.count)}</span></div>
        </div>
        <svg class="chev w-4 h-4 text-ink-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
      </summary>
      <div class="px-5 pb-4 bg-ink-50/40">
        <div class="grid grid-cols-3 gap-3 text-xs">
          <div class="rounded-lg border border-ink-100 bg-white p-3">
            <div class="text-ink-400">分享卡片</div>
            <div class="mt-1 font-medium text-ink-900 truncate">${cfg.title || cfg.name}</div>
          </div>
          <div class="rounded-lg border border-ink-100 bg-white p-3">
            <div class="text-ink-400">落地页</div>
            <div class="mt-1 font-medium text-ink-900 truncate">${primaryLanding?.name || primaryLanding?.title || "暂无"}${landingPages.length > 1 ? ` +${landingPages.length - 1}` : ""}</div>
          </div>
          <div class="rounded-lg border border-ink-100 bg-white p-3">
            <div class="text-ink-400">启用渠道</div>
            <div class="mt-1">${renderChannelIcons(cfg.channels)}</div>
          </div>
        </div>
      </div>
    </details>
  `;
}

// ---------- 分享活动管理：单个卡片 + 单个落地页，并批量关联包体 ----------
function renderShareActivityTabs(active = "manage") {
  const tabs = [
    { key: "manage", title: "活动配置", path: "/ops/share-config", desc: "管理已配置活动" },
    { key: "lab", title: "实验室", path: "/ops/share-config/lab", desc: "配置对照组实验" },
  ];
  return `
    <div class="card p-1.5 mb-4 inline-flex items-center gap-1 text-sm">
      ${tabs.map((tab) => {
        const isActive = active === tab.key;
        return `
          <button onclick="navigate('${tab.path}')" class="px-4 py-2 rounded-lg text-left ${isActive ? "bg-brand-900 text-white shadow-soft" : "text-ink-600 hover:bg-ink-50"}">
            <div class="font-medium leading-tight">${tab.title}</div>
            <div class="text-[10px] ${isActive ? "text-white/70" : "text-ink-400"}">${tab.desc}</div>
          </button>
        `;
      }).join("")}
    </div>
  `;
}

Pages.shareConfigList = function () {
  const packages = getOpsVisiblePackages();
  const configs = MOCK.SHARE_CONFIGS || [];
  const allPlanConfigs = getSortedShareConfigs(configs.filter((c) => c.scope === "package_set"));
  const releasedCount = allPlanConfigs.filter((cfg) => cfg.status === "released").length;
  const draftCount = allPlanConfigs.filter((cfg) => cfg.status === "draft").length;
  const pageSize = 15;
  const query = location.hash.includes("?") ? location.hash.split("?")[1] : "";
  const params = new URLSearchParams(query);
  const selectionMode = params.get("selectFor") || "";
  const selectingForExperiment = ["experiment", "experimentVariant", "experimentPrimary"].includes(selectionMode);
  const selectingPrimaryForExperiment = selectionMode === "experimentPrimary";
  const experimentDraft = getExperimentLabDraft(allPlanConfigs);
  const queryGameId = params.get("game") || "";
  if (selectingForExperiment && queryGameId && queryGameId !== experimentDraft.gameId) {
    experimentDraft.gameId = queryGameId;
    experimentDraft.primaryId = null;
    experimentDraft.variantIds = [];
  }
  const selectedExperimentGame = getExperimentLabSelectedGame(experimentDraft);
  const experimentGameId = selectedExperimentGame?.id || experimentDraft.gameId;
  const activeGames = MOCK.GAMES.filter((game) => game.status === "active");
  const selectedActivityGameId = selectingForExperiment ? experimentGameId : (params.get("game") || "all");
  const filterPackages = selectedActivityGameId === "all" ? packages : packages.filter((pkg) => pkg.game_id === selectedActivityGameId);
  const planConfigs = selectingForExperiment
    ? getExperimentConfigsForGame(allPlanConfigs, experimentGameId)
    : selectedActivityGameId === "all" ? allPlanConfigs : allPlanConfigs.filter((cfg) => shareConfigBelongsToGame(cfg, selectedActivityGameId));
  const page = Math.max(1, parseInt(params.get("page") || "1", 10));
  const totalPages = Math.max(1, Math.ceil(planConfigs.length / pageSize));
  const currentPage = Math.min(page, totalPages);
  const pageStart = planConfigs.length ? (currentPage - 1) * pageSize + 1 : 0;
  const pageEnd = Math.min(currentPage * pageSize, planConfigs.length);
  const pageConfigs = planConfigs.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return `
    ${UI.pageHeader({
      title: "分享活动管理",
      desc: "面向运营活动沉淀可复用的 活动配置编号：一个活动只绑定一个 卡片编号 和一个 落地页编号，再批量关联到目标包体。",
      actions: selectingForExperiment ? `
        <button onclick="confirmExperimentActivitySelection()" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">确认选择</button>
        <button onclick="cancelExperimentActivitySelection()" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">取消选择</button>
      ` : `
        <button onclick="navigate('/ops/share-config/activity/create')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">+ 创建活动分享</button>
        <button onclick="navigate('/ops/package-config')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">包体运营</button>
      `,
    })}

    ${selectingForExperiment ? `
      <div class="card p-4 mb-4 bg-brand-50 border-brand-100">
        <div class="flex items-start justify-between gap-4">
          <div>
            <div class="text-sm font-semibold text-brand-900">${selectingPrimaryForExperiment ? "选择实验主配置" : "选择实验对照配置"}</div>
            <div class="text-xs text-brand-700 mt-1">${selectingPrimaryForExperiment ? "单选 1 条活动配置作为主配置；SDK 后续通过主配置找到关联对照配置。" : "可多选活动配置作为对照组；确认后会回到「创建实验组」页面并自动填入。"} 当前仅展示 ${selectedExperimentGame?.name || "已选游戏"} 下的活动配置。</div>
          </div>
          <span class="badge bg-white text-brand-700 border border-brand-100">已选 <span id="experiment-selection-count">${selectingPrimaryForExperiment ? (experimentDraft.primaryId ? 1 : 0) : (experimentDraft.variantIds || []).length}</span> 个</span>
        </div>
      </div>
    ` : ""}

    <div class="card p-4 mb-4">
      <div class="flex items-center gap-3">
        <input id="share-activity-keyword-filter" oninput="filterShareActivities()" class="w-72 px-3 py-2 text-sm border border-ink-200 rounded-lg" placeholder="搜索活动名 / 活动配置编号 / 卡片编号" />
        <select id="share-activity-status-filter" onchange="filterShareActivities()" class="w-36 px-3 py-2 text-sm border border-ink-200 rounded-lg bg-white">
          <option value="all">全部状态</option>
          <option value="released">已发布</option>
          <option value="draft">草稿</option>
        </select>
        <select id="share-activity-game-filter" onchange="changeShareActivityGameFilter(this.value)" ${selectingForExperiment ? "disabled" : ""} class="w-44 px-3 py-2 text-sm border border-ink-200 rounded-lg bg-white ${selectingForExperiment ? "text-ink-500" : ""}">
          <option value="all" ${selectedActivityGameId === "all" ? "selected" : ""}>全部游戏</option>
          ${activeGames.map((game) => `<option value="${game.id}" ${selectedActivityGameId === game.id ? "selected" : ""}>${game.name}</option>`).join("")}
        </select>
        <select id="share-activity-package-filter" onchange="filterShareActivities()" class="w-56 px-3 py-2 text-sm border border-ink-200 rounded-lg bg-white">
          <option value="all">${selectingForExperiment ? "当前游戏全部包体" : "全部包体"}</option>
          ${filterPackages.slice(0, 12).map((p) => `<option value="${p.id}" data-game="${p.game_id}">${packageFullName(p)}</option>`).join("")}
        </select>
        <div class="flex-1"></div>
        <span class="text-xs text-ink-500">当前 <strong id="share-activity-filter-count" class="text-ink-900">${pageConfigs.length}</strong> / ${planConfigs.length} 条${selectingForExperiment ? ` · ${selectedExperimentGame?.name || "已选游戏"}` : ""} · 每页 15 条</span>
      </div>
    </div>

    <div class="card overflow-hidden">
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500 border-b border-ink-100">
          <tr>
            ${selectingForExperiment ? `<th class="text-left px-4 py-3 font-medium w-10">选择</th>` : ""}
            <th class="text-left px-4 py-3 font-medium">活动 / 活动配置编号</th>
            <th class="text-left px-4 py-3 font-medium">游戏名</th>
            <th class="text-left px-4 py-3 font-medium">卡片编号</th>
            <th class="text-left px-4 py-3 font-medium">落地页编号</th>
            <th class="text-left px-4 py-3 font-medium">包体数</th>
            <th class="text-left px-4 py-3 font-medium">多语言数</th>
            <th class="text-left px-4 py-3 font-medium">启用渠道</th>
            <th class="text-left px-4 py-3 font-medium">状态</th>
            <th class="text-left px-4 py-3 font-medium">更新 / 负责人</th>
            <th class="text-right px-4 py-3 font-medium">操作</th>
          </tr>
        </thead>
        <tbody>
          ${pageConfigs.length ? pageConfigs.map((cfg) => renderShareActivityManageRow(cfg, filterPackages, selectingForExperiment, experimentDraft, selectionMode)).join("") : `<tr><td colspan="${selectingForExperiment ? 11 : 10}" class="px-4 py-10">${UI.emptyState({ icon: "calendar", title: "暂无分享活动", desc: "创建活动后，将在这里管理活动、卡片、落地页和适用包体。" })}</td></tr>`}
        </tbody>
      </table>
      ${renderShareActivityPagination(currentPage, totalPages, pageStart, pageEnd, planConfigs.length, selectionMode, selectingForExperiment ? experimentGameId : (selectedActivityGameId === "all" ? "" : selectedActivityGameId))}
    </div>
  `;
};

Pages.shareConfigLab = function () {
  const configs = getSortedShareConfigs((MOCK.SHARE_CONFIGS || []).filter((c) => c.scope === "package_set"));
  const primary = configs[0];
  const variants = configs.slice(1, 4);
  const groups = getExperimentLabGroups(configs);
  return `
    ${UI.pageHeader({
      title: "分享活动实验室",
      desc: "把多个活动分享配置设定为对照组。SDK 先匹配包体、地区、语言生效范围，再在命中范围内均匀分流并记录分享链路数据。",
      actions: `
        <button onclick="navigate('/ops/share-config/lab/analysis')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">转化率报告</button>
        <button onclick="navigate('/ops/share-config/lab/retention')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">留存率报告</button>
        <button onclick="startCreateExperimentLab()" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">+ 创建实验组</button>
        <button onclick="navigate('/ops/share-config')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回活动配置</button>
      `,
    })}

    <div class="card overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">实验组列表</h3>
          <p class="text-xs text-ink-500 mt-0.5">按实验组管理对照配置；点击单行可展开查看配置组成、策略和数据记录规则。</p>
        </div>
        <span class="badge bg-brand-50 text-brand-700">支持局部展开</span>
      </div>
      <div class="divide-y divide-ink-100">
        ${groups.map((group, idx) => renderExperimentGroupItem({ ...group, open: idx === 0 })).join("")}
      </div>
    </div>
  `;
};

Pages.shareConfigLabAnalysis = function () {
  const configs = getSortedShareConfigs((MOCK.SHARE_CONFIGS || []).filter((c) => c.scope === "package_set"));
  const primary = configs[0];
  const variants = configs.slice(1, 4);
  const rows = buildExperimentAnalysisRows(primary, variants);
  const packages = getExperimentAnalysisPackages();
  const packageRows = buildExperimentAnalysisPackageRows(rows, packages);
  const aggregateRows = buildExperimentAggregateRows(rows, packages);
  const winner = aggregateRows.slice().sort((a, b) => b.totalSuccessRate - a.totalSuccessRate)[0] || rows[0];
  const maxShare = Math.max(...aggregateRows.map((row) => row.share), ...rows.map((row) => row.share));
  const winnerConfidence = getExperimentConfidenceValue(winner?.share, winner?.uplift);
  const winnerConfidenceInterval = getExperimentRateConfidenceInterval(winner?.totalSuccessRate, winner?.share);
  PageHooks.mounted = () => scheduleExperimentLabAnalysisCharts(rows, packages);
  return `
    ${UI.pageHeader({
      title: "实验报告-转化率",
      desc: "查看实验组在分享打开、安装、回流链路中的转化率表现，并对比主配置与对照组差异。",
      actions: `
        <button onclick="navigate('/ops/share-config/lab/retention')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">查看留存率报告</button>
        <button onclick="navigate('/ops/share-config/lab')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回实验室</button>
        <button onclick="confirmAction('导出实验报告-转化率', '确认导出当前实验组的转化率数据分析报告吗？', '确认导出', '报告已生成')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">导出报告</button>
      `,
    })}

    <div class="card p-4 mb-5">
      <div class="grid grid-cols-12 gap-3 items-end">
        <label class="col-span-4 block">
          <span class="block text-xs font-medium text-ink-500 mb-1.5">实验组</span>
          <select class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm bg-white">
            <option>6 月社交渠道卡片样式对照</option>
            <option>Discord 富媒体样式实验</option>
            <option>欧美活动落地页文案对照</option>
          </select>
        </label>
        <label class="col-span-3 block">
          <span class="block text-xs font-medium text-ink-500 mb-1.5">包体范围</span>
          <select id="experiment-report-package-filter" onchange="scheduleExperimentLabAnalysisCharts(window.__experimentReportRows || [], window.__experimentReportPackages || [])" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm bg-white">
            <option value="all">全部包体总和</option>
            ${packages.map((pkg) => `<option value="${pkg.id}">${packageFullName(pkg)}</option>`).join("")}
          </select>
        </label>
        <div class="col-span-5 rounded-lg border border-ok-100 bg-ok-50 px-3 py-2.5">
          <div class="text-xs font-semibold text-ok-700">领先配置</div>
          <div class="text-sm text-ok-700 mt-0.5 truncate">${winner?.role || "—"} · 总成功 ${winner?.totalSuccessRate || "—"}%</div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-5 gap-4 mb-5">
      ${renderExperimentAnalysisMetric("实验配置", `${rows.length} 组`, "配置对照", "同一口径对比", "brand")}
      ${renderExperimentAnalysisMetric("覆盖包体", `${packages.length} 个`, "可筛选", "全部包体总和 / 单包体", "blue")}
      ${renderExperimentAnalysisMetric("最大样本", UI.fmtNum(maxShare), "分享次数", "当前口径单配置最大样本", "ok")}
      ${renderExperimentAnalysisMetric("最高总成功率", `${Math.max(...aggregateRows.map((row) => row.totalSuccessRate)).toFixed(1)}%`, "安装 + 回流", `${winner?.role || "—"}`, "green")}
      ${renderExperimentAnalysisMetric("置信度", `${winnerConfidence}%`, winnerConfidenceInterval, "95% 置信区间", "amber")}
    </div>

    <div class="grid grid-cols-12 gap-5 mb-5">
      <div class="col-span-7 card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
          <h3 class="text-sm font-semibold text-ink-900">转化率漏斗对比</h3>
          <span id="experiment-lab-funnel-scope" class="badge bg-brand-50 text-brand-700">全部包体总和</span>
        </div>
        <div id="experiment-lab-funnel-chart" class="h-[360px]"></div>
      </div>
      <div class="col-span-5 card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100">
          <h3 class="text-sm font-semibold text-ink-900">漏斗差异结论</h3>
        </div>
        <div class="p-5 space-y-3">
          ${renderExperimentFunnelConclusion("打开", aggregateRows, "openRate")}
          ${renderExperimentFunnelConclusion("点击安装", aggregateRows, "installClickRate")}
          ${renderExperimentFunnelConclusion("成功安装", aggregateRows, "installSuccessRate")}
          ${renderExperimentFunnelConclusion("点击回流", aggregateRows, "reflowClickRate")}
          ${renderExperimentFunnelConclusion("成功回流", aggregateRows, "reflowSuccessRate")}
        </div>
      </div>
    </div>

    <div class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">实验组转化漏斗对比</h3>
          <p class="text-xs text-ink-500 mt-0.5">按实验组配置对比各转化环节的转化率，避免受样本量差异影响。</p>
        </div>
        <span class="badge bg-brand-50 text-brand-700">转化率口径</span>
      </div>
      <div id="experiment-lab-group-funnel-chart" class="h-[360px]"></div>
    </div>

    <div class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
        <h3 class="text-sm font-semibold text-ink-900">配置数据明细</h3>
        <span class="text-xs text-ink-400">按总成功率降序</span>
      </div>
      <div class="overflow-x-auto">
      <table class="min-w-[1520px] w-full text-xs">
        <thead class="bg-ink-50 text-xs text-ink-500 border-b border-ink-100">
          <tr>
            <th class="text-left px-4 py-3 font-medium">配置角色</th>
            <th class="text-left px-4 py-3 font-medium">活动配置</th>
            <th class="text-right px-4 py-3 font-medium">总分享数</th>
            <th class="text-right px-4 py-3 font-medium">总打开数</th>
            <th class="text-right px-4 py-3 font-medium">打开转化率</th>
            <th class="text-right px-4 py-3 font-medium">点击安装数</th>
            <th class="text-right px-4 py-3 font-medium">点击安装率</th>
            <th class="text-right px-4 py-3 font-medium">成功安装数</th>
            <th class="text-right px-4 py-3 font-medium">成功安装率</th>
            <th class="text-right px-4 py-3 font-medium">点击回流数</th>
            <th class="text-right px-4 py-3 font-medium">点击回流率</th>
            <th class="text-right px-4 py-3 font-medium">成功回流数</th>
            <th class="text-right px-4 py-3 font-medium">成功回流率</th>
            <th class="text-right px-4 py-3 font-medium">95%置信区间</th>
            <th class="text-right px-4 py-3 font-medium">置信度</th>
          </tr>
        </thead>
        <tbody>
          ${aggregateRows.slice().sort((a, b) => b.totalSuccessRate - a.totalSuccessRate).map(renderExperimentAnalysisRow).join("")}
        </tbody>
      </table>
      </div>
    </div>

    <div class="card px-5 py-4 mb-4">
      <div class="flex items-center justify-between gap-3">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">核心指标趋势</h3>
          <p class="text-xs text-ink-500 mt-1">每张图可单独选择对照组和时间周期，独立查看变化趋势。</p>
        </div>
        <span class="badge bg-brand-50 text-brand-700">独立筛选图表</span>
      </div>
    </div>

    <div class="space-y-4">
      ${getExperimentTrendMetricDefs().map((metric) => `
        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
            <div class="flex items-center gap-2">
              <span class="inline-block w-2 h-2 rounded-full" style="background:${metric.color}"></span>
              <span class="text-sm font-semibold text-ink-900">${metric.label}</span>
            </div>
            <span class="text-[11px] text-ink-400">${metric.desc}</span>
          </div>
          <div class="px-5 py-3 border-b border-ink-100 bg-ink-50/60 flex items-center justify-between gap-4 flex-wrap text-xs">
            <label class="inline-flex items-center gap-2 text-ink-600">
              <span class="font-medium">时间周期</span>
              <select id="experiment-report-time-range-${metric.key}" onchange="scheduleExperimentLabAnalysisCharts(window.__experimentReportRows || [], window.__experimentReportPackages || [])" class="px-2.5 py-1.5 border border-ink-200 rounded-lg bg-white text-xs text-ink-700">
                <option value="7">最近 7 天</option>
                <option value="14">最近 14 天</option>
                <option value="30">最近 30 天</option>
              </select>
            </label>
            <div class="flex items-center gap-2 flex-wrap">
              <span class="font-medium text-ink-500">对照组</span>
              ${rows.map((row) => `
                <label class="inline-flex items-center gap-1.5 px-2 py-1 rounded-lg border border-ink-100 bg-white text-ink-700 cursor-pointer hover:bg-ink-50">
                  <input type="checkbox" class="rounded border-ink-300" data-experiment-trend-metric="${metric.key}" data-experiment-trend-role="${row.role}" checked onchange="scheduleExperimentLabAnalysisCharts(window.__experimentReportRows || [], window.__experimentReportPackages || [])" />
                  <span>${row.role}</span>
                </label>
              `).join("")}
            </div>
          </div>
          <div id="experiment-lab-trend-${metric.key}" class="h-[280px]"></div>
        </div>
      `).join("")}
    </div>
  `;
};

Pages.shareConfigLabRetention = function () {
  const configs = getSortedShareConfigs((MOCK.SHARE_CONFIGS || []).filter((c) => c.scope === "package_set"));
  const primary = configs[0];
  const variants = configs.slice(1, 4);
  const rows = buildExperimentRetentionRows(primary, variants);
  const packages = getExperimentAnalysisPackages();
  const aggregateRows = buildExperimentRetentionAggregateRows(rows, packages);
  const sortedRows = aggregateRows.slice().sort((a, b) => getExperimentRetentionScore(b) - getExperimentRetentionScore(a));
  const best = sortedRows[0] || rows[0];
  const avg = (key) => aggregateRows.length ? Number((aggregateRows.reduce((sum, row) => sum + Number(row[key] || 0), 0) / aggregateRows.length).toFixed(1)) : 0;
  const totalUsers = aggregateRows.reduce((sum, row) => sum + Number(row.activated || 0), 0);
  const avgConfidence = aggregateRows.length ? Number((aggregateRows.reduce((sum, row) => sum + getExperimentConfidenceValue(row.activated, row.uplift), 0) / aggregateRows.length).toFixed(1)) : 0;
  PageHooks.mounted = () => scheduleExperimentLabRetentionCharts(rows, packages);
  return `
    ${UI.pageHeader({
      title: "实验报告-留存率",
      desc: "按实验配置查看分享转化新用户的次留、3留、7留、14留、30留表现。",
      actions: `
        <button onclick="navigate('/ops/share-config/lab/analysis')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">查看转化率报告</button>
        <button onclick="navigate('/ops/share-config/lab')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回实验室</button>
        <button onclick="confirmAction('导出实验报告-留存率', '确认导出当前实验组的留存率数据分析报告吗？', '确认导出', '报告已生成')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">导出留存</button>
      `,
    })}

    <div class="card p-4 mb-5">
      <div class="grid grid-cols-12 gap-3 items-end">
        <label class="col-span-3 block"><span class="block text-xs font-medium text-ink-500 mb-1.5">实验组</span><select class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white"><option>6 月社交渠道卡片样式对照</option><option>Discord 富媒体样式实验</option><option>欧美活动落地页文案对照</option></select></label>
        <label class="col-span-3 block"><span class="block text-xs font-medium text-ink-500 mb-1.5">包体范围</span><select id="experiment-retention-package-filter" onchange="scheduleExperimentLabRetentionCharts(window.__experimentRetentionRows || [], window.__experimentRetentionPackages || [])" class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white"><option value="all">全部包体总和</option>${packages.map((pkg) => `<option value="${pkg.id}">${packageFullName(pkg)}</option>`).join("")}</select></label>
        <label class="col-span-3 block"><span class="block text-xs font-medium text-ink-500 mb-1.5">活动配置</span><input class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg" placeholder="搜索实验配置名称" /></label>
        <label class="col-span-3 block"><span class="block text-xs font-medium text-ink-500 mb-1.5">排序</span><select class="w-full px-3 py-2.5 text-sm border border-ink-200 rounded-lg bg-white"><option>留存综合分从高到低</option><option>30留从高到低</option><option>分享转化新用户从高到低</option></select></label>
      </div>
    </div>

    <div class="grid grid-cols-6 gap-4 mb-5">
      ${renderExperimentAnalysisMetric("转化新用户", UI.fmtNum(totalUsers), "+6.8%", "成功安装口径", "brand")}
      ${renderExperimentAnalysisMetric("平均次留", `${avg("d1")}%`, "+2.1%", "D1 retention", "ok")}
      ${renderExperimentAnalysisMetric("平均7留", `${avg("d7")}%`, "+1.4%", "D7 retention", "blue")}
      ${renderExperimentAnalysisMetric("平均30留", `${avg("d30")}%`, "-0.3%", "D30 retention", "amber")}
      ${renderExperimentAnalysisMetric("平均置信度", `${avgConfidence}%`, "95% CI", "基于样本量和差异", "ok")}
      ${renderExperimentAnalysisMetric("最佳配置", best?.role || "—", "Top", "按留存综合分", "green")}
    </div>

    <div class="card overflow-hidden mb-5">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between gap-3">
        <div>
          <h3 class="text-sm font-semibold text-ink-900">实验组留存率对比</h3>
          <p class="text-xs text-ink-500 mt-0.5">按实验组配置对比次留、3留、7留、14留、30留，统一使用留存率口径。</p>
        </div>
        <span id="experiment-retention-scope" class="badge bg-brand-50 text-brand-700">全部包体总和</span>
      </div>
      <div id="experiment-retention-overview-chart" class="h-[360px]"></div>
    </div>

    <div class="card overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
        <div><h3 class="text-sm font-semibold text-ink-900">实验组用户留存分析表</h3><p class="text-xs text-ink-500 mt-0.5">按实验配置聚合其带来的分享转化新用户，展示次留、3留、7留、14留、30留。</p></div>
        <span class="text-xs text-ink-400">共 ${aggregateRows.length} 条</span>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full min-w-[1520px] text-sm">
          <thead class="bg-ink-50 text-xs text-ink-500 border-b border-ink-100"><tr><th class="px-4 py-3 text-left font-medium">实验配置</th><th class="px-4 py-3 text-right font-medium">分享转化新用户</th><th class="px-4 py-3 text-right font-medium">次留</th><th class="px-4 py-3 text-right font-medium">3留</th><th class="px-4 py-3 text-right font-medium">7留</th><th class="px-4 py-3 text-right font-medium">14留</th><th class="px-4 py-3 text-right font-medium">30留</th><th class="px-4 py-3 text-right font-medium">留存综合分</th><th class="px-4 py-3 text-right font-medium">95%置信区间</th><th class="px-4 py-3 text-right font-medium">置信度</th></tr></thead>
          <tbody>${sortedRows.map(renderExperimentRetentionAnalysisRow).join("")}</tbody>
        </table>
      </div>
    </div>
  `;
};

function getExperimentConfidenceValue(sample = 0, effect = 0) {
  const n = Math.max(1, Number(sample) || 0);
  const sampleScore = Math.min(15, Math.log10(n) * 3.2);
  const effectScore = Math.min(4, Math.abs(Number(effect) || 0) * 0.8);
  return Number(Math.min(99.5, Math.max(80, 80 + sampleScore + effectScore)).toFixed(1));
}

function getExperimentRateConfidenceInterval(rate = 0, sample = 0) {
  const p = Math.min(0.999, Math.max(0.001, (Number(rate) || 0) / 100));
  const n = Math.max(1, Number(sample) || 0);
  const margin = 1.96 * Math.sqrt((p * (1 - p)) / n) * 100;
  return `±${Math.max(0.1, margin).toFixed(1)}%`;
}

function renderExperimentConfidenceBadge(value) {
  const tone = Number(value) >= 95 ? "bg-ok-50 text-ok-700" : Number(value) >= 90 ? "bg-brand-50 text-brand-700" : "bg-warn-50 text-warn-700";
  return `<span class="badge ${tone}">${value}%</span>`;
}

function calculateExperimentShareDataRates(row) {
  const openRate = Number(((row.open / Math.max(1, row.share)) * 100).toFixed(1));
  const installClickRate = Number(((row.installStart / Math.max(1, row.open)) * 100).toFixed(1));
  const installSuccessRate = Number(((row.installSuccess / Math.max(1, row.installStart)) * 100).toFixed(1));
  const reflowClickRate = Number(((row.reflowStart / Math.max(1, row.open)) * 100).toFixed(1));
  const reflowSuccessRate = Number(((row.reflowSuccess / Math.max(1, row.reflowStart)) * 100).toFixed(1));
  const totalSuccessRate = Number((((row.installSuccess + row.reflowSuccess) / Math.max(1, row.share)) * 100).toFixed(1));
  return { ...row, openRate, installClickRate, installSuccessRate, reflowClickRate, reflowSuccessRate, totalSuccessRate };
}

function buildExperimentAnalysisRows(primary, variants = []) {
  const all = [primary, ...variants].filter(Boolean);
  const presets = [
    { share: 42000, openRate: 28.2, installClickRate: 16.5, installSuccessRate: 62.4, reflowClickRate: 14.6, reflowSuccessRate: 58.2 },
    { share: 31800, openRate: 31.8, installClickRate: 18.6, installSuccessRate: 66.1, reflowClickRate: 16.8, reflowSuccessRate: 61.4 },
    { share: 28600, openRate: 30.6, installClickRate: 17.9, installSuccessRate: 64.8, reflowClickRate: 15.9, reflowSuccessRate: 60.2 },
    { share: 26200, openRate: 27.4, installClickRate: 15.8, installSuccessRate: 59.6, reflowClickRate: 13.8, reflowSuccessRate: 55.4 },
  ];
  return all.map((cfg, idx) => {
    const preset = presets[idx] || { share: 18000, openRate: 25.1, installClickRate: 14.2, installSuccessRate: 58.5, reflowClickRate: 12.6, reflowSuccessRate: 52.8 };
    const open = Math.round(preset.share * preset.openRate / 100);
    const installStart = Math.round(open * preset.installClickRate / 100);
    const installSuccess = Math.round(installStart * preset.installSuccessRate / 100);
    const reflowStart = Math.round(open * preset.reflowClickRate / 100);
    const reflowSuccess = Math.round(reflowStart * preset.reflowSuccessRate / 100);
    return calculateExperimentShareDataRates({
      id: cfg.id,
      role: idx === 0 ? "主配置" : `对照组 ${idx}`,
      name: cfg.name,
      title: cfg.title,
      share: preset.share,
      open,
      installStart,
      installSuccess,
      reflowStart,
      reflowSuccess,
      status: cfg.status,
    });
  });
}

function getExperimentAnalysisPackages() {
  const packages = getOpsVisiblePackages().filter((pkg) => pkg.game_id === "g_001");
  return (packages.length ? packages : getOpsVisiblePackages()).slice(0, 4);
}

function buildExperimentAnalysisPackageRows(rows = [], packages = []) {
  const packageFactors = [
    { share: 1, open: 0, installClick: 0, installSuccess: 0, reflowClick: 0, reflowSuccess: 0 },
    { share: 0.86, open: -1.2, installClick: -0.8, installSuccess: -1.6, reflowClick: -0.4, reflowSuccess: -1.2 },
    { share: 0.42, open: 1.6, installClick: 1.1, installSuccess: 1.4, reflowClick: 0.8, reflowSuccess: 1.1 },
    { share: 0.34, open: -0.5, installClick: 0.6, installSuccess: -0.9, reflowClick: 0.5, reflowSuccess: -1.4 },
  ];
  const result = packages.flatMap((pkg, pkgIdx) => {
    const factor = packageFactors[pkgIdx] || packageFactors[0];
    const platformLift = String(pkg.platform || "").includes("iOS") ? 0.4 : -0.2;
    return rows.map((row, rowIdx) => {
      const configLift = rowIdx === 1 ? 0.5 : rowIdx === 2 ? 0.2 : rowIdx === 3 ? -0.3 : 0;
      const share = Math.max(1000, Math.round(row.share * factor.share * (1 - rowIdx * 0.04)));
      const openRate = Math.max(5, row.openRate + factor.open + platformLift + configLift);
      const installClickRate = Math.max(4, row.installClickRate + factor.installClick + platformLift * 0.5 + configLift * 0.6);
      const installSuccessRate = Math.max(35, row.installSuccessRate + factor.installSuccess + platformLift * 0.4 + configLift * 0.5);
      const reflowClickRate = Math.max(4, row.reflowClickRate + factor.reflowClick + platformLift * 0.3 + configLift * 0.4);
      const reflowSuccessRate = Math.max(35, row.reflowSuccessRate + factor.reflowSuccess + platformLift * 0.3 + configLift * 0.4);
      const open = Math.round(share * openRate / 100);
      const installStart = Math.round(open * installClickRate / 100);
      const installSuccess = Math.round(installStart * installSuccessRate / 100);
      const reflowStart = Math.round(open * reflowClickRate / 100);
      const reflowSuccess = Math.round(reflowStart * reflowSuccessRate / 100);
      return calculateExperimentShareDataRates({ ...row, packageId: pkg.id, packageLabel: packageFullName(pkg), share, open, installStart, installSuccess, reflowStart, reflowSuccess });
    });
  });
  packages.forEach((pkg) => {
    const pkgRows = result.filter((row) => row.packageId === pkg.id);
    const base = pkgRows[0];
    pkgRows.forEach((row) => {
      row.uplift = base ? Number((row.totalSuccessRate - base.totalSuccessRate).toFixed(1)) : 0;
    });
  });
  return result;
}

function buildExperimentAggregateRows(rows = [], packages = []) {
  const packageRows = buildExperimentAnalysisPackageRows(rows, packages.length ? packages : getExperimentAnalysisPackages());
  const grouped = new Map();
  packageRows.forEach((row) => {
    const item = grouped.get(row.role) || { ...row, share: 0, open: 0, installStart: 0, installSuccess: 0, reflowStart: 0, reflowSuccess: 0 };
    item.share += Number(row.share) || 0;
    item.open += Number(row.open) || 0;
    item.installStart += Number(row.installStart) || 0;
    item.installSuccess += Number(row.installSuccess) || 0;
    item.reflowStart += Number(row.reflowStart) || 0;
    item.reflowSuccess += Number(row.reflowSuccess) || 0;
    grouped.set(row.role, item);
  });
  const result = Array.from(grouped.values()).map((item) => calculateExperimentShareDataRates({ ...item, packageId: "all", packageLabel: "全部包体总和" }));
  const base = result[0];
  result.forEach((row) => {
    row.uplift = base ? Number((row.totalSuccessRate - base.totalSuccessRate).toFixed(1)) : 0;
  });
  return result;
}

function getSelectedExperimentReportPackageId() {
  return document.getElementById("experiment-report-package-filter")?.value || "all";
}

function getExperimentFunnelAxisLabel(row) {
  const packageLabel = String(row.packageLabel || "").replace(/^[^-]+-/, "");
  return `${packageLabel} ｜ ${row.role}`;
}

function getExperimentFunnelLegend() {
  return {
    top: 14,
    left: 20,
    itemWidth: 16,
    itemHeight: 8,
    itemGap: 18,
    icon: "roundRect",
    textStyle: { color: "#475569", fontSize: 12, fontWeight: 500 },
  };
}

function getExperimentReportFunnelRows(rows = [], packages = []) {
  const selectedPackageId = getSelectedExperimentReportPackageId();
  if (selectedPackageId === "all") return buildExperimentAggregateRows(rows, packages.length ? packages : getExperimentAnalysisPackages());
  const packageRows = buildExperimentAnalysisPackageRows(rows, packages.length ? packages : getExperimentAnalysisPackages());
  return packageRows.filter((row) => row.packageId === selectedPackageId);
}

function renderExperimentPackageConclusion(pkg, packageRows = []) {
  const rows = packageRows.filter((row) => row.packageId === pkg.id);
  const best = rows.slice().sort((a, b) => b.totalSuccessRate - a.totalSuccessRate)[0];
  const base = rows[0];
  const diff = best && base ? Number((best.totalSuccessRate - base.totalSuccessRate).toFixed(1)) : 0;
  const tone = diff >= 0 ? "bg-ok-50 text-ok-700" : "bg-danger-50 text-danger-700";
  return `
    <div class="rounded-xl border border-ink-100 bg-white p-3">
      <div class="flex items-center justify-between gap-3">
        <div class="min-w-0">
          <div class="text-xs text-ink-500 truncate">${packageFullName(pkg)}</div>
          <div class="text-sm font-semibold text-ink-900 mt-0.5">${best?.role || "—"}</div>
        </div>
        <span class="badge ${tone}">${diff >= 0 ? "+" : ""}${diff}%</span>
      </div>
      <div class="text-xs text-ink-500 mt-2 truncate">总成功率 ${best?.totalSuccessRate || "—"}% · ${best?.name || "—"}</div>
    </div>
  `;
}

function renderExperimentAnalysisMetric(label, value, delta, sub, color = "brand") {
  const colorMap = {
    brand: "text-brand-700 bg-brand-50",
    ok: "text-ok-700 bg-ok-50",
    blue: "text-brand-700 bg-brand-50",
    green: "text-ok-700 bg-ok-50",
    amber: "text-warn-700 bg-warn-50",
    rose: "text-danger-700 bg-danger-50",
  };
  return `
    <div class="card p-4">
      <div class="text-xs text-ink-500">${label}</div>
      <div class="mt-2 flex items-end justify-between gap-2">
        <div class="num text-2xl font-semibold text-ink-900">${value}</div>
        <span class="badge ${colorMap[color] || colorMap.brand}">${delta}</span>
      </div>
      <div class="text-xs text-ink-400 mt-2">${sub}</div>
    </div>
  `;
}

function renderExperimentInsightLine(label, value, tone = "brand") {
  const cls = tone === "ok" ? "bg-ok-50 text-ok-700" : tone === "warn" ? "bg-warn-50 text-warn-700" : "bg-brand-50 text-brand-700";
  return `<div class="flex items-center justify-between gap-3"><span class="text-ink-500">${label}</span><span class="badge ${cls}">${value}</span></div>`;
}

function renderExperimentAnalysisRow(row) {
  const confidence = getExperimentConfidenceValue(row.share, row.uplift);
  const interval = getExperimentRateConfidenceInterval(row.totalSuccessRate, row.share);
  return `
    <tr class="border-b last:border-b-0 border-ink-100 row-hover">
      <td class="px-4 py-3"><span class="badge ${row.role === "主配置" ? "bg-brand-50 text-brand-700" : "bg-ink-100 text-ink-700"}">${row.role}</span></td>
      <td class="px-4 py-3 min-w-[220px]"><div class="font-medium text-ink-900 truncate">${row.name}</div><div class="text-xs text-ink-500 truncate mt-0.5">${row.title || "—"}</div></td>
      <td class="px-4 py-3 text-right num text-ink-700">${UI.fmtNum(row.share)}</td>
      <td class="px-4 py-3 text-right num text-ink-700">${UI.fmtNum(row.open)}</td>
      <td class="px-4 py-3 text-right num font-medium text-brand-700">${row.openRate}%</td>
      <td class="px-4 py-3 text-right num text-ink-700">${UI.fmtNum(row.installStart)}</td>
      <td class="px-4 py-3 text-right num text-brand-700">${row.installClickRate}%</td>
      <td class="px-4 py-3 text-right num text-ok-700">${UI.fmtNum(row.installSuccess)}</td>
      <td class="px-4 py-3 text-right num text-brand-700">${row.installSuccessRate}%</td>
      <td class="px-4 py-3 text-right num text-ink-700">${UI.fmtNum(row.reflowStart)}</td>
      <td class="px-4 py-3 text-right num text-brand-700">${row.reflowClickRate}%</td>
      <td class="px-4 py-3 text-right num text-ok-700">${UI.fmtNum(row.reflowSuccess)}</td>
      <td class="px-4 py-3 text-right num text-brand-700">${row.reflowSuccessRate}%</td>
      <td class="px-4 py-3 text-right num text-ink-700">${interval}</td>
      <td class="px-4 py-3 text-right">${renderExperimentConfidenceBadge(confidence)}</td>
    </tr>
  `;
}

function renderExperimentFunnelConclusion(stage, rows, key) {
  const sorted = rows.slice().sort((a, b) => Number(b[key]) - Number(a[key]));
  const best = sorted[0];
  const base = rows[0];
  const diff = best && base ? Number((best[key] - base[key]).toFixed(1)) : 0;
  const tone = diff >= 0 ? "bg-ok-50 text-ok-700" : "bg-danger-50 text-danger-700";
  return `
    <div class="rounded-xl border border-ink-100 bg-white p-3">
      <div class="flex items-center justify-between gap-3">
        <div>
          <div class="text-xs text-ink-500">${stage}阶段最佳</div>
          <div class="text-sm font-semibold text-ink-900 mt-0.5">${best?.role || "—"}</div>
        </div>
        <span class="badge ${tone}">${diff >= 0 ? "+" : ""}${diff}%</span>
      </div>
      <div class="text-xs text-ink-500 mt-2 truncate">${best?.name || "—"}</div>
    </div>
  `;
}

function buildExperimentRetentionRows(primary, variants = []) {
  const all = [primary, ...variants].filter(Boolean);
  const presets = [
    { activated: 12600, d1: 38.2, d3: 25.6, d7: 16.8, d14: 11.4, d30: 7.2 },
    { activated: 10120, d1: 41.5, d3: 28.4, d7: 19.2, d14: 13.1, d30: 8.6 },
    { activated: 9340, d1: 40.1, d3: 27.5, d7: 18.3, d14: 12.4, d30: 8.1 },
    { activated: 8520, d1: 36.8, d3: 24.1, d7: 15.2, d14: 10.2, d30: 6.5 },
  ];
  return all.map((cfg, idx) => {
    const preset = presets[idx] || { activated: 6800, d1: 35.6, d3: 22.8, d7: 14.6, d14: 9.8, d30: 6.1 };
    return {
      id: cfg.id,
      role: idx === 0 ? "主配置" : `对照组 ${idx}`,
      name: cfg.name,
      title: cfg.title,
      status: cfg.status,
      activated: preset.activated,
      d1: preset.d1,
      d3: preset.d3,
      d7: preset.d7,
      d14: preset.d14,
      d30: preset.d30,
    };
  });
}

function buildExperimentRetentionPackageRows(rows = [], packages = []) {
  const packageFactors = [
    { user: 1, d1: 0, d3: 0, d7: 0, d14: 0, d30: 0 },
    { user: 0.84, d1: -1.1, d3: -0.9, d7: -0.8, d14: -0.6, d30: -0.4 },
    { user: 0.48, d1: 1.4, d3: 1.2, d7: 1.0, d14: 0.8, d30: 0.5 },
    { user: 0.36, d1: -0.4, d3: 0.3, d7: 0.5, d14: 0.4, d30: 0.2 },
  ];
  return packages.flatMap((pkg, pkgIdx) => {
    const factor = packageFactors[pkgIdx] || packageFactors[0];
    const platformLift = String(pkg.platform || "").includes("iOS") ? 0.5 : -0.2;
    return rows.map((row, rowIdx) => {
      const configLift = rowIdx === 1 ? 0.7 : rowIdx === 2 ? 0.3 : rowIdx === 3 ? -0.4 : 0;
      return {
        ...row,
        packageId: pkg.id,
        packageLabel: packageFullName(pkg),
        activated: Math.max(1000, Math.round(row.activated * factor.user * (1 - rowIdx * 0.035))),
        d1: Number(Math.max(8, row.d1 + factor.d1 + platformLift + configLift).toFixed(1)),
        d3: Number(Math.max(5, row.d3 + factor.d3 + platformLift * 0.8 + configLift).toFixed(1)),
        d7: Number(Math.max(3, row.d7 + factor.d7 + platformLift * 0.6 + configLift * 0.8).toFixed(1)),
        d14: Number(Math.max(2, row.d14 + factor.d14 + platformLift * 0.4 + configLift * 0.6).toFixed(1)),
        d30: Number(Math.max(1, row.d30 + factor.d30 + platformLift * 0.3 + configLift * 0.4).toFixed(1)),
      };
    });
  });
}

function buildExperimentRetentionAggregateRows(rows = [], packages = []) {
  const packageRows = buildExperimentRetentionPackageRows(rows, packages.length ? packages : getExperimentAnalysisPackages());
  const grouped = new Map();
  packageRows.forEach((row) => {
    const item = grouped.get(row.role) || { ...row, activated: 0, d1Sum: 0, d3Sum: 0, d7Sum: 0, d14Sum: 0, d30Sum: 0 };
    const activated = Number(row.activated) || 0;
    item.activated += activated;
    item.d1Sum += (Number(row.d1) || 0) * activated;
    item.d3Sum += (Number(row.d3) || 0) * activated;
    item.d7Sum += (Number(row.d7) || 0) * activated;
    item.d14Sum += (Number(row.d14) || 0) * activated;
    item.d30Sum += (Number(row.d30) || 0) * activated;
    grouped.set(row.role, item);
  });
  const result = Array.from(grouped.values()).map((item) => ({
    ...item,
    packageId: "all",
    packageLabel: "全部包体总和",
    d1: Number((item.d1Sum / Math.max(1, item.activated)).toFixed(1)),
    d3: Number((item.d3Sum / Math.max(1, item.activated)).toFixed(1)),
    d7: Number((item.d7Sum / Math.max(1, item.activated)).toFixed(1)),
    d14: Number((item.d14Sum / Math.max(1, item.activated)).toFixed(1)),
    d30: Number((item.d30Sum / Math.max(1, item.activated)).toFixed(1)),
  }));
  const base = result[0];
  result.forEach((row) => {
    row.uplift = base ? Number((getExperimentRetentionScore(row) - getExperimentRetentionScore(base)).toFixed(1)) : 0;
  });
  return result;
}

function getSelectedExperimentRetentionPackageId() {
  return document.getElementById("experiment-retention-package-filter")?.value || "all";
}

function getExperimentRetentionRowsForScope(rows = [], packages = []) {
  const selectedPackageId = getSelectedExperimentRetentionPackageId();
  if (selectedPackageId === "all") return buildExperimentRetentionAggregateRows(rows, packages.length ? packages : getExperimentAnalysisPackages());
  return buildExperimentRetentionPackageRows(rows, packages.length ? packages : getExperimentAnalysisPackages()).filter((row) => row.packageId === selectedPackageId);
}

function getExperimentRetentionMetricDefs() {
  return [
    { key: "d1", label: "次日留存", color: "#1E3A8A" },
    { key: "d3", label: "3 日留存", color: "#0F766E" },
    { key: "d7", label: "7 日留存", color: "#16A34A" },
    { key: "d14", label: "14 日留存", color: "#D97706" },
    { key: "d30", label: "30 日留存", color: "#7C3AED" },
  ];
}

function getExperimentRetentionScore(row = {}) {
  return Number((Number(row.d1 || 0) * 0.18 + Number(row.d3 || 0) * 0.22 + Number(row.d7 || 0) * 0.26 + Number(row.d14 || 0) * 0.18 + Number(row.d30 || 0) * 0.16).toFixed(1));
}

function renderExperimentRetentionAnalysisRow(row) {
  const score = getExperimentRetentionScore(row);
  const confidence = getExperimentConfidenceValue(row.activated, row.uplift);
  const interval = getExperimentRateConfidenceInterval(row.d7, row.activated);
  return `
    <tr class="border-b last:border-b-0 border-ink-100 row-hover">
      <td class="px-4 py-3 min-w-[260px]"><div class="flex items-center gap-2"><span class="badge ${row.role === "主配置" ? "bg-brand-50 text-brand-700" : "bg-ink-100 text-ink-700"}">${row.role}</span><div class="min-w-0"><div class="font-medium text-ink-900 truncate">${row.name}</div><div class="text-xs text-ink-500 truncate mt-0.5">${row.title || "—"}</div></div></div></td>
      <td class="px-4 py-3 text-right num text-ink-700">${UI.fmtNum(row.activated)}</td>
      <td class="px-4 py-3 text-right num text-brand-700">${row.d1}%</td>
      <td class="px-4 py-3 text-right num text-brand-700">${row.d3}%</td>
      <td class="px-4 py-3 text-right num font-medium text-ok-700">${row.d7}%</td>
      <td class="px-4 py-3 text-right num text-brand-700">${row.d14}%</td>
      <td class="px-4 py-3 text-right num text-brand-700">${row.d30}%</td>
      <td class="px-4 py-3 text-right num font-semibold text-ink-900">${score}</td>
      <td class="px-4 py-3 text-right num text-ink-700">${interval}</td>
      <td class="px-4 py-3 text-right">${renderExperimentConfidenceBadge(confidence)}</td>
    </tr>
  `;
}

function renderExperimentRetentionConclusion(stage, rows, key) {
  const sorted = rows.slice().sort((a, b) => Number(b[key]) - Number(a[key]));
  const best = sorted[0];
  const base = rows[0];
  const diff = best && base ? Number((best[key] - base[key]).toFixed(1)) : 0;
  const tone = diff >= 0 ? "bg-ok-50 text-ok-700" : "bg-danger-50 text-danger-700";
  return `
    <div class="rounded-xl border border-ink-100 bg-white p-3">
      <div class="flex items-center justify-between gap-3">
        <div>
          <div class="text-xs text-ink-500">${stage}最佳</div>
          <div class="text-sm font-semibold text-ink-900 mt-0.5">${best?.role || "—"}</div>
        </div>
        <span class="badge ${tone}">${diff >= 0 ? "+" : ""}${diff}%</span>
      </div>
      <div class="text-xs text-ink-500 mt-2 truncate">${best?.name || "—"}</div>
    </div>
  `;
}

function getSelectedExperimentRetentionRoles(rows = []) {
  const inputs = Array.from(document.querySelectorAll("[data-experiment-retention-role]"));
  const checked = inputs.filter((el) => el.checked).map((el) => el.dataset.experimentRetentionRole);
  return inputs.length ? checked : rows.map((row) => row.role);
}

function getExperimentRetentionTrendDates() {
  const days = Number(document.getElementById("experiment-retention-time-range")?.value || 14);
  const end = new Date(2026, 5, 6);
  const format = (date) => `${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}`;
  return Array.from({ length: days }, (_, idx) => {
    const d = new Date(end);
    d.setDate(end.getDate() - (days - idx - 1));
    return format(d);
  });
}

function getSelectedExperimentRetentionMetricKey() {
  return document.getElementById("experiment-retention-metric-filter")?.value || "d7";
}

function scheduleExperimentLabRetentionCharts(rows, packages = []) {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      renderExperimentLabRetentionCharts(rows, packages);
      setTimeout(() => resizeExperimentLabRetentionCharts(), 80);
    });
  });
}

function resizeExperimentLabRetentionCharts() {
  ["experiment-retention-overview-chart", "experiment-retention-trend-chart"].forEach((id) => {
    const el = document.getElementById(id);
    const chart = el && window.echarts ? echarts.getInstanceByDom(el) : null;
    if (chart) chart.resize();
  });
}

function renderExperimentLabRetentionCharts(rows, packages = []) {
  window.__experimentRetentionRows = rows;
  window.__experimentRetentionPackages = packages.length ? packages : getExperimentAnalysisPackages();
  const chartRows = getExperimentRetentionRowsForScope(rows, window.__experimentRetentionPackages);
  const selectedPackageId = getSelectedExperimentRetentionPackageId();
  const selectedPackage = window.__experimentRetentionPackages.find((pkg) => pkg.id === selectedPackageId);
  const scopeEl = document.getElementById("experiment-retention-scope");
  if (scopeEl) scopeEl.textContent = selectedPackage ? packageFullName(selectedPackage) : "全部包体总和";
  const metricDefs = getExperimentRetentionMetricDefs();
  const overviewEl = document.getElementById("experiment-retention-overview-chart");
  if (overviewEl && window.echarts) {
    const chart = echarts.getInstanceByDom(overviewEl) || echarts.init(overviewEl);
    chart.setOption({
      grid: { top: 58, right: 24, bottom: 34, left: 48 },
      tooltip: UI.chartTooltip({ valueFormatter: (value) => `${value}%` }),
      legend: getExperimentFunnelLegend(),
      xAxis: { type: "category", data: metricDefs.map((metric) => metric.label), axisLine: { show: false }, axisTick: { show: false }, axisLabel: { color: "#64748B", fontSize: 12 } },
      yAxis: UI.chartYAxis({ axisLabel: { color: "#94A3B8", fontSize: 11, formatter: (v) => `${v}%` } }),
      series: chartRows.map((row, idx) => ({
        name: row.role,
        type: "line",
        smooth: true,
        showSymbol: true,
        symbol: "circle",
        symbolSize: 7,
        data: metricDefs.map((metric) => row[metric.key]),
        lineStyle: { width: idx === 0 ? 3 : 2.2, color: UI.BUSINESS_COLORS[idx] },
        itemStyle: { color: UI.BUSINESS_COLORS[idx], borderColor: "#fff", borderWidth: 2 },
        areaStyle: idx === 0 ? { color: "rgba(30, 58, 138, 0.08)" } : undefined,
        emphasis: { focus: "series" },
      })),
    }, true);
    chart.resize();
  }
  const trendEl = document.getElementById("experiment-retention-trend-chart");
  if (trendEl && window.echarts) {
    const chart = echarts.getInstanceByDom(trendEl) || echarts.init(trendEl);
    const dates = getExperimentRetentionTrendDates();
    const metricKey = getSelectedExperimentRetentionMetricKey();
    const metric = metricDefs.find((item) => item.key === metricKey) || metricDefs[2];
    const selectedRoles = new Set(getSelectedExperimentRetentionRoles(chartRows));
    const lineTypes = ["solid", "dashed", "dotted", [8, 4, 2, 4]];
    const make = (base, idx) => dates.map((_, dayIdx) => Number((base + Math.sin((dayIdx + idx) / 2.8) * (1.1 - idx * 0.08) + dayIdx * 0.03).toFixed(1)));
    const series = chartRows.filter((row) => selectedRoles.has(row.role)).map((row, idx) => ({
      name: `${row.role} · ${metric.label}`,
      type: "line",
      smooth: true,
      showSymbol: false,
      symbol: "circle",
      symbolSize: 5,
      emphasis: { focus: "series" },
      lineStyle: { width: idx === 0 ? 2.4 : 2, color: metric.color, type: lineTypes[idx % lineTypes.length] },
      itemStyle: { color: metric.color, borderColor: "#fff", borderWidth: 2 },
      data: make(Number(row[metric.key]) || 0, idx),
    }));
    chart.setOption({
      grid: { top: 44, right: 18, bottom: 30, left: 42 },
      tooltip: UI.chartTooltip({ valueFormatter: (value) => `${value}%` }),
      legend: { type: "scroll", top: 8, left: 12, right: 12, itemWidth: 16, itemHeight: 8, icon: "path://M0,4 L16,4", textStyle: { color: "#64748B", fontSize: 10 } },
      xAxis: UI.chartXAxis(dates),
      yAxis: UI.chartYAxis({ axisLabel: { color: "#94A3B8", fontSize: 10, formatter: (v) => `${v}%` } }),
      series,
    }, true);
    chart.resize();
  }
}

function renderExperimentSegmentCard(name, value, delta, desc) {
  const positive = !String(delta).startsWith("-");
  return `
    <div class="p-5">
      <div class="text-xs text-ink-500">${name}</div>
      <div class="mt-2 flex items-end justify-between gap-2">
        <div class="num text-2xl font-semibold text-ink-900">${value}</div>
        <span class="text-xs font-semibold ${positive ? "text-ok-700" : "text-danger-700"}">${delta}</span>
      </div>
      <div class="text-xs text-ink-400 mt-2">${desc}</div>
    </div>
  `;
}

function scheduleExperimentLabAnalysisCharts(rows, packages = []) {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      renderExperimentLabAnalysisCharts(rows, packages);
      setTimeout(() => resizeExperimentLabAnalysisCharts(), 80);
    });
  });
}

function resizeExperimentLabAnalysisCharts() {
  ["experiment-lab-funnel-chart", "experiment-lab-group-funnel-chart", ...getExperimentTrendMetricDefs().map((metric) => `experiment-lab-trend-${metric.key}`)].forEach((id) => {
    const el = document.getElementById(id);
    const chart = el && window.echarts ? echarts.getInstanceByDom(el) : null;
    if (chart) chart.resize();
  });
}

function renderExperimentLabAnalysisCharts(rows, packages = []) {
  window.__experimentReportRows = rows;
  window.__experimentReportPackages = packages.length ? packages : getExperimentAnalysisPackages();
  const selectedPackageId = getSelectedExperimentReportPackageId();
  const funnelRows = getExperimentReportFunnelRows(rows, window.__experimentReportPackages);
  const selectedPackage = window.__experimentReportPackages.find((pkg) => pkg.id === selectedPackageId);
  const scopeEl = document.getElementById("experiment-lab-funnel-scope");
  if (scopeEl) scopeEl.textContent = selectedPackage ? packageFullName(selectedPackage) : "全部包体总和";

  const trendRows = getExperimentReportTrendRows(funnelRows.length ? funnelRows : rows);
  getExperimentTrendMetricDefs().forEach((metric) => {
    const trendEl = document.getElementById(`experiment-lab-trend-${metric.key}`);
    if (!trendEl || !window.echarts) return;
    const chart = echarts.getInstanceByDom(trendEl) || echarts.init(trendEl);
    const dates = getExperimentReportTrendDates(metric.key);
    const trendSeries = buildExperimentReportTrendSeries(trendRows, dates.length, metric.key);
    const maxTrendValue = Math.max(...trendSeries.flatMap((series) => (series.data || []).map((value) => Number(value)).filter((value) => !Number.isNaN(value))), 1);
    const updateMarks = getExperimentReportUpdateTrendMarks(dates, trendRows, Number((maxTrendValue * 1.08).toFixed(1)), metric.key);
    chart.setOption({
      grid: { top: 52, right: 18, bottom: 30, left: 42 },
      tooltip: UI.chartTooltip({ valueFormatter: (value) => Array.isArray(value) ? value.join("，") : `${value}%` }),
      legend: { type: "scroll", top: 8, left: 12, right: 12, itemWidth: 16, itemHeight: 8, icon: "path://M0,4 L16,4", textStyle: { color: "#64748B", fontSize: 10 } },
      xAxis: UI.chartXAxis(dates),
      yAxis: UI.chartYAxis({ axisLabel: { color: "#94A3B8", fontSize: 10, formatter: (v) => `${v}%` } }),
      series: [
        ...trendSeries,
        ...(updateMarks.length ? [buildExperimentReportUpdateMarkSeries(updateMarks)] : []),
      ],
    }, true);
    chart.resize();
  });
  const funnelEl = document.getElementById("experiment-lab-funnel-chart");
  if (funnelEl && window.echarts) {
    funnelEl.style.height = "360px";
    const chart = echarts.getInstanceByDom(funnelEl) || echarts.init(funnelEl);
    chart.setOption({
      grid: { top: 58, right: 24, bottom: 34, left: 48 },
      tooltip: { ...UI.chartTooltip({ valueFormatter: (value) => `${value}%` }), axisPointer: { type: "shadow" } },
      legend: getExperimentFunnelLegend(),
      xAxis: { type: "category", data: ["打开转化率", "点击安装率", "成功安装率", "点击回流率", "成功回流率"], axisLine: { show: false }, axisTick: { show: false }, axisLabel: { color: "#64748B", fontSize: 12 } },
      yAxis: UI.chartYAxis({ axisLabel: { color: "#94A3B8", fontSize: 11, formatter: (v) => `${v}%` } }),
      series: funnelRows.map((row, idx) => UI.chartBarSeries(row.role, [row.openRate, row.installClickRate, row.installSuccessRate, row.reflowClickRate, row.reflowSuccessRate], { color: UI.BUSINESS_COLORS[idx], barWidth: 12 })),
    }, true);
    chart.resize();
  }
  const groupFunnelEl = document.getElementById("experiment-lab-group-funnel-chart");
  if (groupFunnelEl && window.echarts) {
    const chart = echarts.getInstanceByDom(groupFunnelEl) || echarts.init(groupFunnelEl);
    const stages = ["打开转化率", "点击安装率", "成功安装率", "点击回流率", "成功回流率", "总成功率"];
    chart.setOption({
      grid: { top: 58, right: 28, bottom: 36, left: 52 },
      tooltip: UI.chartTooltip({ valueFormatter: (value) => `${value}%` }),
      legend: getExperimentFunnelLegend(),
      xAxis: { type: "category", data: stages, axisLine: { show: false }, axisTick: { show: false }, axisLabel: { color: "#64748B", fontSize: 12 } },
      yAxis: UI.chartYAxis({ axisLabel: { color: "#94A3B8", fontSize: 11, formatter: (value) => `${value}%` } }),
      series: funnelRows.map((row, idx) => ({
        name: row.role,
        type: "line",
        smooth: true,
        showSymbol: true,
        symbol: "circle",
        symbolSize: 7,
        data: [row.openRate, row.installClickRate, row.installSuccessRate, row.reflowClickRate, row.reflowSuccessRate, row.totalSuccessRate],
        lineStyle: { width: idx === 0 ? 3 : 2.2, color: UI.BUSINESS_COLORS[idx] },
        itemStyle: { color: UI.BUSINESS_COLORS[idx], borderColor: "#fff", borderWidth: 2 },
        areaStyle: idx === 0 ? { color: "rgba(30, 58, 138, 0.08)" } : undefined,
        emphasis: { focus: "series" },
      })),
    }, true);
    chart.resize();
  }
}

function getExperimentReportTrendDates(metricKey = "") {
  const metricSelect = metricKey ? document.getElementById(`experiment-report-time-range-${metricKey}`) : null;
  const days = Number(metricSelect?.value || document.getElementById("experiment-report-time-range")?.value || 7);
  const end = new Date(2026, 5, 6);
  const format = (date) => `${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}`;
  return Array.from({ length: days }, (_, idx) => {
    const d = new Date(end);
    d.setDate(end.getDate() - (days - idx - 1));
    return format(d);
  });
}

function getExperimentReportTrendRows(rows = []) {
  const grouped = new Map();
  rows.forEach((row) => {
    const item = grouped.get(row.role) || { id: row.id, role: row.role, name: row.name, title: row.title, openRate: 0, installClickRate: 0, installSuccessRate: 0, reflowClickRate: 0, reflowSuccessRate: 0, count: 0 };
    item.openRate += Number(row.openRate) || 0;
    item.installClickRate += Number(row.installClickRate) || 0;
    item.installSuccessRate += Number(row.installSuccessRate) || 0;
    item.reflowClickRate += Number(row.reflowClickRate) || 0;
    item.reflowSuccessRate += Number(row.reflowSuccessRate) || 0;
    item.count += 1;
    grouped.set(row.role, item);
  });
  return Array.from(grouped.values()).map((item) => ({
    ...item,
    openRate: Number((item.openRate / item.count).toFixed(1)),
    installClickRate: Number((item.installClickRate / item.count).toFixed(1)),
    installSuccessRate: Number((item.installSuccessRate / item.count).toFixed(1)),
    reflowClickRate: Number((item.reflowClickRate / item.count).toFixed(1)),
    reflowSuccessRate: Number((item.reflowSuccessRate / item.count).toFixed(1)),
  }));
}

function getSelectedExperimentReportTrendRoles(rows = [], metricKey = "") {
  const selector = metricKey ? `[data-experiment-trend-metric="${metricKey}"][data-experiment-trend-role]` : "[data-experiment-trend-role]";
  const inputs = Array.from(document.querySelectorAll(selector));
  const checked = inputs.filter((el) => el.checked).map((el) => el.dataset.experimentTrendRole);
  return inputs.length ? checked : rows.map((row) => row.role);
}

function getExperimentReportUpdateTrendMarks(dates = [], rows = [], markY = 0, metricKey = "") {
  const dateSet = new Set(dates);
  const selectedRoles = new Set(getSelectedExperimentReportTrendRoles(rows, metricKey));
  const format = (value) => {
    const d = new Date(String(value || "").replace(" ", "T"));
    if (Number.isNaN(d.getTime())) return "";
    return `${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}`;
  };
  const grouped = new Map();
  rows.filter((row) => selectedRoles.has(row.role) && row.id).forEach((row) => {
    getActivityConfigUpdateLogs(row.id).forEach((log) => {
      const day = format(log.operationTime);
      if (!day || !dateSet.has(day)) return;
      const enriched = { ...log, role: row.role, configName: row.name || row.title || log.activityId };
      grouped.set(day, [...(grouped.get(day) || []), enriched]);
    });
  });
  return Array.from(grouped.entries()).map(([day, logs]) => {
    const changePoints = Array.from(new Set(logs.map((log) => log.trendLabel || log.action)));
    return {
      name: changePoints.join(" + "),
      value: [day, markY],
      logs,
      label: changePoints.length > 2 ? `${changePoints.slice(0, 2).join(" + ")} +${changePoints.length - 2}` : changePoints.join(" + "),
    };
  });
}

function buildExperimentReportUpdateMarkSeries(updateMarks = []) {
  return {
    name: "配置变化点",
    type: "scatter",
    data: updateMarks,
    symbol: "pin",
    symbolSize: 30,
    itemStyle: { color: "#7C3AED" },
    label: {
      show: true,
      formatter: (p) => p.data?.label || "配置更新",
      position: "top",
      color: "#6D28D9",
      fontSize: 10,
      fontWeight: 500,
      backgroundColor: "#F5F3FF",
      borderColor: "#DDD6FE",
      borderWidth: 1,
      borderRadius: 3,
      padding: [2, 4],
    },
    tooltip: {
      formatter: (p) => {
        const logs = p.data?.logs || [];
        return `<b>${p.data?.label || p.name}</b><br/>${p.data?.value?.[0] || ""}<br/>${logs.map((log) => `${log.role || "配置"} · ${log.configName || log.activityId}<br/>${log.operationTime} ${log.trendLabel || log.action}<br/><span style="color:#94a3b8">${log.detail}</span>`).join("<br/>")}`;
      },
    },
    z: 5,
  };
}

function getExperimentTrendMetricDefs() {
  return [
    { key: "openRate", label: "打开转化率", color: "#1E3A8A", amp: 1.2, desc: "打开 / 分享" },
    { key: "installClickRate", label: "点击安装率", color: "#0F766E", amp: 0.9, desc: "点击安装 / 打开" },
    { key: "installSuccessRate", label: "成功安装率", color: "#16A34A", amp: 0.8, desc: "成功安装 / 点击" },
    { key: "reflowClickRate", label: "点击回流率", color: "#B45309", amp: 0.7, desc: "点击回流 / 打开" },
    { key: "reflowSuccessRate", label: "成功回流率", color: "#D97706", amp: 0.8, desc: "成功回流 / 点击" },
  ];
}

function buildExperimentReportTrendSeries(rows = [], length = 7, metricKey = "installClickRate") {
  const selectedRoles = getSelectedExperimentReportTrendRoles(rows, metricKey);
  const metrics = getExperimentTrendMetricDefs().filter((metric) => metric.key === metricKey);
  const lineTypes = ["solid", "dashed", "dotted", [8, 4, 2, 4]];
  const make = (base, amp, offset) => Array.from({ length }, (_, idx) => {
    const wave = Math.sin((idx + offset) / 2.6) * amp;
    const drift = idx * 0.04;
    return Number((base + wave + drift).toFixed(1));
  });
  return rows.filter((row) => selectedRoles.includes(row.role)).flatMap((row, rowIdx) => metrics.map((metric, metricIdx) => {
    const color = metric.color;
    const lineType = lineTypes[rowIdx % lineTypes.length];
    return {
      name: `${row.role} · ${metric.label}`,
      type: "line",
      smooth: true,
      showSymbol: false,
      symbol: "circle",
      symbolSize: 5,
      emphasis: { focus: "series" },
      lineStyle: { width: rowIdx === 0 ? 2.4 : 2, color, type: lineType },
      itemStyle: { color, borderColor: "#fff", borderWidth: 2 },
      data: make(Number(row[metric.key]) || 0, metric.amp, rowIdx * 1.3 + metricIdx * 2),
    };
  }));
}

Pages.shareConfigLabCreate = function () {
  const allConfigs = getSortedShareConfigs((MOCK.SHARE_CONFIGS || []).filter((c) => c.scope === "package_set"));
  const query = location.hash.includes("?") ? location.hash.split("?")[1] : "";
  const params = new URLSearchParams(query);
  const draft = getExperimentLabDraft(allConfigs, { reset: params.get("draft") !== "1" });
  const selectedGame = getExperimentLabSelectedGame(draft);
  const configs = getExperimentConfigsForGame(allConfigs, draft.gameId);
  const primary = configs.find((cfg) => cfg.id === draft.primaryId) || null;
  const variants = (draft.variantIds || []).map((id) => configs.find((cfg) => cfg.id === id)).filter(Boolean).slice(0, 9);
  const weights = getExperimentWeights(Math.max(1, (primary ? 1 : 0) + variants.length));
  const experimentPackages = getOpsVisiblePackages().filter((pkg) => pkg.game_id === selectedGame?.id);
  window.__experimentLabScopePackages = experimentPackages;
  const selectedExperimentConfigs = [primary, ...variants].filter(Boolean);
  const experimentLanguages = getExperimentScopeLanguages(selectedExperimentConfigs);
  const canAddVariant = variants.length < 9;
  const canSave = !!primary && variants.length >= 1;
  return `
    ${UI.pageHeader({
      title: "创建实验组",
      desc: "从空白实验组开始，先选择同一游戏下的主配置和对照配置，再设置包体、地区、语言生效范围；命中范围内统一均匀分流。",
      actions: `
        <button onclick="navigate('/ops/share-config/lab')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回实验室</button>
      `,
    })}

    <div class="grid grid-cols-12 gap-5 items-start">
      <section class="col-span-12 space-y-5">
        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100">
            <h3 class="text-sm font-semibold text-ink-900">基础信息</h3>
            <p class="text-xs text-ink-500 mt-0.5">用于运营识别实验组，并限定实验只在同一款游戏下生效。</p>
          </div>
          <div class="p-5 grid grid-cols-2 gap-4">
            <label class="block">
              <span class="block text-xs font-medium text-ink-500 mb-1.5">选择游戏</span>
              <select onchange="changeExperimentLabGame(this.value)" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm bg-white">
                ${MOCK.GAMES.filter((game) => game.status === "active").map((game) => `<option value="${game.id}" ${game.id === selectedGame?.id ? "selected" : ""}>${game.name}</option>`).join("")}
              </select>
              <span class="block text-[11px] text-ink-400 mt-1">只能单选一款游戏；主配置和对照配置必须属于该游戏。</span>
            </label>
            <label class="block">
              <span class="block text-xs font-medium text-ink-500 mb-1.5">实验组名称</span>
              <input placeholder="请输入实验组名称" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm" />
            </label>
            <label class="block">
              <span class="block text-xs font-medium text-ink-500 mb-1.5">开始时间</span>
              <input type="datetime-local" value="2026-06-06T09:00" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm bg-white" />
            </label>
            <label class="block">
              <span class="block text-xs font-medium text-ink-500 mb-1.5">结束时间</span>
              <input type="datetime-local" value="2026-06-20T18:00" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm bg-white" />
            </label>
          </div>
        </div>

        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
            <div>
              <h3 class="text-sm font-semibold text-ink-900">实验配置</h3>
              <p class="text-xs text-ink-500 mt-0.5">选择 1 个主配置和至少 1 个对照配置；系统自动均匀分流。</p>
            </div>
            <span class="badge bg-brand-50 text-brand-700">${selectedGame?.name || "已选游戏"}</span>
          </div>
          <div class="p-5 space-y-4">
            <div>
              <div class="mb-2 flex items-center justify-between gap-3">
                <div class="text-xs font-semibold text-ink-500">主配置</div>
              </div>
              ${renderExperimentConfigSelector("主配置", primary, primary ? weights[0] : "—", true)}
            </div>

            <div>
              <div class="mb-2 flex items-center justify-between gap-3">
                <div class="text-xs font-semibold text-ink-500">对照配置 <span class="font-normal text-ink-400">${variants.length}/9</span></div>
                <button onclick="startAddExperimentVariant()" ${canAddVariant ? "" : "disabled"} class="px-3 py-1.5 rounded-lg border border-ink-100 text-xs ${canAddVariant ? "text-brand-700 hover:bg-brand-50" : "text-ink-300 cursor-not-allowed"}">+ 添加</button>
              </div>
              <div class="space-y-2">
                ${variants.length ? variants.map((cfg, idx) => renderExperimentConfigSelector(`对照组 ${idx + 1}`, cfg, weights[primary ? idx + 1 : idx], false, idx)).join("") : `
                  <div class="rounded-xl border border-dashed border-ink-200 bg-ink-50/50 px-4 py-4 text-center text-sm text-ink-500">暂无对照配置</div>
                `}
              </div>
            </div>
          </div>
        </div>

        <div class="card overflow-visible">
          <div class="px-5 py-4 border-b border-ink-100">
            <h3 class="text-sm font-semibold text-ink-900">分流与生效策略</h3>
            <p class="text-xs text-ink-500 mt-0.5">先定义实验生效范围，支持包体、地区、语言多条件交叉；未选择的条件默认全部。</p>
          </div>
          <div class="p-5 space-y-5">
            <div class="grid grid-cols-3 gap-3">
              ${renderExperimentScopeConditionGroup("包体", "package", experimentPackages.map((pkg) => ({ value: pkg.id, label: packageFullName(pkg), sub: `${pkg.region} · ${pkg.platform}` })), "不选择则默认全部包体")}
              ${renderExperimentRegionScopeEntry(experimentPackages)}
              ${renderExperimentScopeConditionGroup("语言", "language", experimentLanguages, selectedExperimentConfigs.length ? "来自主配置和对照配置" : "请先选择主配置和对照配置")}
            </div>
            <div class="rounded-xl border border-ink-100 bg-ink-50/60 px-4 py-3">
              <div class="flex items-start gap-3">
                <div class="text-xs font-semibold text-ink-500 pt-1 whitespace-nowrap">已选生效范围</div>
                <div id="experiment-scope-summary" class="flex-1 flex flex-wrap gap-2 text-xs">
                  ${renderExperimentScopeSummaryChips()}
                </div>
              </div>
            </div>
            <div class="rounded-xl border border-brand-100 bg-brand-50 p-4">
              <div class="flex items-center justify-between gap-4">
                <div class="text-sm font-semibold text-brand-900">分流策略：生效范围内均匀分流</div>
                <span class="badge bg-white text-brand-700 border border-brand-100">固定策略</span>
              </div>
            </div>
          </div>
        </div>

        <div class="card px-5 py-4 flex items-center justify-between gap-2">
          <div class="text-xs ${canSave ? "text-ok-700" : "text-ink-500"}">${canSave ? "已满足保存条件" : "请选择 1 个主配置和至少 1 个对照配置后再保存"}</div>
          <div class="flex items-center gap-2">
            <button onclick="navigate('/ops/share-config/lab')" class="px-4 py-2 border border-ink-100 text-sm rounded-lg hover:bg-ink-50">取消</button>
            <button ${canSave ? "" : "disabled"} onclick="saveExperimentLabGroup()" class="px-4 py-2 text-sm rounded-lg ${canSave ? "bg-brand-900 text-white hover:bg-brand-800" : "bg-ink-100 text-ink-400 cursor-not-allowed"}">保存实验组</button>
          </div>
        </div>
      </section>
    </div>
  `;
};

function getExperimentDefaultGameId() {
  return MOCK.GAMES.find((game) => game.status === "active")?.id || MOCK.GAMES[0]?.id || "";
}

function shareConfigBelongsToGame(cfg, gameId) {
  if (!gameId) return true;
  return (cfg.package_ids || []).some((pkgId) => MOCK.PACKAGES.find((pkg) => pkg.id === pkgId)?.game_id === gameId);
}

function getExperimentConfigsForGame(configs = [], gameId = getExperimentDefaultGameId()) {
  return (configs || []).filter((cfg) => shareConfigBelongsToGame(cfg, gameId));
}

function getExperimentLabSelectedGame(draft = getExperimentLabDraft()) {
  return MOCK.GAMES.find((game) => game.id === draft.gameId) || MOCK.GAMES.find((game) => game.status === "active") || MOCK.GAMES[0];
}

function getExperimentLabDraft(configs = [], options = {}) {
  const maxVariants = 9;
  if (options.reset || !window.__experimentLabDraft) {
    window.__experimentLabDraft = { primaryId: null, variantIds: [], gameId: getExperimentDefaultGameId() };
  }
  if (!window.__experimentLabDraft.gameId) window.__experimentLabDraft.gameId = getExperimentDefaultGameId();
  const validIds = new Set((configs || []).filter((cfg) => shareConfigBelongsToGame(cfg, window.__experimentLabDraft.gameId)).map((cfg) => cfg.id));
  window.__experimentLabDraft.primaryId = validIds.has(window.__experimentLabDraft.primaryId) ? window.__experimentLabDraft.primaryId : null;
  window.__experimentLabDraft.variantIds = Array.isArray(window.__experimentLabDraft.variantIds)
    ? window.__experimentLabDraft.variantIds.filter((id) => validIds.has(id) && id !== window.__experimentLabDraft.primaryId).slice(0, maxVariants)
    : [];
  return window.__experimentLabDraft;
}

function resetExperimentLabDraft() {
  window.__experimentLabDraft = { primaryId: null, variantIds: [], gameId: getExperimentDefaultGameId() };
}

window.changeExperimentLabGame = function (gameId) {
  const draft = getExperimentLabDraft();
  draft.gameId = gameId || getExperimentDefaultGameId();
  draft.primaryId = null;
  draft.variantIds = [];
  resetExperimentScopeDraft();
  if (typeof setShareRegionCountrySelection === "function") setShareRegionCountrySelection({ global: true, regions: ["GLOBAL"], countries: [] });
  sessionStorage.removeItem("easyshare:regionCountryPickerContext");
  UI.toast("已切换游戏，请重新选择主配置、对照配置和生效范围", "info");
  const target = "/ops/share-config/lab/create?draft=1";
  if ((typeof getCurrentPathWithQuery === "function" ? getCurrentPathWithQuery() : "") === target) renderRoute();
  else navigate(target);
};

function getExperimentWeights(total) {
  const safeTotal = Math.max(1, total);
  const base = Math.floor(100 / safeTotal);
  const remainder = 100 - base * safeTotal;
  return Array.from({ length: safeTotal }, (_, i) => `${base + (i < remainder ? 1 : 0)}%`);
}

function getExperimentScopeRegions(packages = []) {
  const selectedPackageRegions = new Set(packages.map((pkg) => pkg?.region).filter(Boolean));
  const systemRegions = (typeof window.getShareRegionOptions === "function" ? window.getShareRegionOptions() : []).map((region) => ({
    code: region.code,
    name: `${region.zhName || region.name} / ${region.name}`,
    fromPackage: selectedPackageRegions.has(region.code),
  }));
  return systemRegions.length ? systemRegions : Array.from(selectedPackageRegions).map((code) => ({ code, name: typeof window.regionNameFromCode === "function" ? window.regionNameFromCode(code) : code }));
}

function getExperimentSelectedPackageIdsFromDom() {
  return Array.from(document.querySelectorAll("[data-experiment-scope='package']:checked")).map((item) => item.value).filter(Boolean);
}

function getExperimentScopeDraft() {
  window.__experimentLabScopeDraft = window.__experimentLabScopeDraft || { packageIds: [], packageLabels: [], languageValues: [], languageLabels: [] };
  return window.__experimentLabScopeDraft;
}

function resetExperimentScopeDraft() {
  window.__experimentLabScopeDraft = { packageIds: [], packageLabels: [], languageValues: [], languageLabels: [] };
}

function saveExperimentScopeDraftFromDom() {
  const draft = getExperimentScopeDraft();
  const packages = Array.from(document.querySelectorAll("[data-experiment-scope='package']:checked"));
  const languages = Array.from(document.querySelectorAll("[data-experiment-scope='language']:checked"));
  draft.packageIds = packages.map((item) => item.value).filter(Boolean);
  draft.packageLabels = packages.map((item) => item.dataset.label || item.value).filter(Boolean);
  draft.languageValues = languages.map((item) => item.value).filter(Boolean);
  draft.languageLabels = languages.map((item) => item.dataset.label || item.value).filter(Boolean);
}

function getExperimentRegionSelectionLabels() {
  const selection = typeof getShareRegionCountrySelection === "function" ? getShareRegionCountrySelection() : { global: true, regions: ["GLOBAL"], countries: [] };
  if (selection.global) return [];
  return [...(selection.regions || []).filter((code) => code !== "GLOBAL"), ...(selection.countries || [])];
}

function buildExperimentRegionPickerContext(packages = []) {
  const regionOptions = typeof window.getShareRegionOptions === "function" ? window.getShareRegionOptions() : [];
  const countries = typeof window.getShareCountryOptions === "function" ? window.getShareCountryOptions() : [];
  const regionCodes = new Set();
  const countryCodes = new Set();
  packages.forEach((pkg) => {
    const code = pkg?.region || "GLOBAL";
    if (code === "GLOBAL") {
      regionCodes.add("GLOBAL");
    } else if (regionOptions.some((region) => region.code === code)) {
      regionCodes.add(code);
    } else {
      const country = countries.find((item) => item.code === code);
      if (country) {
        countryCodes.add(country.code);
      } else {
        regionCodes.add(code);
      }
    }
  });
  return {
    scope: "experiment-region",
    packageCount: packages.length,
    packageNames: packages.map((pkg) => packageFullName(pkg)),
    allowedRegionCodes: Array.from(regionCodes),
    allowedCountryCodes: Array.from(countryCodes),
  };
}

function renderExperimentRegionScopeEntry(packages = []) {
  const selection = typeof getShareRegionCountrySelection === "function" ? getShareRegionCountrySelection() : { global: true, regions: ["GLOBAL"], countries: [] };
  const regionLabels = getExperimentRegionSelectionLabels();
  const label = regionLabels.length === 0 ? "全部地区" : regionLabels.length === 1 ? regionLabels[0] : `已选 ${regionLabels.length} 项`;
  const regionCodes = Array.from(new Set((packages || []).map((pkg) => pkg.region || "GLOBAL")));
  return `
    <button type="button" onclick="openExperimentRegionCountryPicker()" class="rounded-xl border border-ink-100 bg-white px-3 py-2.5 text-left hover:border-brand-200 hover:bg-brand-50/30">
      <div class="flex items-center justify-between gap-2">
        <span class="text-xs font-semibold text-ink-500">地区</span>
        <span class="text-xs font-medium text-ink-900 truncate">${label}</span>
      </div>
      <div class="mt-1 flex items-center justify-between gap-2 text-[11px] text-ink-400">
        <span class="truncate">基于已选包体地区：${regionCodes.slice(0, 3).join("、") || "全部"}${regionCodes.length > 3 ? ` 等 ${regionCodes.length} 个` : ""}</span>
        <span class="text-brand-700">选择</span>
      </div>
    </button>
  `;
}

window.openExperimentRegionCountryPicker = function () {
  saveExperimentScopeDraftFromDom();
  const packages = window.__experimentLabScopePackages || [];
  const selectedPackageIds = getExperimentSelectedPackageIdsFromDom();
  const scopedPackages = selectedPackageIds.length ? packages.filter((pkg) => selectedPackageIds.includes(pkg.id)) : packages;
  const context = buildExperimentRegionPickerContext(scopedPackages);
  sessionStorage.setItem("easyshare:regionCountryPickerContext", JSON.stringify(context));
  const returnPath = "/ops/share-config/lab/create?draft=1";
  navigate(`/admin/platform/regions-countries?scope=experiment-region&return=${encodeURIComponent(returnPath)}`);
};

function getExperimentScopeChannels(configs = []) {
  const codes = [...new Set((configs || []).flatMap((cfg) => cfg.channels || []))];
  const channels = codes.map((code) => (MOCK.CHANNELS || []).find((item) => item.code === code) || { code, name: code }).filter(Boolean);
  return channels.length ? channels : (MOCK.CHANNELS || []).filter((item) => item.enabled).slice(0, 6);
}

function getShareConfigLanguageCodes(cfg) {
  const explicit = cfg?.languages || cfg?.language_codes || cfg?.locales || cfg?.locale_codes;
  if (Array.isArray(explicit) && explicit.length) return explicit;
  const regionLanguageMap = {
    US: "en-US", GB: "en-GB", CA: "en-US", AU: "en-AU", SG: "en-US",
    TW: "zh-TW", HK: "zh-HK", MO: "zh-HK", CN: "zh-CN",
    JP: "ja-JP", KR: "ko-KR", TH: "th-TH", VN: "vi-VN", ID: "id-ID", MY: "ms-MY", PH: "fil-PH",
    BR: "pt-BR", PT: "pt-PT", ES: "es-ES", MX: "es-MX", FR: "fr-FR", DE: "de-DE", IT: "it-IT",
    RU: "ru-RU", TR: "tr-TR", SA: "ar-SA", AE: "ar-SA", IN: "hi-IN", PK: "ur-PK",
  };
  const packageIds = cfg?.package_ids || [];
  const packageLanguages = packageIds.map((pkgId) => {
    const pkg = MOCK.PACKAGES.find((item) => item.id === pkgId);
    return regionLanguageMap[pkg?.region] || null;
  }).filter(Boolean);
  return packageLanguages.length ? Array.from(new Set(packageLanguages)) : ["en-US"];
}

function getExperimentLanguageLabel(code) {
  const locale = typeof getShareLanguageCatalog === "function" ? getShareLanguageCatalog().find((item) => item.code === code) : null;
  const zhName = typeof getShareLanguageChineseName === "function" ? getShareLanguageChineseName(locale || { code }) : (locale?.name || code);
  return zhName || locale?.name || code;
}

function getExperimentScopeLanguages(configs = []) {
  const codes = Array.from(new Set((configs || []).flatMap((cfg) => getShareConfigLanguageCodes(cfg))));
  return codes.map((code) => ({ value: code, label: getExperimentLanguageLabel(code), sub: code }));
}

function renderExperimentScopeConditionGroup(title, key, options = [], hint = "不选择则默认全部") {
  const labelId = `experiment-scope-${key}-label`;
  const scopeDraft = getExperimentScopeDraft();
  const optionMap = new Map((options || []).map((item) => [item.value, item.label]));
  if (key === "package") {
    scopeDraft.packageIds = (scopeDraft.packageIds || []).filter((id) => optionMap.has(id));
    scopeDraft.packageLabels = scopeDraft.packageIds.map((id) => optionMap.get(id));
  } else if (key === "language") {
    scopeDraft.languageValues = (scopeDraft.languageValues || []).filter((id) => optionMap.has(id));
    scopeDraft.languageLabels = scopeDraft.languageValues.map((id) => optionMap.get(id));
  }
  const selectedValues = new Set(key === "package" ? scopeDraft.packageIds : key === "language" ? scopeDraft.languageValues : []);
  const initialLabels = key === "package" ? scopeDraft.packageLabels : key === "language" ? scopeDraft.languageLabels : [];
  const labelText = initialLabels.length === 0 ? "全部" : initialLabels.length === 1 ? initialLabels[0] : `已选 ${initialLabels.length} 项`;
  return `
    <details class="relative group">
      <summary class="rounded-xl border border-ink-100 bg-white px-3 py-2.5 cursor-pointer hover:border-brand-200 hover:bg-brand-50/30">
        <div class="flex items-center justify-between gap-2">
          <span class="text-xs font-semibold text-ink-500">${title}</span>
          <span id="${labelId}" class="text-xs font-medium text-ink-900 truncate">${labelText}</span>
        </div>
        <div class="mt-1 flex items-center justify-between gap-2 text-[11px] text-ink-400">
          <span class="truncate">${hint}</span>
          <span class="text-ink-300 group-open:rotate-180 transition-transform">⌄</span>
        </div>
      </summary>
      <div class="absolute left-0 right-0 top-full mt-2 z-30 rounded-xl border border-ink-100 bg-white shadow-pop p-2">
        <div class="max-h-56 overflow-y-auto">
          ${options.length ? options.map((item) => `
            <label class="flex items-center gap-2 rounded-lg px-2.5 py-2 text-xs hover:bg-ink-50 cursor-pointer">
              <input type="checkbox" class="rounded border-ink-300" data-experiment-scope="${key}" data-label="${item.label}" value="${item.value}" ${selectedValues.has(item.value) ? "checked" : ""} onchange="updateExperimentScopePickerLabel('${key}', '${labelId}'); updateExperimentScopeSummaryDom(); saveExperimentScopeDraftFromDom()" />
              <span class="flex-1 min-w-0">
                <span class="block font-medium text-ink-700 truncate">${item.label}</span>
                ${item.sub ? `<span class="block text-[11px] text-ink-400 truncate">${item.sub}</span>` : ""}
              </span>
            </label>
          `).join("") : `<div class="rounded-lg border border-dashed border-ink-200 bg-ink-50 px-3 py-3 text-xs text-ink-400">暂无可选项，默认全部</div>`}
        </div>
        <div class="mt-2 pt-2 border-t border-ink-100 flex items-center justify-between gap-2">
          ${key === "region" ? `<button type="button" onclick="navigate('/admin/platform/regions-countries?return=' + encodeURIComponent(getCurrentPathWithQuery()))" class="px-2.5 py-1.5 text-xs rounded-lg text-brand-700 hover:bg-brand-50">统一配置</button>` : `<button type="button" onclick="clearExperimentScopePicker('${key}', '${labelId}')" class="px-2.5 py-1.5 text-xs rounded-lg text-ink-500 hover:bg-ink-50">清空</button>`}
          <div class="flex items-center gap-2">
            ${key === "region" ? `<button type="button" onclick="clearExperimentScopePicker('${key}', '${labelId}')" class="px-2.5 py-1.5 text-xs rounded-lg text-ink-500 hover:bg-ink-50">清空</button>` : ""}
            <button type="button" onclick="confirmExperimentScopePicker('${key}', '${labelId}', this)" class="px-3 py-1.5 text-xs rounded-lg bg-brand-900 text-white hover:bg-brand-800">确认</button>
          </div>
        </div>
      </div>
    </details>
  `;
}

window.updateExperimentScopePickerLabel = function (key, labelId) {
  const label = document.getElementById(labelId);
  if (!label) return;
  const checked = Array.from(document.querySelectorAll(`[data-experiment-scope='${key}']:checked`)).map((item) => item.dataset.label || item.value);
  label.textContent = checked.length === 0 ? "全部" : checked.length === 1 ? checked[0] : `已选 ${checked.length} 项`;
};

function getExperimentScopeSelectionsFromDom() {
  const labels = { package: "包体", region: "地区", language: "语言" };
  return Object.entries(labels).map(([key, label]) => ({
    key,
    label,
    values: Array.from(document.querySelectorAll(`[data-experiment-scope='${key}']:checked`)).map((item) => item.dataset.label || item.value),
  }));
}

function renderExperimentScopeSummaryChips(selections = null) {
  const scopeDraft = getExperimentScopeDraft();
  const items = selections || [
    { label: "包体", values: scopeDraft.packageLabels || [] },
    { label: "地区", values: getExperimentRegionSelectionLabels() },
    { label: "语言", values: scopeDraft.languageLabels || [] },
  ];
  return items.map((item) => {
    const values = item.values && item.values.length ? item.values : ["全部"];
    return `
      <div class="inline-flex items-center gap-1.5 rounded-lg border border-ink-100 bg-white px-2.5 py-1.5">
        <span class="text-ink-400">${item.label}</span>
        <span class="text-ink-800 font-medium">${values.join("、")}</span>
      </div>
    `;
  }).join("");
}

window.updateExperimentScopeSummaryDom = function () {
  const container = document.getElementById("experiment-scope-summary");
  if (!container) return;
  container.innerHTML = renderExperimentScopeSummaryChips(getExperimentScopeSelectionsFromDom());
};

window.clearExperimentScopePicker = function (key, labelId) {
  document.querySelectorAll(`[data-experiment-scope='${key}']:checked`).forEach((item) => {
    item.checked = false;
  });
  saveExperimentScopeDraftFromDom();
  updateExperimentScopePickerLabel(key, labelId);
  updateExperimentScopeSummaryDom();
};

window.confirmExperimentScopePicker = function (key, labelId, button) {
  saveExperimentScopeDraftFromDom();
  updateExperimentScopePickerLabel(key, labelId);
  updateExperimentScopeSummaryDom();
  button?.closest("details")?.removeAttribute("open");
};

function getExperimentScopeSummaryFromDom() {
  saveExperimentScopeDraftFromDom();
  const scopeDraft = getExperimentScopeDraft();
  const items = [
    { label: "包体", values: scopeDraft.packageLabels || [] },
    { label: "地区", values: getExperimentRegionSelectionLabels() },
    { label: "语言", values: scopeDraft.languageLabels || [] },
  ];
  return items.map((item) => `${item.label}: ${item.values.length ? item.values.join("、") : "全部"}`).join("；");
}

window.startCreateExperimentLab = function () {
  getExperimentLabDraft([], { reset: true });
  navigate('/ops/share-config/lab/create');
};

window.startSelectExperimentPrimary = function () {
  const configs = getSortedShareConfigs((MOCK.SHARE_CONFIGS || []).filter((c) => c.scope === "package_set"));
  const draft = getExperimentLabDraft(configs);
  navigate(`/ops/share-config?selectFor=experimentPrimary&game=${encodeURIComponent(draft.gameId || "")}`);
};

window.startAddExperimentVariant = function () {
  const allConfigs = getSortedShareConfigs((MOCK.SHARE_CONFIGS || []).filter((c) => c.scope === "package_set"));
  const draft = getExperimentLabDraft(allConfigs);
  const configs = getExperimentConfigsForGame(allConfigs, draft.gameId);
  if ((draft.variantIds || []).length >= 9) {
    UI.toast("最多支持 9 个对照组", "info");
    return;
  }
  navigate(`/ops/share-config?selectFor=experimentVariant&game=${encodeURIComponent(draft.gameId || "")}`);
};

window.toggleExperimentActivitySelection = function (cfgId) {
  const allConfigs = getSortedShareConfigs((MOCK.SHARE_CONFIGS || []).filter((c) => c.scope === "package_set"));
  const draft = getExperimentLabDraft(allConfigs);
  const configs = getExperimentConfigsForGame(allConfigs, draft.gameId);
  if (!configs.some((cfg) => cfg.id === cfgId)) {
    UI.toast("该配置不属于当前选择的游戏，不能加入实验组", "warning");
    renderRoute();
    return;
  }
  const query = location.hash.includes("?") ? location.hash.split("?")[1] : "";
  const mode = new URLSearchParams(query).get("selectFor") || "experimentVariant";
  if (mode === "experimentPrimary") {
    draft.primaryId = draft.primaryId === cfgId ? null : cfgId;
    draft.variantIds = (draft.variantIds || []).filter((id) => id !== draft.primaryId);
    const count = document.getElementById("experiment-selection-count");
    if (count) count.textContent = String(draft.primaryId ? 1 : 0);
    renderRoute();
    return;
  }
  if (draft.primaryId === cfgId) {
    UI.toast("主配置不能同时作为对照配置", "warning");
    renderRoute();
    return;
  }
  const set = new Set(draft.variantIds || []);
  if (set.has(cfgId)) {
    set.delete(cfgId);
  } else {
    if (set.size >= 9) {
      UI.toast("最多支持选择 9 个对照组", "warning");
      renderRoute();
      return;
    }
    set.add(cfgId);
  }
  draft.variantIds = Array.from(set);
  const count = document.getElementById("experiment-selection-count");
  if (count) count.textContent = String(draft.variantIds.length);
};

window.confirmExperimentActivitySelection = function () {
  const allConfigs = getSortedShareConfigs((MOCK.SHARE_CONFIGS || []).filter((c) => c.scope === "package_set"));
  const draft = getExperimentLabDraft(allConfigs);
  const configs = getExperimentConfigsForGame(allConfigs, draft.gameId);
  const query = location.hash.includes("?") ? location.hash.split("?")[1] : "";
  const mode = new URLSearchParams(query).get("selectFor") || "experimentVariant";
  if (mode === "experimentPrimary") {
    if (!draft.primaryId) {
      UI.toast("请选择 1 个主配置", "warning");
      return;
    }
  } else if (!draft.variantIds || draft.variantIds.length < 1) {
    UI.toast("请至少选择 1 个对照配置", "warning");
    return;
  }
  draft.variantIds = (draft.variantIds || []).filter((id) => id !== draft.primaryId).slice(0, 9);
  navigate('/ops/share-config/lab/create?draft=1');
};

window.cancelExperimentActivitySelection = function () {
  navigate('/ops/share-config/lab/create?draft=1');
};

window.cancelAddExperimentVariant = function () {
  navigate('/ops/share-config/lab/create?draft=1');
};

window.addExperimentVariant = window.startAddExperimentVariant;

window.clearExperimentPrimary = function () {
  const configs = getSortedShareConfigs((MOCK.SHARE_CONFIGS || []).filter((c) => c.scope === "package_set"));
  const draft = getExperimentLabDraft(configs);
  draft.primaryId = null;
  renderRoute();
};

window.removeExperimentVariant = function (index) {
  const configs = getSortedShareConfigs((MOCK.SHARE_CONFIGS || []).filter((c) => c.scope === "package_set"));
  const draft = getExperimentLabDraft(configs);
  draft.variantIds = (draft.variantIds || []).filter((_, idx) => idx !== index);
  renderRoute();
};

function getExperimentStatusMeta(statusKey) {
  const map = {
    pending: { label: "实验待启动", badgeCls: "bg-amber-50 text-amber-700", iconCls: "bg-amber-50 text-amber-700", metric: "待启动" },
    running: { label: "实验运行中", badgeCls: "bg-ok-50 text-ok-700", iconCls: "bg-brand-50 text-brand-700", metric: "观察中" },
    stopped: { label: "实验停止", badgeCls: "bg-ink-100 text-ink-600", iconCls: "bg-ink-100 text-ink-600", metric: "已暂停" },
  };
  return map[statusKey] || map.pending;
}

function getExperimentLabGroups(configs = []) {
  if (!window.__experimentLabGroups) {
    window.__experimentLabGroups = [
      { id: "exp_social_card_june", name: "6 月社交渠道卡片样式对照", statusKey: "pending", strategy: "生效范围内均匀分流", scopeSummary: "包体: 全部；渠道: 全部；地区: 全部；语言: 全部", metric: "待启动", primaryId: configs[0]?.id, variantIds: configs.slice(1, 4).map((cfg) => cfg.id) },
      { id: "exp_discord_rich", name: "Discord 富媒体样式实验", statusKey: "running", strategy: "生效范围内均匀分流", scopeSummary: "包体: 全部；渠道: Discord；地区: 全部；语言: English", metric: "转化率 +18.4%", primaryId: configs[1]?.id, variantIds: [configs[0]?.id, configs[2]?.id].filter(Boolean) },
      { id: "exp_landing_copy", name: "欧美活动落地页文案对照", statusKey: "stopped", strategy: "生效范围内均匀分流", scopeSummary: "包体: 全部；渠道: 全部；地区: United States / 美国、United Kingdom / 英国；语言: 全部", metric: "已暂停", primaryId: configs[0]?.id, variantIds: [configs[1]?.id].filter(Boolean) },
    ];
  }
  return window.__experimentLabGroups.map((group) => {
    const meta = getExperimentStatusMeta(group.statusKey);
    return {
      ...group,
      status: meta.label,
      statusMeta: meta,
      metric: group.statusKey === "running" ? (group.metric || "观察中") : meta.metric,
      primary: configs.find((cfg) => cfg.id === group.primaryId) || configs[0],
      variants: (group.variantIds || []).map((id) => configs.find((cfg) => cfg.id === id)).filter(Boolean),
    };
  });
}

async function saveExperimentLabGroup() {
  const configs = getSortedShareConfigs((MOCK.SHARE_CONFIGS || []).filter((c) => c.scope === "package_set"));
  const draft = getExperimentLabDraft(configs);
  if (!draft.primaryId || !draft.variantIds || draft.variantIds.length < 1) {
    UI.toast("请选择 1 个主配置和至少 1 个对照配置", "warning");
    return;
  }
  try {
    await shareConfigsApi.createExperiment({
      name: document.querySelector("input[placeholder='请输入实验组名称']")?.value || "新建分享实验组",
      statusKey: "pending",
      status: "draft",
      strategy: "生效范围内均匀分流",
      scopeSummary: getExperimentScopeSummaryFromDom(),
      metric: "待启动",
      gameId: draft.gameId,
      primaryId: draft.primaryId,
      variantIds: [...draft.variantIds],
    });
    // keep local UI cache in sync for this session
    getExperimentLabGroups(configs);
    window.__experimentLabGroups.unshift({
      id: `exp_${Date.now()}`,
      name: document.querySelector("input[placeholder='请输入实验组名称']")?.value || "新建分享实验组",
      statusKey: "pending",
      strategy: "生效范围内均匀分流",
      scopeSummary: getExperimentScopeSummaryFromDom(),
      metric: "待启动",
      gameId: draft.gameId,
      primaryId: draft.primaryId,
      variantIds: [...draft.variantIds],
    });
    resetExperimentLabDraft();
    UI.toast("实验组已创建，当前处于实验待启动状态", "success");
    navigate("/ops/share-config/lab");
  } catch (err) {
    UI.toast(err?.message || "创建实验失败", "error");
  }
}

function updateExperimentGroupStatus(groupId, nextStatus) {
  const groups = getExperimentLabGroups(getSortedShareConfigs((MOCK.SHARE_CONFIGS || []).filter((c) => c.scope === "package_set")));
  const target = window.__experimentLabGroups.find((group) => group.id === groupId);
  if (!target) return;
  target.statusKey = nextStatus;
  target.metric = nextStatus === "running" ? "观察中" : getExperimentStatusMeta(nextStatus).metric;
  UI.toast(nextStatus === "running" ? "实验已开启，进入实验运行中" : "实验已暂停，进入实验停止状态", "success");
  renderRoute();
}

function renderExperimentVariantAddPanel(configs = [], nextIndex = 1) {
  return `
    <div class="rounded-xl border-2 border-brand-200 bg-brand-50/40 p-4">
      <div class="flex items-start justify-between gap-3 mb-4">
        <div>
          <div class="text-sm font-semibold text-brand-900">添加对照组 ${nextIndex}</div>
          <div class="text-xs text-brand-700 mt-0.5">选择一条活动配置作为新的对照组；具体命中条件由实验组生效策略统一定义。</div>
        </div>
        <span class="badge bg-white text-brand-700 border border-brand-100">新增流程</span>
      </div>
      <div class="grid grid-cols-12 gap-3 items-end">
        <label class="col-span-5 block">
          <span class="block text-xs font-medium text-ink-500 mb-1.5">选择活动配置</span>
          <select class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm bg-white">
            ${configs.slice(1).map((item) => `<option>${item.name}</option>`).join("") || `<option>暂无可选活动配置</option>`}
          </select>
        </label>
        <div class="col-span-5 rounded-lg border border-brand-100 bg-white/80 px-3 py-2.5 text-xs text-brand-700 leading-relaxed">
          添加后，系统会在实验组生效范围内重新计算均匀分流比例；对照配置不再单独设置命中条件。
        </div>
        <div class="col-span-2 flex justify-end gap-2">
          <button onclick="cancelAddExperimentVariant()" class="px-3 py-2 text-sm border border-ink-100 rounded-lg bg-white hover:bg-ink-50">取消</button>
          <button onclick="confirmAddExperimentVariant()" class="px-3 py-2 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">确认添加</button>
        </div>
      </div>
      <div class="mt-3 rounded-lg bg-white/70 border border-brand-100 px-3 py-2 text-[11px] text-brand-700 leading-relaxed">
        保存实验组后，SDK 先判断包体、地区、语言是否命中生效策略，再在命中范围内均匀分配到主配置和对照配置。
      </div>
    </div>
  `;
}

function renderExperimentConfigSelector(role, cfg, weight, isPrimary, index = -1) {
  const action = isPrimary
    ? `<button onclick="startSelectExperimentPrimary()" class="px-3 py-1.5 text-xs rounded-lg ${cfg ? "border border-ink-100 bg-white hover:bg-ink-50 text-ink-700" : "bg-brand-900 text-white hover:bg-brand-800"}">${cfg ? "更换" : "选择主配置"}</button>`
    : `<button onclick="removeExperimentVariant(${index})" class="text-xs text-danger-600 hover:underline">移除</button>`;
  if (!cfg) {
    return `
      <div class="rounded-xl border border-dashed border-ink-200 bg-ink-50/50 px-4 py-4 flex items-center justify-between gap-4">
        <span class="text-sm text-ink-500">未选择主配置</span>
        ${action}
      </div>
    `;
  }
  return `
    <div class="rounded-xl border ${isPrimary ? "border-brand-100 bg-brand-50/40" : "border-ink-100 bg-white"} px-4 py-3 flex items-center gap-3">
      <span class="badge ${isPrimary ? "bg-brand-50 text-brand-700" : "bg-ink-100 text-ink-700"}">${role}</span>
      <div class="flex-1 min-w-0">
        <div class="text-sm font-semibold text-ink-900 truncate">${cfg.name}</div>
        <div class="text-xs text-ink-400 font-mono mt-0.5 truncate">${configId(cfg)}</div>
      </div>
      <span class="text-xs text-ink-500 whitespace-nowrap">${weight}</span>
      ${UI.statusBadge(cfg.status)}
      <div class="w-16 text-right">${action}</div>
    </div>
  `;
}

function renderExperimentGroupItem({ id, name, statusKey = "pending", status, statusMeta = getExperimentStatusMeta(statusKey), strategy, scopeSummary = "包体: 全部；渠道: 全部；地区: 全部；语言: 全部", metric, primary, variants = [], open = false }) {
  const allConfigs = [primary, ...variants].filter(Boolean);
  const weights = getExperimentWeights(allConfigs.length || 1);
  const actionButton = statusKey === "running"
    ? `<button class="text-xs text-danger-600 hover:underline" onclick="event.preventDefault(); event.stopPropagation(); updateExperimentGroupStatus('${id}', 'stopped')">暂停实验</button>`
    : `<button class="text-xs text-brand-600 hover:underline" onclick="event.preventDefault(); event.stopPropagation(); updateExperimentGroupStatus('${id}', 'running')">开启实验</button>`;
  return `
    <details class="group" ${open ? "open" : ""}>
      <summary class="px-5 py-4 cursor-pointer hover:bg-ink-50 flex items-center gap-4">
        <span class="w-8 h-8 rounded-lg ${statusMeta.iconCls} flex items-center justify-center">
          ${Icon.activity({ size: 15 })}
        </span>
        <div class="flex-1 min-w-0">
          <div class="flex items-center gap-2 flex-wrap">
            <h3 class="text-sm font-semibold text-ink-900">${name}</h3>
            <span class="badge ${statusMeta.badgeCls}">${status}</span>
            <span class="badge bg-ink-100 text-ink-700">${allConfigs.length} 个配置</span>
          </div>
          <div class="mt-1 text-xs text-ink-500">${strategy} · ${metric} · SDK 可通过主配置找到关联配置</div>
          <div class="mt-1 text-[11px] text-ink-400 line-clamp-1">生效策略：${scopeSummary}</div>
        </div>
        <div class="flex items-center gap-3">
          ${actionButton}
          <button class="text-xs text-brand-600 hover:underline" onclick="event.preventDefault(); event.stopPropagation(); navigate('/ops/share-config/lab/analysis')">查看报告</button>
        </div>
        <svg class="chev w-4 h-4 text-ink-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
      </summary>
      <div class="px-5 pb-5 bg-ink-50/50">
        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-12 rounded-xl border border-ink-100 bg-white overflow-hidden">
            <div class="grid grid-cols-12 bg-ink-50 text-xs text-ink-500 border-b border-ink-100">
              <div class="col-span-3 px-4 py-2.5 font-medium">角色</div>
              <div class="col-span-6 px-4 py-2.5 font-medium">活动配置</div>
              <div class="col-span-2 px-4 py-2.5 font-medium">分流比例</div>
              <div class="col-span-1 px-4 py-2.5 font-medium text-right">状态</div>
            </div>
            ${renderExperimentConfigLine("主配置", primary, weights[0] || "—", "bg-brand-50 text-brand-700")}
            ${variants.map((cfg, idx) => renderExperimentConfigLine(`对照组 ${idx + 1}`, cfg, weights[idx + 1] || "—", "bg-ink-50 text-ink-700")).join("")}
          </div>
        </div>
      </div>
    </details>
  `;
}

function renderExperimentConfigLine(role, cfg, weight, badgeCls) {
  return `
    <div class="grid grid-cols-12 border-b last:border-b-0 border-ink-100 text-sm items-center">
      <div class="col-span-3 px-4 py-3"><span class="badge ${badgeCls}">${role}</span></div>
      <div class="col-span-6 px-4 py-3">
        <div class="font-medium text-ink-900">${cfg?.name || "请选择活动配置"}</div>
        <div class="text-xs text-ink-500 mt-0.5">${cfg?.title || "可选择一条已发布活动配置"}</div>
      </div>
      <div class="col-span-2 px-4 py-3 text-ink-700">${weight}</div>
      <div class="col-span-1 px-4 py-3 text-right">${cfg ? UI.statusBadge(cfg.status) : `<span class="text-xs text-ink-400">待选</span>`}</div>
    </div>
  `;
}

window.changeShareActivityGameFilter = function (gameId) {
  const query = gameId && gameId !== "all" ? `?game=${encodeURIComponent(gameId)}` : "";
  navigate(`/ops/share-config${query}`);
};

window.updateShareActivityPackageFilterOptions = function (resetPackage = false) {
  const gameId = document.getElementById("share-activity-game-filter")?.value || "all";
  const packageSelect = document.getElementById("share-activity-package-filter");
  if (!packageSelect) return;
  const previousValue = resetPackage ? "all" : (packageSelect.value || "all");
  const sourcePackages = typeof getOpsVisiblePackages === "function" ? getOpsVisiblePackages() : (MOCK.PACKAGES || []);
  const visiblePackages = gameId === "all" ? sourcePackages : sourcePackages.filter((pkg) => pkg.game_id === gameId);
  packageSelect.innerHTML = `
    <option value="all">${gameId === "all" ? "全部包体" : "当前游戏全部包体"}</option>
    ${visiblePackages.slice(0, 12).map((p) => `<option value="${p.id}" data-game="${p.game_id}">${packageFullName(p)}</option>`).join("")}
  `;
  packageSelect.value = visiblePackages.some((pkg) => pkg.id === previousValue) ? previousValue : "all";
};

window.filterShareActivities = function () {
  const keyword = (document.getElementById("share-activity-keyword-filter")?.value || "").trim().toLowerCase();
  const status = document.getElementById("share-activity-status-filter")?.value || "all";
  const gameId = document.getElementById("share-activity-game-filter")?.value || "all";
  const packageId = document.getElementById("share-activity-package-filter")?.value || "all";
  let visible = 0;
  document.querySelectorAll("[data-share-activity='true']").forEach((row) => {
    const rowGames = (row.dataset.games || "").split(",").filter(Boolean);
    const rowPackages = (row.dataset.packages || "").split(",").filter(Boolean);
    const matchedKeyword = !keyword || row.dataset.search.includes(keyword);
    const matchedStatus = status === "all" || row.dataset.status === status;
    const matchedGame = gameId === "all" || rowGames.includes(gameId);
    const matchedPackage = packageId === "all" || rowPackages.includes(packageId);
    const matched = matchedKeyword && matchedStatus && matchedGame && matchedPackage;
    row.classList.toggle("hidden", !matched);
    if (matched) visible += 1;
  });
  const count = document.getElementById("share-activity-filter-count");
  if (count) count.textContent = String(visible);
};

function renderShareActivityWorkflowStep(index, title, desc, iconName) {
  const iconHtml = Icon[iconName] ? Icon[iconName]({ size: 15 }) : "";
  return `
    <div class="rounded-xl border border-ink-100 bg-ink-50/60 p-3">
      <div class="flex items-center gap-2">
        <span class="w-6 h-6 rounded-lg bg-white border border-ink-200 flex items-center justify-center text-[10px] font-semibold text-ink-500">${index}</span>
        <span class="w-7 h-7 rounded-lg bg-brand-50 text-brand-700 flex items-center justify-center">${iconHtml}</span>
      </div>
      <div class="mt-3 text-sm font-semibold text-ink-900">${title}</div>
      <div class="mt-1 text-xs text-ink-500 leading-relaxed">${desc}</div>
    </div>
  `;
}

function renderShareActivityPagination(currentPage, totalPages, pageStart, pageEnd, total, selectionMode = "", gameId = "") {
  const pagePath = (page) => `/ops/share-config?${selectionMode ? `selectFor=${selectionMode}&` : ""}${gameId ? `game=${encodeURIComponent(gameId)}&` : ""}page=${page}`;
  const pageButton = (page) => `
    <button onclick="navigate('${pagePath(page)}')" class="px-2.5 py-1 rounded ${page === currentPage ? "bg-brand-900 text-white" : "hover:bg-ink-100 text-ink-600"}">${page}</button>
  `;
  return `
    <div class="px-5 py-4 border-t border-ink-100 bg-ink-50 flex items-center justify-between text-xs text-ink-500">
      <div>显示 <strong>${pageStart}-${pageEnd}</strong> / ${total} 条 · 每页 15 条</div>
      <div class="flex items-center gap-1">
        <button ${currentPage === 1 ? "disabled" : ""} onclick="navigate('${pagePath(currentPage - 1)}')" class="px-2.5 py-1 rounded hover:bg-ink-100 disabled:opacity-40 disabled:cursor-not-allowed">上一页</button>
        ${Array.from({ length: totalPages }, (_, i) => pageButton(i + 1)).join("")}
        <button ${currentPage === totalPages ? "disabled" : ""} onclick="navigate('${pagePath(currentPage + 1)}')" class="px-2.5 py-1 rounded hover:bg-ink-100 disabled:opacity-40 disabled:cursor-not-allowed">下一页</button>
      </div>
    </div>
  `;
}

function getShareActivityLanguageCount(cfg) {
  const template = (MOCK.TEMPLATES || []).find((item) => item.temple_id === cfg.temple_id || item.id === cfg.temple_id);
  const explicit = cfg.language_count || cfg.languages || cfg.locale_count || cfg.locales?.length;
  return Number(explicit || template?.languages || Math.max(1, Math.min(7, 3 + ((cfg.channels || []).length % 4))));
}

function getShareActivityLanguageVersions(cfg) {
  const presets = ["简体中文", "English", "繁體中文", "日本語", "한국어", "ไทย", "Tiếng Việt"];
  return presets.slice(0, getShareActivityLanguageCount(cfg));
}

function renderShareActivityLanguageChips(cfg) {
  return getShareActivityLanguageVersions(cfg).map((lang) => `<span class="px-2 py-1 rounded bg-brand-50 text-brand-700 text-[11px]">${lang}</span>`).join("");
}

function renderShareActivityManageRow(cfg, visiblePackages, selectingForExperiment = false, experimentDraft = null, selectionMode = "") {
  const targetPackages = visiblePackages.filter((p) => cfg.package_ids.includes(p.id));
  const activityGame = getShareGame(targetPackages[0]?.game_id || cfg.game_id);
  const landingPage = getLandingPagesForConfig(cfg)[0];
  const cardId = cardIdForConfig(cfg);
  const landingId = landingPage ? landingPageIdForLandingPage(landingPage) : "—";
  const languageCount = getShareActivityLanguageCount(cfg);
  const hasUrlLandingPage = landingPage && (landingPage.source_type === "url" || landingPage.content_type === "url");
  const searchText = [
    cfg.name,
    configId(cfg),
    cardId,
    landingId,
    cfg.owner,
    cfg.status,
    ...(cfg.channels || []),
    activityGame?.name,
    activityGame?.code,
    ...(landingPage ? [landingPage.id, landingPage.name, landingPage.title, landingPage.url, landingPage.temple_id] : []),
    ...targetPackages.map((p) => packageSearchText(p)),
  ].filter(Boolean).join(" ").toLowerCase().replace(/"/g, "&quot;");
  const packageData = targetPackages.map((p) => p.id).join(",");
  const gameData = Array.from(new Set(targetPackages.map((p) => p.game_id).filter(Boolean))).join(",");
  const selectingPrimary = selectionMode === "experimentPrimary";
  const selected = selectingPrimary ? experimentDraft?.primaryId === cfg.id : !!experimentDraft?.variantIds?.includes(cfg.id);
  const disabledAsVariant = !selectingPrimary && experimentDraft?.primaryId === cfg.id;

  return `
    <tr class="border-t border-ink-100 row-hover align-top ${disabledAsVariant ? "opacity-50" : ""}" data-share-activity="true" data-search="${searchText}" data-status="${cfg.status}" data-games="${gameData}" data-packages="${packageData}">
      ${selectingForExperiment ? `<td class="px-4 py-3"><input type="${selectingPrimary ? "radio" : "checkbox"}" name="experiment-activity-selection" ${selected ? "checked" : ""} ${disabledAsVariant ? "disabled" : ""} onchange="toggleExperimentActivitySelection('${cfg.id}')" class="w-4 h-4 rounded border-ink-300" /></td>` : ""}
      <td class="px-4 py-3 min-w-[220px]">
        <button onclick="navigate('/ops/share-config/activity/${cfg.id}/edit')" class="font-medium text-ink-900 hover:text-brand-700 hover:underline text-left" title="点击查看配置详情">${cfg.name}</button>
        <div class="mt-1 flex items-center gap-1.5 flex-wrap">
          <span class="text-xs text-ink-500">${cfg.mode === "expert" ? "高级活动" : "标准活动"}</span>
          ${hasUrlLandingPage ? `<span class="badge bg-purple-50 text-purple-700">URL 落地页</span>` : ""}
        </div>
      </td>
      <td class="px-4 py-3 min-w-[150px]">
        ${activityGame ? `<span class="inline-flex items-center gap-1.5 px-2 py-1 rounded-lg bg-ink-50 border border-ink-100 text-xs text-ink-700">${renderGameIcon(activityGame, "w-4 h-4")}<span class="truncate max-w-[112px]">${activityGame.name}</span></span>` : `<span class="text-xs text-ink-400">—</span>`}
      </td>
      <td class="px-4 py-3 min-w-[180px]">
        <div class="text-sm text-ink-900 line-clamp-1">${cfg.title || cfg.name}</div>
        <div class="text-xs text-ink-500 mt-1">已配置卡片</div>
      </td>
      <td class="px-4 py-3 min-w-[190px]">
        <div class="text-sm text-ink-900 line-clamp-1">${landingPage?.name || "未绑定落地页"}</div>
        <div class="text-xs text-ink-500 mt-1">${hasUrlLandingPage ? "外部 URL" : "模板落地页"}</div>
      </td>
      <td class="px-4 py-3 min-w-[180px]">
        <div class="num text-sm font-semibold text-ink-900">${targetPackages.length}</div>
        <div class="text-xs text-ink-500 mt-1 line-clamp-2">${targetPackages.slice(0, 3).map((p) => packageFullName(p)).join("、")}${targetPackages.length > 3 ? ` 等` : ""}</div>
      </td>
      <td class="px-4 py-3 min-w-[120px]">
        <div class="num text-sm font-semibold text-ink-900">${languageCount}</div>
        <div class="text-xs text-ink-500 mt-1">语言版本</div>
      </td>
      <td class="px-4 py-3">${renderChannelIcons(cfg.channels)}</td>
      <td class="px-4 py-3">${UI.statusBadge(cfg.status)}</td>
      <td class="px-4 py-3 text-xs text-ink-500">
        <div>${cfg.updated || "—"}</div>
        <div class="mt-1">${cfg.owner || "—"}</div>
      </td>
      <td class="px-4 py-3 text-right whitespace-nowrap">
        <button onclick="navigate('/ops/share-config/activity/${cfg.id}/edit')" class="text-xs text-brand-600 hover:underline mr-2">详情</button>
        <button onclick="navigate('/ops/analytics/share-details/${cfg.id}')" class="text-xs text-ink-600 hover:text-brand-700 hover:underline">查看数据</button>
      </td>
    </tr>
  `;
}

function renderShareActivityManageCard(cfg, visiblePackages) {
  const targetPackages = visiblePackages.filter((p) => cfg.package_ids.includes(p.id));
  const parallelPackages = targetPackages.filter((p) => getAllShareConfigsForPackage(p).length > 1);
  const landingPage = getLandingPagesForConfig(cfg)[0];
  const gameIds = [...new Set(targetPackages.map((p) => p.game_id))];
  const games = gameIds.map((id) => getShareGame(id)).filter(Boolean);
  const cardId = cardIdForConfig(cfg);
  const landingId = landingPage ? landingPageIdForLandingPage(landingPage) : "—";
  const hasUrlLandingPage = landingPage && (landingPage.source_type === "url" || landingPage.content_type === "url");
  const searchText = [
    cfg.name,
    configId(cfg),
    cardId,
    landingId,
    cfg.owner,
    cfg.status,
    ...(cfg.channels || []),
    ...(landingPage ? [landingPage.id, landingPage.name, landingPage.title, landingPage.url, landingPage.temple_id] : []),
    ...targetPackages.map((p) => packageFullName(p)),
  ].filter(Boolean).join(" ").toLowerCase().replace(/"/g, "&quot;");
  const packageData = targetPackages.map((p) => p.id).join(",");

  return `
    <div class="card overflow-hidden" data-share-activity="true" data-search="${searchText}" data-status="${cfg.status}" data-packages="${packageData}">
      <div class="px-5 py-4 border-b border-ink-100 flex items-start justify-between gap-4">
        <div class="min-w-0">
          <div class="flex items-center gap-2 flex-wrap">
            <h3 class="text-base font-semibold text-ink-900">${cfg.name}</h3>
            ${UI.statusBadge(cfg.status)}
            ${hasUrlLandingPage ? `<span class="badge bg-purple-50 text-purple-700">含 URL 落地页</span>` : ""}
          </div>
          <div class="mt-1 flex items-center gap-2 text-xs text-ink-500">
            <code class="px-1.5 py-0.5 rounded bg-ink-50 border border-ink-100 font-mono text-ink-700">${configId(cfg)}</code>
            <span>卡片编号</span>
            <code class="px-1.5 py-0.5 rounded bg-brand-50 border border-brand-100 font-mono text-brand-700">${cardId}</code>
            <span>更新于 ${cfg.updated || "—"}</span>
          </div>
        </div>
        <div class="flex items-center gap-2 flex-shrink-0">
          <button onclick="navigate('/ops/share-config/plans/${cfg.id}')" class="px-3 py-1.5 text-xs rounded-lg bg-brand-900 text-white hover:bg-brand-800">编辑活动</button>
          <button onclick="confirmAction('复制活动配置', '确认复制该活动配置并生成新的草稿 活动配置编号？', '确认复制', '已复制为草稿')" class="px-3 py-1.5 text-xs rounded-lg border border-ink-100 hover:bg-ink-50">复制</button>
        </div>
      </div>

      <div class="grid grid-cols-12 gap-0 divide-x divide-ink-100">
        <div class="col-span-5 p-5">
          <div class="text-xs font-semibold text-ink-500 mb-3">活动资产</div>
          <div class="rounded-xl border border-ink-100 bg-ink-50/60 p-3">
            <div class="grid grid-cols-2 gap-3">
              <div class="rounded-lg bg-white border border-ink-100 p-3">
                <div class="text-[11px] text-ink-400">分享卡片</div>
                <div class="mt-1 text-sm font-semibold text-ink-900">${cfg.title || cfg.name}</div>
                <code class="mt-2 inline-flex px-1.5 py-0.5 rounded bg-brand-50 border border-brand-100 text-[10px] font-mono text-brand-700">${cardId}</code>
              </div>
              <div class="rounded-lg bg-white border border-ink-100 p-3">
                <div class="flex items-center justify-between gap-2">
                  <div class="text-[11px] text-ink-400">落地页</div>
                  ${landingPage ? landingPageSourceLabel(landingPage) : `<span class="badge bg-ink-100 text-ink-600">未绑定</span>`}
                </div>
                <div class="mt-1 text-sm font-semibold text-ink-900 truncate">${landingPage?.name || "未选择 落地页"}</div>
                <code class="mt-2 inline-flex px-1.5 py-0.5 rounded bg-purple-50 border border-purple-100 text-[10px] font-mono text-purple-700">${landingId}</code>
              </div>
            </div>
            <div class="mt-3 pt-3 border-t border-ink-100 text-[11px] text-ink-500">
              <code class="font-mono text-brand-700">${cardId}</code>
              <span class="mx-1 text-ink-300">+</span>
              <code class="font-mono text-purple-700">${landingId}</code>
              <span class="mx-1 text-ink-300">→</span>
              <code class="font-mono text-ink-700">${configId(cfg)}</code>
            </div>
          </div>
        </div>

        <div class="col-span-4 p-5">
          <div class="text-xs font-semibold text-ink-500 mb-3">适用范围</div>
          <div class="flex items-center gap-2 flex-wrap mb-3">
            ${games.slice(0, 3).map((game) => `<span class="inline-flex items-center gap-1.5 px-2 py-1 rounded-lg bg-ink-50 border border-ink-100 text-xs text-ink-700">${renderGameIcon(game, "w-4 h-4")} ${game.name}</span>`).join("")}
            ${games.length > 3 ? `<span class="text-xs text-ink-400">+${games.length - 3} 游戏</span>` : ""}
          </div>
          <div class="space-y-1.5">
            ${targetPackages.slice(0, 4).map((p) => `<div class="flex items-center justify-between gap-2 text-xs"><span class="text-ink-700 truncate">${packageFullName(p)}</span><span class="badge bg-ink-100 text-ink-600">${p.region} · ${p.platform}</span></div>`).join("")}
            ${targetPackages.length > 4 ? `<div class="text-xs text-ink-400">+${targetPackages.length - 4} 个包体</div>` : ""}
          </div>
        </div>

        <div class="col-span-3 p-5">
          <div class="text-xs font-semibold text-ink-500 mb-3">运行信息</div>
          <div class="space-y-3">
            <div>
              <div class="text-[11px] text-ink-400 mb-1">启用渠道</div>
              ${renderChannelIcons(cfg.channels)}
            </div>
            <div>
              <div class="text-[11px] text-ink-400 mb-1">关联方式</div>
              ${parallelPackages.length > 0
                ? `<span class="badge bg-blue-50 text-blue-700">${parallelPackages.length} 个包体多 Config 并行</span>`
                : `<span class="badge bg-ok-50 text-ok-700">单活动关联</span>`}
            </div>
            <div class="text-xs text-ink-500">负责人：${cfg.owner || "—"}</div>
          </div>
        </div>
      </div>
    </div>
  `;
}

function getOpsVisiblePackages() {
  const role = MOCK.SESSION.currentRole;
  if (role === "sdk_admin") return MOCK.PACKAGES;
  const currentUserName = MOCK.ROLES[role]?.user;
  const user = MOCK.USERS.find((u) => u.name === currentUserName);
  if (!user || user.games.includes("all")) return MOCK.PACKAGES;
  return MOCK.PACKAGES.filter((p) => user.games.includes(p.game_id));
}

function getShareGame(gameId) {
  return MOCK.GAMES.find((g) => g.id === gameId);
}

function renderGameIcon(game, className = "w-6 h-6") {
  if (!game) return "";
  if (typeof game.icon === "string" && game.icon.startsWith("data:image")) {
    return `<img src="${game.icon}" class="${className} rounded-md object-cover border border-ink-200" alt="${game.name}" />`;
  }
  return `<span class="text-base">${game.icon}</span>`;
}

function packageFullName(pkg) {
  return pkg?.name || pkg?.id || "未知包体";
}

function packageSearchText(pkg) {
  const game = getShareGame(pkg.game_id);
  return [pkg?.name, pkg?.id, game?.name, game?.code, pkg?.region, pkg?.region_name, pkg?.platform].filter(Boolean).join(" ");
}

function getDirectPackageConfigs(pkg) {
  return (MOCK.SHARE_CONFIGS || [])
    .filter((cfg) => cfg.scope === "package" && cfg.package_ids.includes(pkg.id));
}

function getDirectPackageConfig(pkg) {
  return getDirectPackageConfigs(pkg)[0];
}

function getPlanConfigsForPackage(pkg) {
  return (MOCK.SHARE_CONFIGS || [])
    .filter((cfg) => cfg.scope === "package_set" && cfg.package_ids.includes(pkg.id));
}

function configUpdatedTime(cfg) {
  const time = Date.parse((cfg?.updated || "").replace(" ", "T"));
  return Number.isNaN(time) ? 0 : time;
}

function getSortedShareConfigs(configs) {
  return [...configs].sort((a, b) => configUpdatedTime(b) - configUpdatedTime(a));
}

// 按"创建时间从新到旧"排序：以 created_at 为主键；缺失时回退 updated（保持稳定的降序）
function getShareConfigsByCreatedDesc(configs) {
  const time = (cfg) => {
    const v = (cfg && (cfg.created_at || cfg.created || cfg.updated)) || "";
    const t = Date.parse(String(v).replace(" ", "T"));
    return Number.isNaN(t) ? 0 : t;
  };
  return [...configs].sort((a, b) => time(b) - time(a));
}

function createDemoPackageHistory(pkg, baseConfigs) {
  if (pkg.id !== "p_a1b2c3d4e5f6" || baseConfigs.length >= 15) return baseConfigs;
  const seed = baseConfigs[0] || (MOCK.SHARE_CONFIGS || [])[0];
  const audience = ["new_user", "returning_user", "high_ltv", "direct_url"];
  const extra = Array.from({ length: 15 - baseConfigs.length }, (_, i) => {
    const index = i + 1;
    const landingPageId = index % 4 === 0 ? "lp_003_event_url" : index % 3 === 0 ? "lp_001_return" : "lp_001_new";
    const day = String(14 - i).padStart(2, "0");
    return {
      ...seed,
      id: `cfg_pkg_001_hist_${String(index).padStart(2, "0")}`,
      config_id: `cfg_pkg_001_hist_${String(index).padStart(2, "0")}`,
      name: `${pkg.name} 历史配置 #${String(index).padStart(2, "0")}`,
      scope: index % 3 === 0 ? "package_set" : "package",
      package_ids: [pkg.id],
      status: index % 5 === 0 ? "draft" : "released",
      updated: `2026-05-${day} ${String(18 - (i % 8)).padStart(2, "0")}:20`,
      landing_page_ids: landingPageId === "lp_003_event_url" ? ["lp_003_event_url"] : [landingPageId],
      landing_page_id: landingPageId,
      landing_rules: [{ landing_page_id: landingPageId, audience: audience[index % audience.length] }],
      title: index % 4 === 0 ? "Limited time event rewards!" : seed.title,
    };
  });
  return [...baseConfigs, ...extra];
}

function getAllShareConfigsForPackage(pkg) {
  const baseConfigs = (MOCK.SHARE_CONFIGS || []).filter((cfg) => cfg.package_ids.includes(pkg.id));
  return getSortedShareConfigs(createDemoPackageHistory(pkg, baseConfigs));
}

function configId(cfg) {
  return cfg?.config_id || cfg?.id || "—";
}

function getLandingPage(landingPageId) {
  return (MOCK.LANDING_PAGES || []).find((p) => p.id === landingPageId);
}

function getLandingPagesForConfig(cfg) {
  const ids = cfg?.landing_page_ids || (cfg?.landing_page_id ? [cfg.landing_page_id] : []);
  return ids.map((id) => getLandingPage(id)).filter(Boolean);
}

function getTemple(templeId) {
  return (MOCK.TEMPLATES || []).find((t) => (t.temple_id || t.id) === templeId || t.id === templeId);
}

function renderConfigIdChips(configs) {
  if (!configs.length) return `<span class="text-xs text-ink-400">暂无 活动配置编号</span>`;
  return `
    <div class="flex flex-wrap gap-1">
      ${configs.map((cfg) => `<code class="px-1.5 py-0.5 rounded bg-ink-50 border border-ink-100 text-[10px] font-mono text-ink-700" title="${cfg.scope === "package" ? "包体级配置" : "配置方案"}">${configId(cfg)}</code>`).join("")}
    </div>
  `;
}

function landingPageSourceLabel(landingPage) {
  if (!landingPage) return `<span class="badge bg-ink-100 text-ink-600">未知来源</span>`;
  if (landingPage.source_type === "url" || landingPage.content_type === "url") {
    return `<span class="badge bg-purple-50 text-purple-700">URL 落地页</span>`;
  }
  return `<span class="badge bg-brand-50 text-brand-700">模版 落地页</span>`;
}

function audienceRuleLabel(rule) {
  const map = {
    new_user: "新用户 / 未安装",
    returning_user: "回流用户 / 曾安装",
    high_ltv: "高 LTV / 付费倾向",
    region_tw_hk_mo: "地区 TW / HK / MO",
    direct_url: "直接跳转 URL",
  };
  return map[rule] || rule || "默认用户";
}

function renderLandingPageIdChips(cfg) {
  const landingPages = getLandingPagesForConfig(cfg);
  if (!landingPages.length) return `<span class="text-xs text-ink-400">暂无 落地页编号</span>`;
  return `
    <div class="flex flex-wrap gap-1 mt-1">
      ${landingPages.map((p) => `<code class="px-1.5 py-0.5 rounded bg-brand-50 border border-brand-100 text-[10px] font-mono text-brand-700" title="${p.name} · ${p.audience_rule || "默认"}">${p.id}</code>`).join("")}
    </div>
  `;
}

function renderLandingPageSourceChips(cfg) {
  const landingPages = getLandingPagesForConfig(cfg);
  if (!landingPages.length) return `<span class="text-xs text-ink-400">未生成 落地页</span>`;
  return `
    <div class="flex flex-wrap gap-1 mt-1">
      ${landingPages.map((p) => `
        <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-ink-50 border border-ink-100 text-[10px] text-ink-700">
          ${p.source_type === "url" || p.content_type === "url" ? "URL" : "模版"}
          <code class="font-mono">${p.temple_id || p.url || "—"}</code>
        </span>
      `).join("")}
    </div>
  `;
}

function renderLandingPageRules(cfg) {
  const landingPages = getLandingPagesForConfig(cfg);
  if (!landingPages.length) return `<span class="text-xs text-ink-400">暂无组合规则</span>`;
  const cardId = cardIdForConfig(cfg);
  return `
    <div class="space-y-1 mt-1">
      ${landingPages.slice(0, 4).map((landingPage, idx) => `<div class="text-[11px] text-ink-500"><span class="text-ink-400">#${idx + 1}</span> <code class="font-mono text-brand-700">${cardId}</code> + <code class="font-mono text-purple-700">${landingPageIdForLandingPage(landingPage)}</code> · ${landingPage.audience_rule || "默认用户"}</div>`).join("")}
      ${landingPages.length > 4 ? `<div class="text-[11px] text-ink-400">+${landingPages.length - 4} 组组合</div>` : ""}
    </div>
  `;
}

function renderLandingPageCards(landingPages) {
  if (!landingPages.length) return `<div class="text-xs text-ink-400">暂无 落地页</div>`;
  return landingPages.map((p) => `
    <div class="rounded-xl border border-ink-100 bg-white p-3">
      <div class="flex items-start justify-between gap-2">
        <div>
          <div class="text-sm font-semibold text-ink-900">${p.name}</div>
          <div class="font-mono text-[11px] text-brand-700 mt-0.5">落地页编号: ${p.id}</div>
        </div>
        ${landingPageSourceLabel(p)}
      </div>
      <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
        <div class="rounded-lg bg-ink-50 p-2">
          <div class="text-ink-400">落地页编号</div>
          <div class="mt-1 font-mono text-purple-700">${landingPageIdForLandingPage(p)}</div>
        </div>
        <div class="rounded-lg bg-ink-50 p-2">
          <div class="text-ink-400">组合规则</div>
          <div class="mt-1 text-ink-700">${p.audience_rule || "默认用户"}</div>
        </div>
      </div>
      ${p.source_type === "url" || p.content_type === "url" ? `<div class="mt-2 px-2 py-1.5 rounded-lg bg-purple-50 text-[11px] text-purple-700 font-mono truncate">${p.url || p.title}</div>` : `<div class="mt-2 px-2 py-1.5 rounded-lg bg-brand-50 text-[11px] text-brand-700 font-mono">模版编号: ${p.temple_id || "—"}</div>`}
    </div>
  `).join("");
}

function renderChannelIcons(channelCodes = []) {
  const channels = channelCodes.map((code) => MOCK.CHANNELS.find((c) => c.code === code)).filter(Boolean);
  if (channels.length === 0) return `<span class="text-xs text-ink-400">未启用</span>`;
  return `
    <div class="flex items-center gap-1">
      ${channels.slice(0, 5).map((c) => `<span class="text-base" title="${c.name}">${c.icon}</span>`).join("")}
      ${channels.length > 5 ? `<span class="text-xs text-ink-500 ml-1">+${channels.length - 5}</span>` : ""}
    </div>
  `;
}

function getPackageOperationOverview(pkg) {
  const share = pkg.today_share || 0;
  const open = Math.round(share * 0.29);
  const install = pkg.today_install || Math.round(open * 0.68);
  const installRate = share ? ((install / share) * 100).toFixed(1) : "0.0";
  return { share, open, install, installRate };
}

function renderPackageConfigRow(pkg) {
  const game = getShareGame(pkg.game_id);
  const history = getAllShareConfigsForPackage(pkg);
  const latest = history[0];
  const releasedCount = history.filter((cfg) => cfg.status === "released").length;
  const draftCount = history.filter((cfg) => cfg.status === "draft").length;
  const operation = getPackageOperationOverview(pkg);

  return `
    <tr class="border-t border-ink-100 row-hover align-top">
      <td class="px-4 py-3">
        <div class="space-y-2">
          <div class="flex items-center gap-1.5 flex-wrap">
            <span class="badge bg-blue-50 text-blue-700">${pkg.region}</span>
            <span class="badge bg-ink-100 text-ink-700">${pkg.platform}</span>
          </div>
          <div class="flex items-center gap-2 min-w-0">
            ${renderGameIcon(game, "w-5 h-5")}
            <div class="min-w-0">
              <div class="text-xs font-semibold text-ink-900 truncate">${packageFullName(pkg)}</div>
              <div class="text-[11px] text-ink-400 truncate">${pkg.region_name || pkg.region}</div>
            </div>
          </div>
        </div>
      </td>
      <td class="px-4 py-3">
        <div class="flex items-baseline gap-2">
          <div class="text-xl font-semibold text-ink-900">${history.length}</div>
          <div class="text-xs text-ink-500">条历史配置</div>
        </div>
        <div class="flex flex-wrap gap-1 mt-2">
          ${releasedCount ? `<span class="badge bg-ok-50 text-ok-700">已发布 ${releasedCount}</span>` : ""}
          ${draftCount ? `<span class="badge bg-amber-50 text-amber-700">草稿 ${draftCount}</span>` : ""}
          ${history.length > 1 ? `<span class="badge bg-blue-50 text-blue-700">多配置并行</span>` : ""}
          ${!history.length ? `<span class="badge bg-ink-100 text-ink-600">暂无配置</span>` : ""}
        </div>
      </td>
      <td class="px-4 py-3">
        <div class="grid grid-cols-3 gap-2 text-xs">
          <div>
            <div class="text-ink-400">今日分享</div>
            <div class="mt-0.5 font-semibold text-ink-900 num">${UI.fmtNum(operation.share)}</div>
          </div>
          <div>
            <div class="text-ink-400">打开</div>
            <div class="mt-0.5 font-semibold text-ink-900 num">${UI.fmtNum(operation.open)}</div>
          </div>
          <div>
            <div class="text-ink-400">成功安装</div>
            <div class="mt-0.5 font-semibold text-ink-900 num">${UI.fmtNum(operation.install)}</div>
          </div>
        </div>
        <div class="mt-2 text-[11px] text-ink-500">分享→安装率 <span class="font-semibold text-ink-800 num">${operation.installRate}%</span></div>
      </td>
      <td class="px-4 py-3">
        ${latest
          ? `<div class="rounded-lg border border-brand-100 bg-brand-50/50 p-3">
              <div class="text-sm font-medium text-ink-900 truncate">${latest.name}</div>
              <div class="text-xs text-ink-500 mt-1">${latest.updated || "—"}</div>
              <div class="mt-2">${renderPackageConfigAssetSummary(latest)}</div>
            </div>`
          : `<span class="text-sm text-ink-400">暂无配置历史</span>`}
      </td>
      <td class="px-4 py-3 text-right whitespace-nowrap">
        <button onclick="navigate('/ops/package-config/${pkg.id}/history')" class="text-xs text-brand-600 hover:underline">查看历史</button>
      </td>
    </tr>
  `;
}

function renderPlanConfigRow(cfg, visiblePackages) {
  const targetPackages = visiblePackages.filter((p) => cfg.package_ids.includes(p.id));
  const parallelPackages = targetPackages.filter((p) => getAllShareConfigsForPackage(p).length > 1);
  const landingPages = getLandingPagesForConfig(cfg);
  return `
    <tr class="border-t border-ink-100 row-hover align-top">
      <td class="px-4 py-3 min-w-[230px]">
        <div class="font-medium text-ink-900">${cfg.name}</div>
        <div class="text-xs text-ink-500 font-mono mt-0.5">活动配置编号: ${configId(cfg)}</div>
        <div class="mt-2">
          <div class="text-[11px] font-semibold text-ink-500">落地页编号（${landingPages.length || 0}）</div>
          ${renderLandingPageIdChips(cfg)}
        </div>
      </td>
      <td class="px-4 py-3 min-w-[180px]">
        ${renderLandingPageSourceChips(cfg)}
        <div class="mt-2 space-y-1">
          ${landingPages.slice(0, 3).map((p) => `
            <div class="flex items-center gap-1.5 text-[11px] text-ink-500">
              ${landingPageSourceLabel(p)}
              <span class="truncate">${p.source_type === "url" ? (p.url || p.title) : (getTemple(p.temple_id)?.name || p.temple_id || "未绑定 模版")}</span>
            </div>
          `).join("")}
          ${landingPages.length > 3 ? `<div class="text-[11px] text-ink-400">+${landingPages.length - 3} 个 落地页</div>` : ""}
        </div>
      </td>
      <td class="px-4 py-3 min-w-[260px]">
        <div class="text-[11px] font-semibold text-ink-500">卡片 + 落地页 组合</div>
        ${renderConfiguredCardLandingCombos(cardIdForConfig(cfg), landingPages)}
        <div class="mt-2 text-[11px] font-semibold text-ink-500">组合规则</div>
        ${renderLandingPageRules(cfg)}
      </td>
      <td class="px-4 py-3">
        <div class="text-sm text-ink-900">${targetPackages.length} 个包体</div>
        <div class="text-xs text-ink-500 mt-0.5">${targetPackages.slice(0, 3).map((p) => p.name).join("、")}${targetPackages.length > 3 ? ` 等` : ""}</div>
      </td>
      <td class="px-4 py-3">
        ${parallelPackages.length > 0
          ? `<span class="badge bg-blue-50 text-blue-700">${parallelPackages.length} 个包体并行多 Config</span>`
          : `<span class="badge bg-ok-50 text-ok-700">单 Config 关联</span>`}
        <div class="text-[11px] text-ink-400 mt-1">不存在 活动配置编号 优先级</div>
      </td>
      <td class="px-4 py-3">${renderChannelIcons(cfg.channels)}</td>
      <td class="px-4 py-3">${UI.statusBadge(cfg.status)}</td>
      <td class="px-4 py-3 text-xs text-ink-500">${cfg.updated}</td>
      <td class="px-4 py-3 text-right">
        <button onclick="navigate('/ops/share-config/plans/${cfg.id}')" class="text-xs text-brand-600 hover:underline">编辑适用包体</button>
      </td>
    </tr>
  `;
}

// ============================================================
// 配置方案：先配置，再选择适用包体（工作流 2）
// ============================================================
Pages.configPlanEdit = function (configId) {
  const isNew = !configId || configId === "create";
  const currentPath = location.hash.replace(/^#/, "").split("?")[0] || "/";
  const isLandingEntry = currentPath === "/ops/share-landing-config";
  const query = location.hash.includes("?") ? location.hash.split("?")[1] : "";
  const params = new URLSearchParams(query);
  const selectedTemple = getTemple(params.get("temple")) || MOCK.TEMPLATES[0];
  const generatedSuffix = String(Date.now()).slice(-6);
  const generatedTempleLandingPageId = `lp_tpl_${generatedSuffix}`;
  const generatedUrlLandingPageId = `lp_url_${generatedSuffix}`;
  const demoUrl = "https://event.example.com/share-campaign";
  const generatedLandingPages = [
    {
      id: generatedTempleLandingPageId,
      temple_id: selectedTemple?.temple_id || selectedTemple?.id || "temple_new",
      source_type: "temple",
      content_type: "share_content",
      name: `${selectedTemple?.name || "预置模板"} 生成 落地页`,
      audience_rule: "被分享者为新用户 / 未安装或回流用户",
      status: "draft",
      title: selectedTemple?.sample_title || "Invite friends and get rewards!",
    },
    {
      id: generatedUrlLandingPageId,
      temple_id: null,
      source_type: "url",
      content_type: "url",
      name: "跳转 URL 生成 落地页",
      audience_rule: "活动分享场景 / 直接跳转落地页",
      status: "draft",
      url: demoUrl,
      title: demoUrl,
    },
  ];
  const cfg = isNew
    ? {
      id: "cfg_plan_new",
      config_id: "cfg_plan_new",
      landing_page_ids: generatedLandingPages.map((p) => p.id),
      landing_page_id: generatedTempleLandingPageId,
      temple_id: selectedTemple?.temple_id || selectedTemple?.id || "temple_new",
      name: `${selectedTemple?.name || "新活动"} 多 落地页 配置`,
      scope: "package_set",
      mode: "expert",
      package_ids: getOpsVisiblePackages().slice(0, 3).map((p) => p.id),
      landing_rules: [
        { landing_page_id: generatedTempleLandingPageId, audience: "new_user" },
        { landing_page_id: generatedTempleLandingPageId, audience: "returning_user" },
        { landing_page_id: generatedUrlLandingPageId, audience: "direct_url" },
      ],
      status: "draft",
      channels: ["facebook", "messenger", "twitter", "whatsapp"],
      title: selectedTemple?.sample_title || "Invite friends and get rewards!",
    }
    : (MOCK.SHARE_CONFIGS || []).find((c) => c.id === configId) || (MOCK.SHARE_CONFIGS || [])[0];
  const packages = getOpsVisiblePackages();
  const selectedPackages = packages.filter((p) => cfg.package_ids.includes(p.id));
  const parallelPackages = selectedPackages.filter((p) => getAllShareConfigsForPackage(p).length > 1);
  const existingLandingPages = getLandingPagesForConfig(cfg);
  const landingPages = isNew ? generatedLandingPages : existingLandingPages;
  const temple = getTemple(cfg.temple_id) || getTemple(landingPages.find((p) => p.temple_id)?.temple_id);

  return `
    ${UI.pageHeader({
      title: isLandingEntry ? "分享落地页配置" : (isNew ? "新建分享活动配置" : "编辑分享活动配置"),
      desc: isLandingEntry ? "通过跳转 URL 生成 落地页编号，并可与任意 卡片编号 组合后发布到 活动配置编号。" : "先完成运营活动配置，再选择这套配置适用到哪些包体；同一包体下多个 活动配置编号 可并行运行，不存在优先级。",
      actions: `<button onclick="navigate('${isLandingEntry ? "/ops/share-landing-config" : "/ops/share-config"}')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回${isLandingEntry ? "分享落地页配置" : "分享活动配置"}</button>`,
    })}
    ${renderOpsModuleTabs(isLandingEntry ? "landing" : "activity")}

    <div class="grid grid-cols-12 gap-5 items-start">
      <div class="col-span-7 space-y-4">
        <div class="card overflow-hidden">
          <div class="px-5 py-4 border-b border-ink-100 bg-gradient-to-r from-brand-50 to-white">
            <div class="text-xs font-semibold tracking-wider text-brand-700">STEP 1</div>
            <h3 class="text-base font-semibold text-ink-900 mt-0.5">配置内容</h3>
          </div>
          <div class="p-5 space-y-4">
            <div class="grid grid-cols-4 gap-3">
              <div class="rounded-lg border border-ink-200 bg-ink-50 p-3">
                <div class="text-[11px] font-semibold text-ink-500">活动配置编号</div>
                <div class="mt-1 font-mono text-xs text-ink-900">${configId(cfg)}</div>
              </div>
              <div class="rounded-lg border border-brand-200 bg-brand-50 p-3">
                <div class="text-[11px] font-semibold text-brand-700">落地页编号 数</div>
                <div class="mt-1 font-mono text-xs text-ink-900">${landingPages.length} 个</div>
              </div>
              <div class="rounded-lg border border-ink-200 bg-white p-3">
                <div class="text-[11px] font-semibold text-ink-500">来源 模版编号</div>
                <div class="mt-1 font-mono text-xs text-ink-900">${temple?.temple_id || cfg.temple_id || "—"}</div>
              </div>
              <div class="rounded-lg border border-ink-200 bg-white p-3">
                <div class="text-[11px] font-semibold text-ink-500">组合关系</div>
                <div class="mt-1 font-mono text-xs text-ink-900">卡片 × Landing</div>
              </div>
            </div>
            <div>
              <label class="block text-sm font-medium text-ink-700 mb-1.5">配置名称</label>
              <input value="${cfg.name}" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm" />
              <p class="text-xs text-ink-500 mt-1.5">一个 活动配置编号 可关联多组 卡片编号 + 落地页编号；客户端调用只传 活动配置编号，SDK 读取该 Config 下已发布的组合。</p>
            </div>

            <div class="rounded-xl border border-ink-100 overflow-hidden">
              <div class="px-4 py-3 bg-ink-50 border-b border-ink-100">
                <div class="text-sm font-semibold text-ink-900">落地页 来源</div>
                <div class="text-xs text-ink-500 mt-0.5">支持基于 SDK 管理员预置 模版 生成，也支持直接输入跳转 URL 生成 URL 落地页。</div>
              </div>
              <div class="grid grid-cols-2 gap-3 p-4">
                <label class="rounded-xl border border-brand-200 bg-brand-50 p-3 cursor-pointer">
                  <div class="flex items-center gap-2">
                    <input type="radio" name="landingPage-source" checked />
                    <span class="text-sm font-semibold text-brand-900">预置 模版 生成</span>
                  </div>
                  <p class="text-xs text-brand-700 mt-1.5">选择 模版编号 后，在模板基础上生成可编辑分享内容 落地页。</p>
                </label>
                <label class="rounded-xl border border-purple-200 bg-purple-50 p-3 cursor-pointer">
                  <div class="flex items-center gap-2">
                    <input type="radio" name="landingPage-source" />
                    <span class="text-sm font-semibold text-purple-900">跳转 URL 生成</span>
                  </div>
                  <p class="text-xs text-purple-700 mt-1.5">输入落地页 URL 后生成 URL 落地页，命中时直接跳转。</p>
                </label>
              </div>
            </div>

            <div class="grid grid-cols-2 gap-4">
              <div class="rounded-xl border border-brand-100 bg-white p-4 space-y-3">
                <div>
                  <div class="text-sm font-semibold text-ink-900">方式 A · 基于 模版 生成 落地页</div>
                  <div class="text-xs text-ink-500 mt-0.5">模版编号 由 SDK 管理员预置，运营调用后生成 落地页编号。</div>
                </div>
                <div>
                  <label class="block text-xs font-medium text-ink-500 mb-1">模版编号</label>
                  <select class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm bg-white">
                    ${MOCK.TEMPLATES.map((t) => `<option ${((t.temple_id || t.id) === (temple?.temple_id || cfg.temple_id)) ? "selected" : ""}>${t.temple_id || t.id} · ${t.name}</option>`).join("")}
                  </select>
                </div>
                <div>
                  <label class="block text-xs font-medium text-ink-500 mb-1">落地页编号</label>
                  <div class="px-3 py-2 rounded-lg border border-ink-100 bg-ink-50 text-xs font-mono text-purple-700">${landingPageIdForLandingPage(landingPages.find((p) => p.source_type !== "url") || landingPages[0] || { id: generatedTempleLandingPageId })}</div>
                </div>
                <div>
                  <label class="block text-xs font-medium text-ink-500 mb-1">被分享者用户规则</label>
                  <select class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm bg-white">
                    <option>新用户 / 未安装</option>
                    <option>回流用户 / 曾安装</option>
                    <option>高 LTV / 付费倾向</option>
                  </select>
                </div>
                <div class="rounded-lg bg-brand-50 px-3 py-2 text-xs">
                  <span class="text-brand-700 font-semibold">可组合 卡片编号：</span>
                  <code class="font-mono text-brand-900">${cardIdForConfig(cfg)}</code>
                </div>
              </div>

              <div class="rounded-xl border border-purple-100 bg-white p-4 space-y-3">
                <div>
                  <div class="text-sm font-semibold text-ink-900">方式 B · 基于跳转 URL 生成 落地页</div>
                  <div class="text-xs text-ink-500 mt-0.5">URL 型 落地页 不依赖 模版，内容就是跳转落地页。</div>
                </div>
                <div>
                  <label class="block text-xs font-medium text-ink-500 mb-1">跳转 URL</label>
                  <input type="url" value="${landingPages.find((p) => p.source_type === "url")?.url || demoUrl}" class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm font-mono" />
                </div>
                <div>
                  <label class="block text-xs font-medium text-ink-500 mb-1">落地页编号</label>
                  <div class="px-3 py-2 rounded-lg border border-ink-100 bg-ink-50 text-xs font-mono text-purple-700">${landingPageIdForLandingPage(landingPages.find((p) => p.source_type === "url") || { id: generatedUrlLandingPageId, source_type: "url" })}</div>
                </div>
                <div>
                  <label class="block text-xs font-medium text-ink-500 mb-1">被分享者用户规则</label>
                  <select class="w-full px-3 py-2 border border-ink-200 rounded-lg text-sm bg-white">
                    <option>活动分享场景 / 直接跳转落地页</option>
                    <option>特定地区用户</option>
                    <option>特殊活动白名单</option>
                  </select>
                </div>
                <div class="rounded-lg bg-purple-50 px-3 py-2 text-xs">
                  <span class="text-purple-700 font-semibold">生成 落地页编号：</span>
                  <code class="font-mono text-purple-900">${landingPageIdForLandingPage(landingPages.find((p) => p.source_type === "url") || { id: generatedUrlLandingPageId, source_type: "url" })}</code>
                </div>
              </div>
            </div>

            <div class="rounded-xl border border-ink-100 bg-ink-50 p-4">
              <div class="flex items-center justify-between mb-3">
                <div>
                  <div class="text-sm font-semibold text-ink-900">多 落地页 列表</div>
                  <div class="text-xs text-ink-500 mt-0.5">当前 活动配置编号 发布后会关联以下 落地页编号。</div>
                </div>
                <span class="badge bg-brand-50 text-brand-700">${landingPages.length} 落地页编号</span>
              </div>
              <div class="space-y-2">${renderLandingPageCards(landingPages)}</div>
            </div>

            <div class="rounded-xl border border-ink-100 bg-white p-4">
              <div class="text-sm font-semibold text-ink-900">卡片 + 落地页 组合规则</div>
              <div class="text-xs text-ink-500 mt-0.5">SDK 收到 活动配置编号 后，读取该 Config 下已发布的 卡片编号 + 落地页编号 组合。</div>
              <div class="mt-2">${renderLandingPageRules(cfg)}</div>
            </div>

            <div class="grid grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-medium text-ink-700 mb-1.5">配置模式</label>
                <select class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm bg-white">
                  <option ${cfg.mode === "quick" ? "selected" : ""}>快速模式</option>
                  <option ${cfg.mode === "expert" ? "selected" : ""}>专家模式</option>
                </select>
              </div>
              <div>
                <label class="block text-sm font-medium text-ink-700 mb-1.5">配置层级</label>
                <div class="px-3 py-2.5 border border-ink-200 rounded-lg text-sm bg-ink-50 text-ink-700">配置方案 · 可批量绑定包体</div>
              </div>
            </div>
            <div>
              <label class="block text-sm font-medium text-ink-700 mb-1.5">分享标题</label>
              <input value="${cfg.title}" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm" />
            </div>
            <div>
              <label class="block text-sm font-medium text-ink-700 mb-1.5">分享描述</label>
              <textarea rows="3" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm">选择这套配置的包体会复用相同分享文案、渠道参数和归因策略。</textarea>
            </div>
            <div>
              <label class="block text-sm font-medium text-ink-700 mb-2">启用渠道</label>
              <div class="grid grid-cols-4 gap-2">
                ${MOCK.CHANNELS.slice(0, 8).map((c) => `
                  <label class="flex items-center gap-2 px-3 py-2 border border-ink-200 rounded-lg text-xs cursor-pointer hover:border-brand-300 ${cfg.channels.includes(c.code) ? "bg-brand-50 border-brand-200" : "bg-white"}">
                    <input type="checkbox" ${cfg.channels.includes(c.code) ? "checked" : ""} />
                    <span>${c.icon}</span>
                    <span>${c.name}</span>
                  </label>
                `).join("")}
              </div>
            </div>
          </div>
        </div>

        <div class="card p-4 bg-amber-50 border-amber-200">
          <div class="text-sm font-semibold text-amber-900">并行运行规则</div>
          <p class="text-xs text-amber-800 leading-relaxed mt-1">如果选中的包体已经存在其它 活动配置编号，本方案发布后会作为额外 活动配置编号 与其并行可用。客户端调用 SDK 时通过 configID 指定使用哪套配置。</p>
        </div>
      </div>

      <div class="col-span-5 space-y-4">
        <div class="card overflow-hidden sticky top-4">
          <div class="px-5 py-4 border-b border-ink-100 bg-white">
            <div class="text-xs font-semibold tracking-wider text-brand-700">STEP 2</div>
            <h3 class="text-base font-semibold text-ink-900 mt-0.5">选择适用包体</h3>
            <p class="text-xs text-ink-500 mt-1">已选择 ${selectedPackages.length} 个包体，其中 ${parallelPackages.length} 个将形成多 活动配置编号 并行关联。</p>
          </div>
          <div class="p-4 max-h-[520px] overflow-y-auto space-y-2">
            ${packages.map((p) => {
              const game = getShareGame(p.game_id);
              const checked = cfg.package_ids.includes(p.id);
              const relatedCount = getAllShareConfigsForPackage(p).length;
              return `
                <label class="block rounded-xl border ${checked ? "border-brand-200 bg-brand-50/60" : "border-ink-200 bg-white"} p-3 cursor-pointer hover:border-brand-300">
                  <div class="flex items-start gap-3">
                    <input type="checkbox" class="mt-1" ${checked ? "checked" : ""} />
                    <div class="flex-1 min-w-0">
                      <div class="flex items-center gap-1.5 text-sm font-semibold text-ink-900">
                        ${renderGameIcon(game, "w-5 h-5")}
                        <span>${game?.name}</span>
                        <span class="text-ink-300">/</span>
                        <span class="font-mono text-xs text-ink-600">${p.name}</span>
                      </div>
                      <div class="flex items-center gap-1.5 mt-1">
                        <span class="badge bg-blue-50 text-blue-700">${p.region}</span>
                        <span class="badge bg-ink-100 text-ink-700">${p.platform}</span>
                        ${relatedCount > 0 ? `<span class="badge bg-blue-50 text-blue-700">已有 ${relatedCount} 个 活动配置编号，将并行关联</span>` : `<span class="badge bg-ok-50 text-ok-700">首个 活动配置编号 关联</span>`}
                      </div>
                    </div>
                  </div>
                </label>
              `;
            }).join("")}
          </div>
          <div class="px-5 py-4 border-t border-ink-100 bg-ink-50 flex items-center justify-between gap-3">
            <div class="text-xs text-ink-500">发布后预计 5 分钟内推送到 SDK 配置缓存。</div>
            <button onclick="confirmAction('发布配置方案', '将发布配置方案并绑定到 ${selectedPackages.length} 个包体；其中 ${parallelPackages.length} 个包体将形成多 活动配置编号 并行关联，不存在优先级。', '确认发布', '配置方案已发布，可与其它 活动配置编号 并行调用', '/ops/share-config')" class="px-4 py-2 bg-brand-900 text-white text-sm rounded-lg hover:bg-brand-800">保存并发布</button>
          </div>
        </div>
      </div>
    </div>
  `;
};

// ============================================================
// 创建活动分享（选 卡片 + 选 落地页 → 生成 活动配置编号）
// ============================================================
function getActivityShareDraft() {
  if (!window.__activityShareDraft) {
    window.__activityShareDraft = {
      step: 1,
      cardConfigId: "",      // 选中的"卡片"对应的 cfg.id
      landingPageId: "",     // 选中的 落地页 id
      name: "",
      packageIds: [],
      channels: ["facebook", "messenger", "whatsapp"],
      generatedConfigId: "", // 生成后的 活动配置编号
      // 筛选条件（在重渲染后保持）
      cardFilter: { title: "", id: "" },
      lpFilter: { title: "", id: "" },
    };
  }
  // 兼容旧 draft 缺字段
  if (!window.__activityShareDraft.cardFilter) window.__activityShareDraft.cardFilter = { title: "", id: "" };
  if (!window.__activityShareDraft.lpFilter) window.__activityShareDraft.lpFilter = { title: "", id: "" };
  return window.__activityShareDraft;
}
function resetActivityShareDraft() {
  window.__activityShareDraft = null;
}
function getActivityShareBackPath() {
  const draft = getActivityShareDraft();
  return draft.editingActivityId ? `/ops/share-config/activity/${draft.editingActivityId}/edit` : "/ops/share-config";
}
window.activityShareGoToStep = function (step) {
  const draft = getActivityShareDraft();
  if (step === 2 && !draft.cardConfigId) { UI.toast("请先选择一张已配置卡片", "warn"); return; }
  if (step === 3 && (!draft.cardConfigId || !draft.landingPageId)) { UI.toast("请先完成卡片与落地页的选择", "warn"); return; }
  draft.step = step;
  renderRoute();
};
window.activityShareSelectCard = function (cfgId) {
  const draft = getActivityShareDraft();
  draft.cardConfigId = cfgId;
  // 默认带入该 cfg 关联的第一个 落地页 作为推荐
  const cfg = (MOCK.SHARE_CONFIGS || []).find((c) => c.id === cfgId);
  if (cfg && !draft.landingPageId) {
    const ids = cfg.landing_page_ids || (cfg.landing_page_id ? [cfg.landing_page_id] : []);
    if (ids[0]) draft.landingPageId = ids[0];
  }
  if (cfg && !draft.name) draft.name = `${cfg.name} · 活动分享`;
  if (cfg && (!draft.channels || draft.channels.length === 0) && cfg.channels) draft.channels = [...cfg.channels];
  renderRoute();
};
window.activityShareSelectLandingPage = function (lpId) {
  const draft = getActivityShareDraft();
  draft.landingPageId = lpId;
  renderRoute();
};
window.activityShareSetName = function (val) { getActivityShareDraft().name = val; };
window.activityShareTogglePackage = function (pkgId) {
  const draft = getActivityShareDraft();
  const idx = draft.packageIds.indexOf(pkgId);
  if (idx >= 0) draft.packageIds.splice(idx, 1); else draft.packageIds.push(pkgId);
  // 仅刷新摘要区与按钮态，避免整页重渲染丢失输入焦点
  const stat = document.getElementById("activity-share-pkg-count");
  if (stat) stat.textContent = String(draft.packageIds.length);
  const btn = document.querySelector(`[data-activity-pkg="${pkgId}"]`);
  if (btn) {
    const on = idx < 0;
    btn.classList.toggle("border-brand-500", on);
    btn.classList.toggle("bg-brand-50", on);
    btn.classList.toggle("text-brand-900", on);
  }
};
window.activityShareToggleChannel = function (code) {
  const draft = getActivityShareDraft();
  const idx = draft.channels.indexOf(code);
  if (idx >= 0) draft.channels.splice(idx, 1); else draft.channels.push(code);
  const btn = document.querySelector(`[data-activity-channel="${code}"]`);
  if (btn) {
    const on = idx < 0;
    btn.classList.toggle("border-brand-500", on);
    btn.classList.toggle("bg-brand-50", on);
    btn.classList.toggle("text-brand-900", on);
  }
};
window.activityShareGenerateConfigId = async function () {
  const draft = getActivityShareDraft();
  if (!draft.cardConfigId || !draft.landingPageId) { UI.toast("请完成前两步", "warn"); return; }
  if (!draft.name || !draft.name.trim()) { UI.toast("请填写活动名称", "warn"); return; }
  // 名称从输入框同步（防止 onblur 还没触发）
  const input = document.getElementById("activity-share-name-input");
  if (input) draft.name = input.value;

  try {
    if (draft.editingActivityId) {
      const editingCfg = (MOCK.SHARE_CONFIGS || []).find((item) => item.id === draft.editingActivityId);
      const cardCfg = (MOCK.SHARE_CONFIGS || []).find((c) => c.id === draft.cardConfigId);
      await shareConfigsApi.update(draft.editingActivityId, {
        name: draft.name,
        channels: Array.isArray(draft.channels) ? [...draft.channels] : editingCfg?.channels,
        landing_page_id: draft.landingPageId,
        landing_page_ids: [draft.landingPageId],
        title: cardCfg?.title || editingCfg?.title,
        package_ids: Array.isArray(draft.packageIds) ? [...draft.packageIds] : editingCfg?.package_ids,
      });
      recordActivityConfigUpdate(editingCfg, draft);
      draft.generatedConfigId = editingCfg?.config_id || editingCfg?.id || draft.editingActivityId;
    } else {
      const cardCfg = (MOCK.SHARE_CONFIGS || []).find((c) => c.id === draft.cardConfigId);
      const { data: created } = await shareConfigsApi.create({
        name: draft.name.trim(),
        scope: "package_set",
        status: "draft",
        package_ids: Array.isArray(draft.packageIds) ? [...draft.packageIds] : [],
        landing_page_id: draft.landingPageId,
        landing_page_ids: [draft.landingPageId],
        channels: Array.isArray(draft.channels) ? [...draft.channels] : (cardCfg?.channels || []),
        title: cardCfg?.title || draft.name,
        desc: cardCfg?.desc,
        url: cardCfg?.url,
        image_url: cardCfg?.image_url,
        temple_id: cardCfg?.temple_id ?? null,
        mode: "quick",
      });
      draft.generatedConfigId = created.config_id || created.id;
    }
    await invalidateAndRefresh();
    draft.step = 4;
    renderRoute();
  } catch (err) {
    UI.toast(err?.message || "保存活动失败", "error");
  }
};
window.activityShareCopyConfigId = function () {
  const draft = getActivityShareDraft();
  const id = draft.generatedConfigId;
  if (!id) return;
  const exec = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => UI.toast("活动配置编号 已复制", "success"), () => UI.toast("复制失败，请手动复制", "warn"));
    } else {
      UI.toast("活动配置编号 已复制", "success");
    }
  };
  exec(id);
};

window.copyActivityConfigValue = function (id) {
  if (!id) return;
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(id).then(() => UI.toast("配置值已复制", "success"), () => UI.toast("复制失败，请手动复制", "warning"));
  } else {
    UI.toast("配置值已复制", "success");
  }
};
window.activityShareRestart = function () {
  resetActivityShareDraft();
  navigate("/ops/share-config/activity/create");
};

function renderActivityShareStepper(currentStep) {
  const steps = [
    { n: 1, title: "选择已配置卡片", desc: "确定卡片素材" },
    { n: 2, title: "选择已配置落地页", desc: "确定跳转页面" },
    { n: 3, title: "活动信息", desc: "填写并校验" },
    { n: 4, title: "生成活动配置", desc: "复制给研发使用" },
  ];
  return `
    <div class="card p-4 mb-5">
      <div class="flex items-center gap-2">
        ${steps.map((s, i) => {
    const done = currentStep > s.n;
    const active = currentStep === s.n;
    const tone = done ? "bg-emerald-500 text-white border-emerald-500" : active ? "bg-brand-900 text-white border-brand-900" : "bg-white text-ink-400 border-ink-200";
    const labelTone = done || active ? "text-ink-900" : "text-ink-400";
    return `
            <div class="flex items-center gap-2.5 ${i === 0 ? "" : "ml-1"}">
              <div class="w-7 h-7 rounded-full border-2 flex items-center justify-center text-xs font-semibold ${tone}">${done ? "✓" : s.n}</div>
              <div class="leading-tight">
                <div class="text-[13px] font-semibold ${labelTone}">${s.title}</div>
                <div class="text-[11px] text-ink-400">${s.desc}</div>
              </div>
            </div>
            ${i < steps.length - 1 ? `<div class="flex-1 h-px ${done ? "bg-emerald-300" : "bg-ink-200"} mx-3"></div>` : ""}
          `;
  }).join("")}
      </div>
    </div>
  `;
}

function renderActivityShareSelectionSummary(draft) {
  const cfg = (MOCK.SHARE_CONFIGS || []).find((c) => c.id === draft.cardConfigId);
  const lp = (MOCK.LANDING_PAGES || []).find((p) => p.id === draft.landingPageId);
  const cardId = cfg ? cardIdForConfig(cfg) : "—";
  const lpId = lp ? landingPageIdForLandingPage(lp) : "—";
  return `
    <div class="grid grid-cols-2 gap-3">
      <div class="rounded-xl border ${cfg ? "border-brand-200 bg-brand-50" : "border-dashed border-ink-200 bg-ink-50"} p-3.5">
        <div class="flex items-center justify-between">
          <div class="text-[11px] font-semibold ${cfg ? "text-brand-700" : "text-ink-400"} tracking-wide">已选卡片 (卡片编号)</div>
          ${cfg ? `<button onclick="activityShareGoToStep(1)" class="text-[11px] text-brand-700 hover:underline">更换</button>` : ""}
        </div>
        ${cfg ? `
          <div class="text-sm font-semibold text-ink-900 mt-1.5">${cfg.name}</div>
          <div class="mt-1 text-[11px] text-ink-500 line-clamp-1">${cfg.title || "—"}</div>
          <div class="mt-2">${renderChannelIcons(cfg.channels || [])}</div>
        ` : `<div class="mt-1.5 text-xs text-ink-400">尚未选择卡片</div>`}
      </div>
      <div class="rounded-xl border ${lp ? "border-purple-200 bg-purple-50" : "border-dashed border-ink-200 bg-ink-50"} p-3.5">
        <div class="flex items-center justify-between">
          <div class="text-[11px] font-semibold ${lp ? "text-purple-700" : "text-ink-400"} tracking-wide">已选落地页 (落地页编号)</div>
          ${lp ? `<button onclick="activityShareGoToStep(2)" class="text-[11px] text-purple-700 hover:underline">更换</button>` : ""}
        </div>
        ${lp ? `
          <div class="mt-1.5 font-mono text-xs text-ink-900">${lpId}</div>
          <div class="text-sm font-semibold text-ink-900 mt-1">${lp.name}</div>
          <div class="mt-1 text-[11px] text-ink-500 line-clamp-1">${(lp.source_type === "url" || lp.content_type === "url") ? "外部 URL 注册" : "模版生成"} · ${lp.audience_rule || "默认用户"}</div>
        ` : `<div class="mt-1.5 text-xs text-ink-400">尚未选择落地页</div>`}
      </div>
    </div>
  `;
}

function renderActivityShareCardPicker(draft) {
  const configs = getShareConfigsByCreatedDesc(MOCK.SHARE_CONFIGS || []);
  if (configs.length === 0) {
    return UI.emptyState({ icon: "🃏", title: "暂无已配置卡片", desc: "请先在「分享卡片配置」中创建至少一张卡片，再来创建活动分享。", action: `<button onclick="navigate('/ops/share-card-config')" class="px-4 py-2 bg-brand-900 text-white rounded-lg text-sm">去配置卡片</button>` });
  }
  return `
    <div class="card overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100 bg-gradient-to-r from-brand-50 to-white flex items-center justify-between">
        <div>
          <div class="text-xs font-semibold tracking-wider text-brand-700">STEP 1</div>
          <h3 class="text-base font-semibold text-ink-900 mt-0.5">从「已配置卡片」中选择 1 张</h3>
          <p class="text-[12px] text-ink-500 mt-0.5">不同卡片对应不同的分享样式与素材；活动开始后无法更换。默认按创建时间从新到旧排列。</p>
        </div>
        <button onclick="navigate('/ops/share-card-config')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-white">+ 新增卡片</button>
      </div>
      <!-- 筛选栏：卡片标题 -->
      <div class="px-5 py-3 border-b border-ink-100 bg-white flex flex-wrap items-center gap-2">
        <div class="relative">
          <span class="absolute left-2.5 top-1/2 -translate-y-1/2 text-ink-400 text-xs">🔎</span>
          <input id="activity-card-title-filter" type="text" oninput="filterActivityShareCards()" value="${escapeShareCardValue(draft.cardFilter?.title || "")}" placeholder="按卡片标题筛选" class="pl-7 pr-3 py-1.5 text-xs border border-ink-100 rounded-lg w-56 focus:outline-none focus:border-brand-400" />
        </div>

        <button type="button" onclick="resetActivityShareCardFilter()" class="px-2.5 py-1.5 text-xs border border-ink-100 rounded-lg text-ink-600 hover:bg-ink-50">清空</button>
        <div class="ml-auto text-[11px] text-ink-500" id="activity-card-filter-count">共 ${configs.length} 张</div>
      </div>
      <div class="p-5">
        <div id="activity-card-grid" class="grid grid-cols-6 gap-3">
          ${configs.map((cfg) => renderActivityShareCardOption(cfg, draft.cardConfigId === cfg.id)).join("")}
        </div>
        <div id="activity-card-empty" class="hidden text-center text-xs text-ink-400 py-8">没有匹配的卡片，请调整筛选条件</div>
      </div>
      <div class="px-5 py-3 border-t border-ink-100 bg-ink-50/50 flex items-center justify-end gap-2">
        <button onclick="navigate(getActivityShareBackPath())" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-white">取消</button>
        <button onclick="activityShareGoToStep(2)" class="px-4 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800 disabled:opacity-40" ${draft.cardConfigId ? "" : "disabled"}>下一步：选择落地页 →</button>
      </div>
    </div>
  `;
}

function renderActivityShareCardOption(cfg, selected) {
  const cardId = cardIdForConfig(cfg);
  const landingPages = getLandingPagesForConfig(cfg);
  // 优先使用创建卡片时用户上传的卡片图片（og:image），便于一眼分辨；缺失时才回退到 模版 生成的 SVG 封面
  const uploadedImage = cfg.image_data_url || cfg.image_url || cfg.imageUrl || "";
  const coverUrl = uploadedImage || buildCardCoverDataUrl(cfg, landingPages);
  const hasUploadedImage = !!uploadedImage;
  const channels = (cfg.channels || []).map((code) => MOCK.CHANNELS.find((c) => c.code === code)).filter(Boolean);
  const lpCount = (cfg.landing_page_ids || (cfg.landing_page_id ? [cfg.landing_page_id] : [])).length;
  const pkgCount = (cfg.package_ids || []).length;
  const statusDot = cfg.status === "released"
    ? { cls: "bg-emerald-500", label: "已发布" }
    : cfg.status === "draft"
      ? { cls: "bg-amber-500", label: "草稿" }
      : cfg.status === "offline"
        ? { cls: "bg-ink-400", label: "已下线" }
        : { cls: "bg-ink-300", label: cfg.status || "未知" };
  const titleAttr = (cfg.title || cfg.name || "").replace(/"/g, "&quot;");
  const filterTitleText = [cfg.name, cfg.title].filter(Boolean).join(" ").toLowerCase();
  const filterIdText = [cardId, configId(cfg), cfg.id].filter(Boolean).join(" ").toLowerCase();
  return `
    <button type="button" onclick="activityShareSelectCard('${cfg.id}')" title="${titleAttr}"
      data-activity-card-option="1"
      data-filter-title="${escapeShareCardValue(filterTitleText)}"
      data-filter-id="${escapeShareCardValue(filterIdText)}"
      class="group relative w-full aspect-square rounded-xl border-2 ${selected ? "border-brand-500 ring-2 ring-brand-200" : "border-ink-100 hover:border-brand-300"} overflow-hidden transition-all bg-white flex flex-col">
      <!-- 上半部：封面图（优先使用创建卡片时上传的卡片图，更易分辨） -->
      <div class="relative flex-1 overflow-hidden ${hasUploadedImage ? "bg-white" : "bg-ink-100"}">
        <img src="${coverUrl}" alt="${titleAttr}" class="absolute inset-0 w-full h-full ${hasUploadedImage ? "object-contain p-2" : "object-cover"} select-none" draggable="false" />
        <div class="absolute top-1.5 left-1.5"><code class="px-1 py-0.5 rounded bg-white/85 backdrop-blur text-[9px] font-mono text-brand-700">${cardId}</code></div>
        ${selected ? `<div class="absolute top-1.5 right-1.5 w-5 h-5 rounded-full bg-brand-900 text-white text-[10px] flex items-center justify-center shadow">✓</div>` : ""}
        <div class="absolute bottom-1.5 left-1.5 flex items-center gap-1 px-1.5 py-0.5 rounded bg-white/85 backdrop-blur text-[9px] text-ink-700">
          <span class="w-1.5 h-1.5 rounded-full ${statusDot.cls}"></span>
          <span>${statusDot.label}</span>
        </div>
      </div>
      <!-- 下半部：信息区 -->
      <div class="px-2 py-1.5 border-t border-ink-100 text-left bg-white">
        <div class="text-[11px] font-semibold text-ink-900 line-clamp-1 leading-tight">${cfg.name}</div>
        <div class="mt-1 flex items-center justify-between gap-1">
          <div class="flex items-center gap-0.5 min-w-0 overflow-hidden">
            ${channels.slice(0, 4).map((c) => `<span class="text-[11px] leading-none">${c.icon}</span>`).join("")}
            ${channels.length > 4 ? `<span class="text-[9px] text-ink-400 ml-0.5">+${channels.length - 4}</span>` : ""}
            ${channels.length === 0 ? `<span class="text-[9px] text-ink-300">未启用</span>` : ""}
          </div>
          <div class="flex items-center gap-1 text-[9px] text-ink-500 shrink-0">
            <span title="关联落地页数">🌐${lpCount}</span>
            <span title="适用包体数">📦${pkgCount}</span>
          </div>
        </div>
      </div>
    </button>
  `;
}

function renderActivityShareLandingPicker(draft) {
  const lps = getLandingPagesByCreatedDesc();
  if (lps.length === 0) {
    return UI.emptyState({ icon: "🌐", title: "暂无已配置落地页", desc: "请先在「分享落地页配置」中创建一个 落地页，再回到这里完成活动分享。", action: `<button onclick="navigate('/ops/share-landing-config')" class="px-4 py-2 bg-brand-900 text-white rounded-lg text-sm">去配置落地页</button>` });
  }
  const templeLPs = lps.filter((p) => !(p.source_type === "url" || p.content_type === "url"));
  const urlLPs = lps.filter((p) => p.source_type === "url" || p.content_type === "url");
  return `
    <div class="space-y-4">
      ${renderActivityShareSelectionSummary(draft)}
      <div class="card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100 bg-gradient-to-r from-purple-50 to-white flex items-center justify-between">
          <div>
            <div class="text-xs font-semibold tracking-wider text-purple-700">STEP 2</div>
            <h3 class="text-base font-semibold text-ink-900 mt-0.5">从「已配置落地页」中选择 1 个</h3>
            <p class="text-[12px] text-ink-500 mt-0.5">客户端拉起 活动配置编号 时，被分享者打开后将看到这个落地页。默认按创建时间从新到旧排列。</p>
          </div>
          <button onclick="navigate('/ops/share-landing-config')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-white">+ 新增落地页</button>
        </div>
        <!-- 筛选栏：落地页标题 -->
        <div class="px-5 py-3 border-b border-ink-100 bg-white flex flex-wrap items-center gap-2">
          <div class="relative">
            <span class="absolute left-2.5 top-1/2 -translate-y-1/2 text-ink-400 text-xs">🔎</span>
            <input id="activity-lp-title-filter" type="text" oninput="filterActivityShareLandingPages()" value="${escapeShareCardValue(draft.lpFilter?.title || "")}" placeholder="按落地页标题筛选" class="pl-7 pr-3 py-1.5 text-xs border border-ink-100 rounded-lg w-56 focus:outline-none focus:border-purple-400" />
          </div>

          <button type="button" onclick="resetActivityShareLandingFilter()" class="px-2.5 py-1.5 text-xs border border-ink-100 rounded-lg text-ink-600 hover:bg-ink-50">清空</button>
          <div class="ml-auto text-[11px] text-ink-500" id="activity-lp-filter-count">共 ${lps.length} 个</div>
        </div>
        <div class="p-5 space-y-5">
          ${templeLPs.length ? `
            <div data-activity-lp-section="temple">
              <div class="flex items-center gap-2 mb-2">
                <span class="text-[11px] font-semibold tracking-wide text-brand-700">模版 生成</span>
                <span class="text-[11px] text-ink-400" data-activity-lp-section-count>${templeLPs.length} 个</span>
              </div>
              <div class="grid grid-cols-2 gap-3">
                ${templeLPs.map((p) => renderActivityShareLPOption(p, draft.landingPageId === p.id)).join("")}
              </div>
            </div>` : ""}
          ${urlLPs.length ? `
            <div data-activity-lp-section="url">
              <div class="flex items-center gap-2 mb-2">
                <span class="text-[11px] font-semibold tracking-wide text-purple-700">外部 URL 注册</span>
                <span class="text-[11px] text-ink-400" data-activity-lp-section-count>${urlLPs.length} 个</span>
              </div>
              <div class="grid grid-cols-2 gap-3">
                ${urlLPs.map((p) => renderActivityShareLPOption(p, draft.landingPageId === p.id)).join("")}
              </div>
            </div>` : ""}
          <div id="activity-lp-empty" class="hidden text-center text-xs text-ink-400 py-8">没有匹配的落地页，请调整筛选条件</div>
        </div>
        <div class="px-5 py-3 border-t border-ink-100 bg-ink-50/50 flex items-center justify-between">
          <button onclick="activityShareGoToStep(1)" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-white">← 上一步</button>
          <div class="flex items-center gap-2">
            <button onclick="navigate(getActivityShareBackPath())" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-white">取消</button>
            <button onclick="activityShareGoToStep(3)" class="px-4 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800 disabled:opacity-40" ${draft.landingPageId ? "" : "disabled"}>下一步：活动信息 →</button>
          </div>
        </div>
      </div>
    </div>
  `;
}

function renderActivityShareLPOption(lp, selected) {
  const lpId = landingPageIdForLandingPage(lp);
  const isUrl = lp.source_type === "url" || lp.content_type === "url";
  const tone = isUrl ? "from-purple-100 to-purple-50" : "from-brand-100 to-brand-50";
  const ico = isUrl ? "🔗" : "🧩";
  const filterTitleText = [lp.name, lp.title, lp.audience_rule].filter(Boolean).join(" ").toLowerCase();
  const filterIdText = [lpId, lp.id].filter(Boolean).join(" ").toLowerCase();
  return `
    <button type="button" onclick="activityShareSelectLandingPage('${lp.id}')"
      data-activity-lp-option="1"
      data-filter-title="${escapeShareCardValue(filterTitleText)}"
      data-filter-id="${escapeShareCardValue(filterIdText)}"
      class="text-left rounded-xl border-2 ${selected ? "border-purple-500 ring-2 ring-purple-200" : "border-ink-100 hover:border-purple-300"} bg-white overflow-hidden transition-all">
      <div class="flex items-stretch">
        <div class="w-14 flex items-center justify-center bg-gradient-to-br ${tone} text-2xl">${ico}</div>
        <div class="flex-1 p-3">
          <div class="flex items-center gap-1.5 flex-wrap mb-1">
            ${UI.statusBadge(lp.status)}
            ${selected ? `<span class="px-1.5 py-0.5 rounded bg-purple-900 text-white text-[10px]">✓ 已选</span>` : ""}
          </div>
          <div class="text-sm font-semibold text-ink-900 line-clamp-1">${lp.name}</div>
          <div class="text-[11px] text-ink-500 line-clamp-1 mt-0.5">${lp.audience_rule || "默认用户"}</div>
          ${lp.url ? `<div class="text-[11px] text-purple-600 font-mono line-clamp-1 mt-1">${lp.url}</div>` : ""}
        </div>
      </div>
    </button>
  `;
}

// ---------- 创建活动分享 · STEP 1/2 筛选（纯 DOM 操作，避免重渲染丢失输入焦点） ----------
window.filterActivityShareCards = function () {
  const titleKw = (document.getElementById("activity-card-title-filter")?.value || "").trim().toLowerCase();
  const idKw = (document.getElementById("activity-card-id-filter")?.value || "").trim().toLowerCase();
  // 持久化到 draft，使重渲染后保持
  const draft = getActivityShareDraft();
  draft.cardFilter = { title: titleKw, id: idKw };
  const opts = document.querySelectorAll('[data-activity-card-option="1"]');
  let visible = 0;
  opts.forEach((el) => {
    const t = el.getAttribute("data-filter-title") || "";
    const i = el.getAttribute("data-filter-id") || "";
    const okTitle = !titleKw || t.includes(titleKw);
    const okId = !idKw || i.includes(idKw);
    const show = okTitle && okId;
    el.style.display = show ? "" : "none";
    if (show) visible += 1;
  });
  const total = opts.length;
  const cnt = document.getElementById("activity-card-filter-count");
  if (cnt) cnt.textContent = (titleKw || idKw) ? `匹配 ${visible} / ${total} 张` : `共 ${total} 张`;
  const empty = document.getElementById("activity-card-empty");
  if (empty) empty.classList.toggle("hidden", visible !== 0);
  const grid = document.getElementById("activity-card-grid");
  if (grid) grid.classList.toggle("hidden", visible === 0);
};
window.resetActivityShareCardFilter = function () {
  const a = document.getElementById("activity-card-title-filter");
  const b = document.getElementById("activity-card-id-filter");
  if (a) a.value = "";
  if (b) b.value = "";
  window.filterActivityShareCards();
};

window.filterActivityShareLandingPages = function () {
  const titleKw = (document.getElementById("activity-lp-title-filter")?.value || "").trim().toLowerCase();
  const idKw = (document.getElementById("activity-lp-id-filter")?.value || "").trim().toLowerCase();
  const draft = getActivityShareDraft();
  draft.lpFilter = { title: titleKw, id: idKw };
  const opts = document.querySelectorAll('[data-activity-lp-option="1"]');
  let visible = 0;
  opts.forEach((el) => {
    const t = el.getAttribute("data-filter-title") || "";
    const i = el.getAttribute("data-filter-id") || "";
    const okTitle = !titleKw || t.includes(titleKw);
    const okId = !idKw || i.includes(idKw);
    const show = okTitle && okId;
    el.style.display = show ? "" : "none";
    if (show) visible += 1;
  });
  // 分组容器：所在分组无可见项时整组隐藏并更新分组计数
  document.querySelectorAll("[data-activity-lp-section]").forEach((section) => {
    const items = section.querySelectorAll('[data-activity-lp-option="1"]');
    const sectionVisible = Array.from(items).filter((el) => el.style.display !== "none").length;
    section.style.display = sectionVisible === 0 ? "none" : "";
    const countEl = section.querySelector("[data-activity-lp-section-count]");
    if (countEl) countEl.textContent = `${sectionVisible} 个`;
  });
  const total = opts.length;
  const cnt = document.getElementById("activity-lp-filter-count");
  if (cnt) cnt.textContent = (titleKw || idKw) ? `匹配 ${visible} / ${total} 个` : `共 ${total} 个`;
  const empty = document.getElementById("activity-lp-empty");
  if (empty) empty.classList.toggle("hidden", visible !== 0);
};
window.resetActivityShareLandingFilter = function () {
  const a = document.getElementById("activity-lp-title-filter");
  const b = document.getElementById("activity-lp-id-filter");
  if (a) a.value = "";
  if (b) b.value = "";
  window.filterActivityShareLandingPages();
};

function renderActivityShareInfoForm(draft) {
  const cfg = (MOCK.SHARE_CONFIGS || []).find((c) => c.id === draft.cardConfigId);
  const lp = (MOCK.LANDING_PAGES || []).find((p) => p.id === draft.landingPageId);
  return `
    <div class="space-y-4">
      ${renderActivityShareSelectionSummary(draft)}

      <div class="card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100 bg-gradient-to-r from-emerald-50 to-white">
          <div class="text-xs font-semibold tracking-wider text-emerald-700">STEP 3</div>
          <h3 class="text-base font-semibold text-ink-900 mt-0.5">填写活动名称</h3>
          <p class="text-[12px] text-ink-500 mt-0.5">活动名称仅供运营内部识别，便于在列表中检索这条 活动配置编号。</p>
        </div>
        <div class="p-5 space-y-5">
          <div>
            <label class="block text-sm font-medium text-ink-700 mb-1.5">活动名称 <span class="text-rose-500">*</span></label>
            <input id="activity-share-name-input" value="${(draft.name || "").replace(/"/g, "&quot;")}" oninput="activityShareSetName(this.value)" placeholder="例如：王者征途 5 月限时活动 · 邀请有奖" class="w-full px-3 py-2.5 border border-ink-200 rounded-lg text-sm" />
          </div>

          <div class="rounded-xl border border-ink-100 bg-ink-50 p-4">
            <div class="text-[11px] font-semibold tracking-wide text-ink-500 mb-2">组合预览</div>
            <div class="flex items-center gap-2 text-xs text-ink-700 flex-wrap">
              <span class="px-2 py-1 rounded bg-white border border-brand-200 text-brand-700">${cfg?.name || "未选择卡片"}</span>
              <span class="text-ink-400">+</span>
              <span class="px-2 py-1 rounded bg-white border border-purple-200 text-purple-700">${lp?.name || "未选择落地页"}</span>
              <span class="text-ink-400">→</span>
              <span class="px-2 py-1 rounded bg-brand-900 text-white">活动配置</span>
            </div>
            <p class="text-[11px] text-ink-500 mt-2">保存后会生成一条活动配置，研发在 SDK 调用时使用该活动配置完成分享。</p>
          </div>
        </div>
        <div class="px-5 py-3 border-t border-ink-100 bg-ink-50/50 flex items-center justify-between">
          <button onclick="activityShareGoToStep(2)" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-white">← 上一步</button>
          <div class="flex items-center gap-2">
            <button onclick="navigate(getActivityShareBackPath())" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-white">取消</button>
            <button onclick="activityShareGenerateConfigId()" class="px-4 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800 shadow-soft">${draft.editingActivityId ? "更新活动配置" : "完成活动创建"}</button>
          </div>
        </div>
      </div>
    </div>
  `;
}

function renderActivityShareSuccess(draft) {
  const cfg = (MOCK.SHARE_CONFIGS || []).find((c) => c.id === draft.cardConfigId);
  const lp = (MOCK.LANDING_PAGES || []).find((p) => p.id === draft.landingPageId);
  const generated = draft.generatedConfigId || "—";
  const sdkSample = `// 客户端集成（伪代码）：客户端无需关心 卡片 / 落地页 细节
EasyShareSDK.share({
  configId: "${generated}", // ← 由运营在系统中提供
  scenarioId: "default",     // 可选：场景区分
});`;
  return `
    <div class="card overflow-hidden">
      <div class="px-6 py-5 bg-gradient-to-br from-emerald-50 via-brand-50 to-white border-b border-ink-100">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-full bg-emerald-500 text-white flex items-center justify-center text-lg">✓</div>
          <div>
            <h3 class="text-base font-semibold text-ink-900">${draft.editingActivityId ? "活动配置已更新" : "活动分享创建成功"}</h3>
            <p class="text-[12px] text-ink-500 mt-0.5">${draft.editingActivityId ? "已复用原活动配置编号并保存最新配置。" : "已生成 活动配置编号。请将此 ID 同步给研发，由其在调用分享 SDK 时传入。"}</p>
          </div>
        </div>
      </div>
      <div class="p-6 space-y-5">
        <div class="rounded-xl border-2 border-brand-200 bg-brand-50 p-4 flex items-center justify-between gap-3">
          <div class="min-w-0">
            <div class="text-[11px] font-semibold tracking-wide text-brand-700">${draft.editingActivityId ? "复用的 活动配置编号" : "生成的 活动配置编号"}</div>
            <div class="mt-1 font-mono text-xl font-bold text-brand-900 tracking-wider truncate">${generated}</div>
            <div class="text-[11px] text-brand-700/80 mt-1">活动名称：${draft.name || "—"}</div>
          </div>
          <button onclick="activityShareCopyConfigId()" class="shrink-0 px-4 py-2 bg-brand-900 text-white text-sm rounded-lg hover:bg-brand-800 shadow-soft">复制配置值</button>
        </div>

        <div class="grid grid-cols-3 gap-3">
          <div class="rounded-lg border border-ink-100 bg-white p-3">
            <div class="text-[11px] text-ink-400">分享卡片</div>
            <div class="mt-1 text-xs text-ink-900 line-clamp-1">${cfg?.name || "—"}</div>
            <div class="text-[11px] text-ink-500 mt-1 line-clamp-1">${cfg?.title || "—"}</div>
          </div>
          <div class="rounded-lg border border-ink-100 bg-white p-3">
            <div class="text-[11px] text-ink-400">落地页</div>
            <div class="mt-1 text-xs text-ink-900 line-clamp-1">${lp?.name || "—"}</div>
            <div class="text-[11px] text-ink-500 mt-1">${lp ? ((lp.source_type === "url" || lp.content_type === "url") ? "外部 URL" : "模板落地页") : "—"}</div>
          </div>
          <div class="rounded-lg border border-ink-100 bg-white p-3">
            <div class="text-[11px] text-ink-400">活动名称</div>
            <div class="mt-1 text-xs text-ink-900 line-clamp-1">${draft.name || "—"}</div>
            <div class="text-[11px] text-ink-500 mt-1">创建于 ${new Date().toLocaleString("zh-CN", { hour12: false })}</div>
          </div>
        </div>

        <div class="rounded-xl border border-ink-100 overflow-hidden">
          <div class="px-4 py-2.5 bg-ink-900 text-ink-200 text-[11px] font-mono flex items-center justify-between">
            <span>研发集成示例</span>
            <span class="text-ink-400">EasyShare SDK</span>
          </div>
          <pre class="p-4 bg-ink-900 text-emerald-200 text-[12px] font-mono leading-relaxed overflow-auto"><code>${sdkSample.replace(/</g, "&lt;")}</code></pre>
        </div>

        <div class="flex items-center justify-end gap-2 pt-1">
          ${draft.editingActivityId ? "" : `<button onclick="activityShareRestart()" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">再创建一个</button>`}
          <button onclick="navigate(getActivityShareBackPath())" class="px-4 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">${draft.editingActivityId ? "返回活动详情" : "返回分享活动配置列表"}</button>
        </div>
      </div>
    </div>
  `;
}

function getActivityConfigUpdateLogStore() {
  window.__activityConfigUpdateLogs = window.__activityConfigUpdateLogs || [
    { activityId: "cfg_plan_003", operationTime: "2026-06-05 17:20", operator: "赵六", action: "更换分享卡片", target: "分享卡片", detail: "卡片素材更新为公会招募版本", result: "已保存", trendLabel: "卡片更新" },
    { activityId: "cfg_plan_003", operationTime: "2026-06-05 17:22", operator: "赵六", action: "更换落地页", target: "落地页", detail: "落地页更新为联盟招募活动页", result: "已保存", trendLabel: "落地页更新" },
    { activityId: "cfg_plan_005", operationTime: "2026-06-03 11:42", operator: "王五", action: "更新活动配置", target: "分享卡片 / 落地页", detail: "更新活动名称、卡片文案和落地页绑定", result: "已保存", trendLabel: "配置更新" },
  ];
  return window.__activityConfigUpdateLogs;
}

function getActivityConfigUpdateLogs(activityId) {
  return getActivityConfigUpdateLogStore().filter((log) => !activityId || log.activityId === activityId);
}
window.getActivityConfigUpdateLogs = getActivityConfigUpdateLogs;

window.getShareActivityUpdateTrendMarks = function (dates = [], activityId = "") {
  const dateSet = new Set(dates);
  const format = (value) => {
    const d = new Date(String(value || "").replace(" ", "T"));
    if (Number.isNaN(d.getTime())) return "";
    return `${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}`;
  };
  const grouped = new Map();
  getActivityConfigUpdateLogs(activityId).forEach((log) => {
    const day = format(log.operationTime);
    if (!day || !dateSet.has(day)) return;
    grouped.set(day, [...(grouped.get(day) || []), log]);
  });
  return Array.from(grouped.entries()).map(([day, logs]) => {
    const changePoints = Array.from(new Set(logs.map((log) => log.trendLabel || log.action)));
    return {
      name: changePoints.join(" + "),
      value: [day, 34 + Math.min(4, logs.length)],
      logs,
      label: changePoints.length > 2 ? `${changePoints.slice(0, 2).join(" + ")} +${changePoints.length - 2}` : changePoints.join(" + "),
      detailLabel: logs.map((log) => `${log.trendLabel || log.action}：${log.detail}`).join("；"),
    };
  });
};

function recordActivityConfigUpdate(cfg, draft) {
  if (!cfg || !draft?.editingActivityId || draft.__updateCommitted) return;
  const oldCardId = draft.originalCardConfigId || draft.editingActivityId;
  const oldLandingId = draft.originalLandingPageId || cfg.landing_page_id || (cfg.landing_page_ids || [])[0] || "";
  const newCardCfg = (MOCK.SHARE_CONFIGS || []).find((item) => item.id === draft.cardConfigId);
  const newLanding = (MOCK.LANDING_PAGES || []).find((item) => item.id === draft.landingPageId);
  const now = new Date().toLocaleString("zh-CN", { hour12: false }).replace(/\//g, "-");
  const operator = MOCK.ROLES?.[MOCK.SESSION?.currentRole]?.user || cfg.owner || "当前用户";
  const logs = [];
  if (draft.cardConfigId && draft.cardConfigId !== oldCardId) {
    logs.push({ activityId: cfg.id, operationTime: now, operator, action: "更换分享卡片", target: "分享卡片", detail: `从 ${cardIdForConfig({ id: oldCardId })} 更换为 ${newCardCfg ? cardIdForConfig(newCardCfg) : draft.cardConfigId}`, result: "已保存", trendLabel: "卡片更新" });
    if (newCardCfg?.title) cfg.title = newCardCfg.title;
  }
  if (draft.landingPageId && draft.landingPageId !== oldLandingId) {
    logs.push({ activityId: cfg.id, operationTime: now, operator, action: "更换落地页", target: "落地页", detail: `从 ${oldLandingId || "未设置"} 更换为 ${newLanding ? landingPageIdForLandingPage(newLanding) : draft.landingPageId}`, result: "已保存", trendLabel: "落地页更新" });
    cfg.landing_page_id = draft.landingPageId;
    cfg.landing_page_ids = [draft.landingPageId];
  }
  if (!logs.length) {
    logs.push({ activityId: cfg.id, operationTime: now, operator, action: "更新活动配置", target: "活动配置", detail: "保存活动配置基础信息", result: "已保存", trendLabel: "配置更新" });
  }
  cfg.name = draft.name || cfg.name;
  cfg.channels = Array.isArray(draft.channels) ? [...draft.channels] : cfg.channels;
  cfg.updated = now.slice(0, 16);
  getActivityConfigUpdateLogStore().unshift(...logs);
  draft.__updateCommitted = true;
}

Pages.activityShareDetail = function (activityId) {
  const cfg = (MOCK.SHARE_CONFIGS || []).find((item) => item.id === activityId) || (MOCK.SHARE_CONFIGS || []).find((item) => item.scope === "package_set") || (MOCK.SHARE_CONFIGS || [])[0];
  const landingPage = getLandingPagesForConfig(cfg)[0];
  const targetPackages = getOpsVisiblePackages().filter((pkg) => (cfg.package_ids || []).includes(pkg.id));
  const languageCount = getShareActivityLanguageCount(cfg);
  const generated = configId(cfg);
  const cardId = cardIdForConfig(cfg);
  const landingId = landingPage ? landingPageIdForLandingPage(landingPage) : "—";
  const createdAt = cfg.created_at || "2026-05-28 10:30";
  const creator = cfg.creator || cfg.owner || "张三";
  const cardTitle = cfg.title || cfg.name || "—";
  const landingType = landingPage ? ((landingPage.source_type === "url" || landingPage.content_type === "url") ? "外部 URL" : "模板落地页") : "—";
  const operationLogs = [
    ...getActivityConfigUpdateLogs(cfg.id),
    { operationTime: "2026-06-01 14:18", operator: "李四", action: "发布活动", target: "发布状态", detail: "活动状态更新为已发布", result: "已发布" },
    { operationTime: createdAt, operator: creator, action: "创建活动", target: "活动配置", detail: "生成活动分享配置", result: "已创建" },
  ];
  return `
    ${UI.pageHeader({
      title: "活动详情",
      desc: "集中查看活动配置编号、卡片编号、落地页编号、包体数、多语言数、启用渠道和发布状态。",
      actions: `
        <button onclick="navigate('/ops/share-config')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">返回活动管理</button>
        <button onclick="startEditActivityShare('${cfg.id}')" class="px-3 py-1.5 text-sm bg-brand-900 text-white rounded-lg hover:bg-brand-800">编辑活动</button>
      `,
    })}

    <div class="card overflow-hidden mb-5">
      <div class="px-6 py-5 bg-gradient-to-br from-emerald-50 via-brand-50 to-white border-b border-ink-100">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-full bg-emerald-500 text-white flex items-center justify-center text-lg">✓</div>
          <div>
            <h3 class="text-base font-semibold text-ink-900">${cfg.name || "活动分享"}</h3>
            <div class="text-[12px] text-ink-500 mt-0.5">活动配置编号聚合了卡片、落地页、包体、多语言和渠道投放信息。</div>
          </div>
        </div>
      </div>
      <div class="p-6 space-y-5">
        <div class="rounded-xl border-2 border-brand-200 bg-brand-50 p-4 flex items-center justify-between gap-3">
          <div class="min-w-0">
            <div class="text-[11px] font-semibold tracking-wide text-brand-700">活动配置编号</div>
            <div class="mt-1 font-mono text-xl font-bold text-brand-900 tracking-wider truncate">${generated}</div>
            <div class="text-[11px] text-brand-700/80 mt-1">卡片 ${cardId} · 落地页 ${landingId} · ${targetPackages.length} 个包体 · ${languageCount} 个语言版本</div>
          </div>
          <button onclick="copyActivityConfigValue('${generated}')" class="shrink-0 px-4 py-2 bg-brand-900 text-white text-sm rounded-lg hover:bg-brand-800 shadow-soft">复制配置值</button>
        </div>

        <div class="grid grid-cols-4 gap-3">
          <div class="rounded-lg border border-ink-100 bg-white p-3">
            <div class="text-[11px] text-ink-400">卡片编号</div>
            <div class="mt-1 text-xs text-ink-900 line-clamp-1 font-mono">${cardId}</div>
            <div class="text-[11px] text-ink-500 mt-1 line-clamp-1">${cardTitle}</div>
          </div>
          <div class="rounded-lg border border-ink-100 bg-white p-3">
            <div class="text-[11px] text-ink-400">落地页编号</div>
            <div class="mt-1 text-xs text-ink-900 line-clamp-1 font-mono">${landingId}</div>
            <div class="text-[11px] text-ink-500 mt-1">${landingPage?.name || "—"} · ${landingType}</div>
          </div>
          <div class="rounded-lg border border-ink-100 bg-white p-3">
            <div class="text-[11px] text-ink-400">包体数</div>
            <div class="mt-1 num text-xl font-semibold text-ink-900">${targetPackages.length}</div>
            <div class="text-[11px] text-ink-500 mt-1 line-clamp-1">${targetPackages.slice(0, 2).map((pkg) => packageFullName(pkg)).join("、")}${targetPackages.length > 2 ? " 等" : ""}</div>
          </div>
          <div class="rounded-lg border border-ink-100 bg-white p-3">
            <div class="text-[11px] text-ink-400">多语言数</div>
            <div class="mt-1 num text-xl font-semibold text-ink-900">${languageCount}</div>
            <div class="text-[11px] text-ink-500 mt-1">语言版本</div>
          </div>
          <div class="rounded-lg border border-ink-100 bg-white p-3">
            <div class="text-[11px] text-ink-400">启用渠道</div>
            <div class="mt-1">${renderChannelIcons(cfg.channels)}</div>
            <div class="text-[11px] text-ink-500 mt-1">${(cfg.channels || []).length} 个渠道</div>
          </div>
          <div class="rounded-lg border border-ink-100 bg-white p-3">
            <div class="text-[11px] text-ink-400">当前状态</div>
            <div class="mt-1">${UI.statusBadge(cfg.status)}</div>
            <div class="text-[11px] text-ink-500 mt-1">${cfg.mode === "expert" ? "高级活动" : "标准活动"}</div>
          </div>
          <div class="rounded-lg border border-ink-100 bg-white p-3">
            <div class="text-[11px] text-ink-400">更新 / 负责人</div>
            <div class="mt-1 text-xs text-ink-900 line-clamp-1">${cfg.updated || "—"}</div>
            <div class="text-[11px] text-ink-500 mt-1">负责人：${cfg.owner || "—"}</div>
          </div>
          <div class="rounded-lg border border-ink-100 bg-white p-3">
            <div class="text-[11px] text-ink-400">创建信息</div>
            <div class="mt-1 text-xs text-ink-900 line-clamp-1">${createdAt}</div>
            <div class="text-[11px] text-ink-500 mt-1">创建人：${creator}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-5 mb-5">
      <div class="col-span-7 card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100">
          <h3 class="text-sm font-semibold text-ink-900">关联包体</h3>
          <p class="text-xs text-ink-500 mt-0.5">与分享活动管理列表中的「包体数」一致。</p>
        </div>
        <div class="p-5 grid grid-cols-2 gap-2">
          ${targetPackages.length ? targetPackages.map((pkg) => `<div class="rounded-lg border border-ink-100 bg-ink-50 px-3 py-2 text-xs"><div class="font-medium text-ink-800 truncate">${packageFullName(pkg)}</div><div class="mt-1 font-mono text-[11px] text-ink-400">${pkg.id}</div></div>`).join("") : `<div class="col-span-2 text-xs text-ink-400">暂无关联包体</div>`}
        </div>
      </div>
      <div class="col-span-5 card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100">
          <h3 class="text-sm font-semibold text-ink-900">多语言版本</h3>
          <p class="text-xs text-ink-500 mt-0.5">与分享活动管理列表中的「多语言数」一致。</p>
        </div>
        <div class="p-5 flex flex-wrap gap-2">
          ${renderShareActivityLanguageChips(cfg)}
        </div>
      </div>
    </div>

    <div class="card overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
        <h3 class="text-sm font-semibold text-ink-900">操作日志</h3>
        <span class="text-xs text-ink-400">共 ${operationLogs.length} 条</span>
      </div>
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500 border-b border-ink-100">
          <tr>
            <th class="text-left px-5 py-3 font-medium">操作内容</th>
            <th class="text-left px-4 py-3 font-medium">操作对象</th>
            <th class="text-left px-4 py-3 font-medium">操作人</th>
            <th class="text-left px-4 py-3 font-medium">操作时间</th>
            <th class="text-left px-4 py-3 font-medium">结果</th>
            <th class="text-left px-5 py-3 font-medium">说明</th>
          </tr>
        </thead>
        <tbody>
          ${operationLogs.map((log) => `
            <tr class="border-b last:border-b-0 border-ink-100 row-hover">
              <td class="px-5 py-3 font-medium text-ink-900">${log.action}</td>
              <td class="px-4 py-3 text-ink-600">${log.target}</td>
              <td class="px-4 py-3 text-ink-700">${log.operator}</td>
              <td class="px-4 py-3 text-ink-600 whitespace-nowrap">${log.operationTime}</td>
              <td class="px-4 py-3"><span class="badge bg-ok-50 text-ok-700">${log.result}</span></td>
              <td class="px-5 py-3 text-ink-500">${log.detail}</td>
            </tr>
          `).join("")}
        </tbody>
      </table>
      <div class="px-5 py-4 border-t border-ink-100 flex items-center justify-end gap-2">
        <button onclick="navigate('/ops/share-config')" class="px-4 py-2 border border-ink-100 text-sm rounded-lg hover:bg-ink-50">返回</button>
        <button onclick="startEditActivityShare('${cfg.id}')" class="px-4 py-2 bg-brand-900 text-white text-sm rounded-lg hover:bg-brand-800">编辑活动</button>
      </div>
    </div>
  `;
};

window.startEditActivityShare = function (activityId) {
  resetActivityShareDraft();
  navigate(`/ops/share-config/activity/${activityId}/edit-flow`);
};

function seedActivityShareEditDraft(activityId) {
  const cfg = (MOCK.SHARE_CONFIGS || []).find((item) => item.id === activityId) || (MOCK.SHARE_CONFIGS || []).find((item) => item.scope === "package_set") || (MOCK.SHARE_CONFIGS || [])[0];
  if (!window.__activityShareDraft || window.__activityShareDraft.editingActivityId !== activityId) {
    window.__activityShareDraft = {
      step: 1,
      cardConfigId: cfg.id,
      landingPageId: cfg.landing_page_id || (cfg.landing_page_ids || [])[0] || "",
      name: cfg.name || "",
      packageIds: [...(cfg.package_ids || [])],
      channels: [...(cfg.channels || [])],
      generatedConfigId: configId(cfg),
      editingActivityId: activityId,
      originalCardConfigId: cfg.id,
      originalLandingPageId: cfg.landing_page_id || (cfg.landing_page_ids || [])[0] || "",
      cardFilter: { title: "", id: "" },
      lpFilter: { title: "", id: "" },
    };
  }
  return window.__activityShareDraft;
}

Pages.activityShareEdit = function (activityId) {
  seedActivityShareEditDraft(activityId);
  return Pages.activityShareCreate();
};

Pages.activityShareCreate = function () {
  const currentPath = location.hash.replace(/^#/, "").split("?")[0] || "/";
  if (currentPath === "/ops/share-config/activity/create" && window.__activityShareDraft?.editingActivityId) {
    resetActivityShareDraft();
  }
  const draft = getActivityShareDraft();
  let body = "";
  if (draft.step === 1) body = renderActivityShareCardPicker(draft);
  else if (draft.step === 2) body = renderActivityShareLandingPicker(draft);
  else if (draft.step === 3) body = renderActivityShareInfoForm(draft);
  else body = renderActivityShareSuccess(draft);

  // 渲染后回填筛选状态：值已经通过 input 的 value 属性渲染在 DOM 上，
  // 这里再触发一次筛选函数，把卡片/LP 选项的可见性同步到当前关键字
  if (draft.step === 1 && (draft.cardFilter?.title || draft.cardFilter?.id)) {
    window.PageHooks = window.PageHooks || {};
    window.PageHooks.mounted = () => { try { window.filterActivityShareCards(); } catch (_) { /* noop */ } };
  } else if (draft.step === 2 && (draft.lpFilter?.title || draft.lpFilter?.id)) {
    window.PageHooks = window.PageHooks || {};
    window.PageHooks.mounted = () => { try { window.filterActivityShareLandingPages(); } catch (_) { /* noop */ } };
  }

  return `
    ${UI.pageHeader({
    title: draft.editingActivityId ? "编辑活动" : "创建活动分享",
    desc: "",
    actions: `
        <button onclick="navigate('${draft.editingActivityId ? `/ops/share-config/activity/${draft.editingActivityId}/edit` : "/ops/share-config"}')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">${draft.editingActivityId ? "返回活动详情" : "返回分享活动配置"}</button>
      `,
  })}
    ${typeof renderOpsModuleTabs === "function" ? renderOpsModuleTabs("activity") : ""}

    ${renderActivityShareStepper(draft.step)}
    ${body}
  `;
};

// ============================================================
// 快速模式（PRD 4.2.1）
// ============================================================
Pages.configQuick = function (packageId) {
  const pkg = MOCK.PACKAGES.find((p) => p.id === packageId) || MOCK.PACKAGES[0];
  const game = MOCK.GAMES.find((g) => g.id === pkg.game_id);
  const basePath = location.hash.startsWith("#/ops/package-config") ? "/ops/package-config" : "/ops/share-config";
  const backPath = basePath === "/ops/package-config" ? "/ops/package-config" : "/ops/share-config";

  return `
    ${UI.pageHeader({
      title: "包体快速配置",
      desc: `当前包体：${game?.icon} ${game?.name} / ${pkg.name}（${pkg.region_name} · ${pkg.platform}）。保存后生成或维护该包体下可并行调用的 活动配置编号。`,
      actions: `<button onclick="navigate('${basePath}/${pkg.id}/expert')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">⚙️ 切换到专家模式</button>`,
    })}

    <div class="card p-6">
      ${UI.stepIndicator(["选择模板", "上传图片", "确认渠道", "保存生效"], 0)}

      <div class="mt-8 max-w-3xl mx-auto">
        <h3 class="text-base font-semibold text-ink-900 mb-2">Step 1 · 选择预设模板</h3>
        <p class="text-sm text-ink-500 mb-5">系统已为不同品类游戏准备了最佳实践模板，选择后可直接生效</p>

        <div class="grid grid-cols-3 gap-3">
          ${[
            { name: "休闲游戏模板", icon: "🍬", desc: "适合三消、跑酷、解谜", channels: 8, color: "from-pink-400 to-rose-500", recommended: false },
            { name: "RPG 游戏模板", icon: "⚔️", desc: "适合 MMORPG、ARPG", channels: 10, color: "from-amber-400 to-orange-500", recommended: true },
            { name: "策略 SLG 模板", icon: "🏰", desc: "适合 SLG、卡牌", channels: 9, color: "from-emerald-400 to-teal-500", recommended: false },
          ]
            .map(
              (t) => `
            <label class="relative cursor-pointer">
              <input type="radio" name="template" class="peer sr-only" ${t.recommended ? "checked" : ""} />
              <div class="border-2 border-ink-100 peer-checked:border-brand-500 peer-checked:bg-brand-50/30 rounded-xl p-5 hover:border-brand-300 transition">
                ${t.recommended ? `<div class="absolute -top-2 right-3 px-2 py-0.5 bg-brand-500 text-white text-[10px] rounded-full">推荐</div>` : ""}
                <div class="w-12 h-12 rounded-xl bg-ink-100 flex items-center justify-center text-2xl mb-3">${t.icon}</div>
                <div class="text-sm font-semibold text-ink-900">${t.name}</div>
                <div class="text-xs text-ink-500 mt-1">${t.desc}</div>
                <div class="mt-3 pt-3 border-t border-ink-100 text-xs text-ink-700">
                  默认启用 <strong>${t.channels}</strong> 个渠道
                </div>
              </div>
            </label>
          `,
            )
            .join("")}
        </div>

        <div class="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4 text-sm text-blue-900 flex gap-2">
          <span>💡</span>
          <div>
            <strong>预设包含什么？</strong>
            默认分享文案 + 标准 UTM 参数 + 推荐渠道列表 + 默认归因窗口（7 天）。所有内容后续可在专家模式中精细修改。
          </div>
        </div>

        <div class="flex justify-between mt-8 pt-6 border-t border-ink-100">
          <button onclick="navigate('${backPath}')" class="px-4 py-2 border border-ink-100 rounded-lg text-sm hover:bg-ink-50">取消</button>
          <button onclick="confirmAction('保存包体级配置', '确定要将当前模板作为该包体的一个 活动配置编号 发布吗？该 活动配置编号 将与包体下其它 活动配置编号 并行可用。', '确认发布', '包体级 活动配置编号 已发布，可并行调用', '${backPath}')" class="px-6 py-2 bg-brand-500 text-white rounded-lg text-sm hover:bg-brand-600">
            保存为包体级 活动配置编号 →
          </button>
        </div>
      </div>
    </div>
  `;
};

// ============================================================
// 专家模式（PRD 4.2.2）
// 体现 ShareContent 抽象 + Adapter 模式 + 平台能力矩阵
// ============================================================
Pages.configExpert = function (packageId) {
  const pkg = MOCK.PACKAGES.find((p) => p.id === packageId) || MOCK.PACKAGES[0];
  const game = MOCK.GAMES.find((g) => g.id === pkg.game_id);
  const basePath = "/ops/share-config";
  const backPath = "/ops/share-config";

  // tab state
  const step = parseInt(location.hash.split("?step=")[1] || "1");

  return `
    ${UI.pageHeader({
      title: "包体专家配置",
      desc: `当前包体：${game?.icon} ${game?.name} / ${pkg.name}（${pkg.region_name} · ${pkg.platform}）。保存后生成或维护该包体下可并行调用的 活动配置编号。`,
      actions: `
        <button onclick="confirmAction('保存草稿', '确定要保存当前配置为草稿吗？草稿不会立即发布到 SDK。', '确认保存', '已保存为草稿', '', 'info')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">💾 保存草稿</button>
        <button onclick="navigate('${basePath}/${pkg.id}/quick')" class="px-3 py-1.5 text-sm border border-ink-100 rounded-lg hover:bg-ink-50">⚡️ 切换快速模式</button>
      `,
    })}

    <div class="card p-6">
      ${UI.stepIndicator(["选择目标", "分享样式", "渠道配置", "高级设置"], step - 1)}

      <div class="mt-2">
        ${renderExpertStep(step, pkg, game)}
      </div>

      <div class="flex justify-between mt-8 pt-6 border-t border-ink-100">
        <button ${step === 1 ? "disabled" : ""} onclick="navigate('${basePath}/${pkg.id}/expert?step=${step - 1}')" class="px-4 py-2 border border-ink-100 rounded-lg text-sm hover:bg-ink-50 disabled:opacity-40 disabled:cursor-not-allowed">← 上一步</button>
        <div class="flex gap-2">
          <button onclick="confirmAction('保存草稿', '确定要保存当前配置为草稿吗？草稿不会立即发布到 SDK。', '确认保存', '已保存为草稿', '', 'info')" class="px-4 py-2 border border-ink-100 rounded-lg text-sm hover:bg-ink-50">保存草稿</button>
          ${
            step < 4
              ? `<button onclick="navigate('${basePath}/${pkg.id}/expert?step=${step + 1}')" class="px-6 py-2 bg-brand-500 text-white rounded-lg text-sm hover:bg-brand-600">下一步 →</button>`
              : `<button onclick="confirmAction('保存包体级配置', '确定要发布当前包体级 活动配置编号 吗？它将与该包体下其它 活动配置编号 并行可用。', '确认发布', '包体级 活动配置编号 已发布，可并行调用', '${backPath}')" class="px-6 py-2 bg-brand-500 text-white rounded-lg text-sm hover:bg-brand-600">保存包体级 活动配置编号</button>`
          }
        </div>
      </div>
    </div>
  `;
};

function renderExpertStep(step, pkg, game) {
  if (step === 1) return renderExpertStep1(pkg, game);
  if (step === 2) return renderExpertStep2(pkg, game);
  if (step === 3) return renderExpertStep3(pkg, game);
  if (step === 4) return renderExpertStep4(pkg, game);
}

// Step 1 · 选择目标 + 配置继承提示
function renderExpertStep1(pkg, game) {
  return `
    <div class="max-w-3xl">
      <h3 class="text-base font-semibold text-ink-900">Step 1 · 配置目标确认</h3>
      <p class="text-sm text-ink-500 mt-1">确认本次要配置的游戏与包体</p>

      <div class="grid grid-cols-2 gap-4 mt-5">
        <div>
          <label class="block text-sm font-medium text-ink-700 mb-1">游戏</label>
          <div class="flex items-center gap-2 px-3 py-2.5 border border-ink-100 rounded-lg bg-ink-50">
            <span class="text-xl">${game.icon}</span>
            <span class="text-sm font-medium">${game.name}</span>
            <span class="ml-auto text-xs text-ink-500 font-mono">${game.code}</span>
          </div>
        </div>
        <div>
          <label class="block text-sm font-medium text-ink-700 mb-1">包体</label>
          <div class="flex items-center gap-2 px-3 py-2.5 border border-ink-100 rounded-lg bg-ink-50">
            <span class="badge bg-blue-50 text-blue-700">${pkg.region}</span>
            <span class="badge bg-ink-100 text-ink-700">${pkg.platform}</span>
            <span class="text-sm font-medium">${pkg.name}</span>
          </div>
        </div>
      </div>

      <!-- 活动配置编号 并行机制可视化 -->
      <div class="mt-8">
        <div class="text-sm font-medium text-ink-900 mb-2">活动配置编号 并行机制</div>
        <div class="bg-brand-50 rounded-xl p-5 border border-brand-100">
          <div class="flex items-center justify-between gap-4">
            <div class="flex-1 text-center">
              <div class="text-3xl mb-1">📦</div>
              <div class="text-xs text-ink-500">包体 包体标识</div>
              <div class="text-sm font-semibold mt-0.5">${pkg.name}</div>
              <div class="mt-2 text-[11px] text-ink-500">可关联多个 活动配置编号</div>
            </div>
            <div class="text-2xl text-brand-500">→</div>
            <div class="flex-1 text-center">
              <div class="text-3xl mb-1">🎯</div>
              <div class="text-xs text-ink-500">多个 活动配置编号</div>
              <div class="text-sm font-semibold mt-0.5">并行可调用</div>
              <div class="mt-2 text-[11px] text-ink-500">不存在优先级</div>
            </div>
            <div class="text-2xl text-brand-500">→</div>
            <div class="flex-1 text-center">
              <div class="text-3xl mb-1">📱</div>
              <div class="text-xs text-ink-500">SDK 调用</div>
              <div class="text-sm font-semibold mt-0.5 text-brand-600">指定 活动配置编号</div>
              <div class="mt-2 text-[11px] text-ink-500">读取 卡片 + 落地页 组合</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Config / 落地页 运行时提示 -->
      <div class="mt-6 bg-ink-50 rounded-lg p-4">
        <div class="text-xs font-semibold text-ink-700 mb-2 flex items-center gap-1">
          <span class="px-2 py-0.5 bg-brand-100 text-brand-700 rounded text-[10px]">技术提示</span>
          <span>保存后生成包体级 活动配置编号，并可与其它 活动配置编号 并行运行</span>
        </div>
        <pre class="text-xs font-mono text-ink-700 leading-relaxed">SDK.share(configID, channel)
  → 客户端显式指定本次使用的 活动配置编号
  → SDK 只在该 活动配置编号 下读取 卡片编号 + 落地页编号 组合
  → 卡片编号 决定渠道内卡片展示
  → 落地页编号 决定点击后的落地页
  → 同一个 活动配置编号 可搭载多组组合</pre>
      </div>
    </div>
  `;
}

// Step 2 · 分享样式（多语言 + 图片）
function renderExpertStep2(pkg, game) {
  return `
    <div>
      <h3 class="text-base font-semibold text-ink-900">Step 2 · 落地页 分享内容</h3>
      <p class="text-sm text-ink-500 mt-1">这些字段属于 模版 派生 落地页 的分享内容；若命中 URL 落地页，则会直接使用 URL 跳转。</p>

      <div class="grid grid-cols-2 gap-6 mt-6">
        <!-- 左：表单 -->
        <div class="space-y-5">
          <!-- 分享图片 -->
          <div>
            <label class="block text-sm font-medium text-ink-700 mb-2">分享图片 (image)</label>
            <div onclick="document.getElementById('share-content-image-file').click()" class="border-2 border-dashed border-ink-100 rounded-lg p-6 text-center hover:border-brand-300 cursor-pointer">
              <div id="share-content-image-preview" class="w-full h-36 rounded-lg bg-ink-50 border border-ink-100 flex items-center justify-center text-4xl mb-3 overflow-hidden">🖼️</div>
              <div class="text-sm text-ink-700 font-medium">点击上传图片</div>
              <div id="share-content-image-name" class="text-xs text-ink-500 mt-1">建议 1200×630 px，&lt; 1 MB，PNG / JPG / WebP</div>
              <div class="mt-2 text-[10px] text-amber-600 bg-amber-50 inline-block px-2 py-0.5 rounded">⚠️ 部分平台 CDN 缓存最长 24h，更新图片需带版本号</div>
            </div>
            <input id="share-content-image-file" type="file" accept="image/png,image/jpeg,image/webp" class="hidden" onchange="handleShareContentImageFile(this.files?.[0])" />
          </div>

          <!-- 多语言 title -->
          <div>
            <div class="flex items-center justify-between mb-2">
              <label class="text-sm font-medium text-ink-700">分享标题 (title) · 多语言</label>
              <button class="text-xs text-brand-500 hover:underline">+ 添加语言</button>
            </div>
            <div class="space-y-2">
              ${[
                { code: "en", flag: "🇺🇸", value: "Join me in epic battle!" },
                { code: "zh-CN", flag: "🇨🇳", value: "快来和我一起战斗！" },
                { code: "ja", flag: "🇯🇵", value: "一緒に戦おう！" },
              ]
                .map(
                  (l) => `
                <div class="flex items-center gap-2">
                  <span class="px-2 py-1 bg-ink-100 rounded text-xs font-medium flex items-center gap-1 w-20">${l.flag} ${l.code}</span>
                  <input type="text" value="${l.value}" class="flex-1 px-3 py-2 border border-ink-100 rounded-lg text-sm" />
                  <button class="text-ink-300 hover:text-red-500 px-1">✕</button>
                </div>
              `,
                )
                .join("")}
            </div>
          </div>

          <!-- 多语言 description -->
          <div>
            <label class="text-sm font-medium text-ink-700">分享描述 (description)</label>
            <div class="space-y-2 mt-2">
              <div class="flex items-start gap-2">
                <span class="px-2 py-1 bg-ink-100 rounded text-xs font-medium flex items-center gap-1 w-20 flex-shrink-0 mt-0.5">🇺🇸 en</span>
                <textarea rows="2" class="flex-1 px-3 py-2 border border-ink-100 rounded-lg text-sm">Download now and get free gems! New players welcome.</textarea>
              </div>
              <div class="flex items-start gap-2">
                <span class="px-2 py-1 bg-ink-100 rounded text-xs font-medium flex items-center gap-1 w-20 flex-shrink-0 mt-0.5">🇨🇳 zh-CN</span>
                <textarea rows="2" class="flex-1 px-3 py-2 border border-ink-100 rounded-lg text-sm">立即下载领取免费宝石！新玩家专享福利。</textarea>
              </div>
            </div>
          </div>

          <!-- target_url -->
          <div>
            <label class="block text-sm font-medium text-ink-700 mb-1">落地页 URL (target_url)</label>
            <input type="url" value="https://share.kingsquest.com/landing" class="w-full px-3 py-2 border border-ink-100 rounded-lg text-sm font-mono" />
            <p class="text-xs text-ink-500 mt-1">用户点击短链最终跳转的 URL，需正确埋设 OG meta</p>
          </div>

          <!-- deep_link -->
          <div>
            <label class="block text-sm font-medium text-ink-700 mb-1">Deep Link / 应用唤起</label>
            <div class="grid grid-cols-2 gap-2">
              <input type="text" value="kingsquest://share/invite" class="px-3 py-2 border border-ink-100 rounded-lg text-sm font-mono" placeholder="deep_link (URL Scheme)" />
              <input type="text" value="https://app.kingsquest.com/i" class="px-3 py-2 border border-ink-100 rounded-lg text-sm font-mono" placeholder="app_link (Universal Link)" />
            </div>
            <input type="text" value="https://kingsquest.com/download" class="mt-2 w-full px-3 py-2 border border-ink-100 rounded-lg text-sm font-mono" placeholder="fallback_url（唤起失败兜底）" />
            <div class="mt-2 text-[10px] text-amber-600 bg-amber-50 inline-block px-2 py-0.5 rounded">⚠️ iOS 14+ schema 拦截 / Android intent 兼容差异，强烈建议同时填 app_link + fallback</div>
          </div>
        </div>

        <!-- 右：实时预览 -->
        <div>
          <div class="text-sm font-medium text-ink-700 mb-2">实时预览（不同平台）</div>

          <div class="sticky top-2 space-y-3">
            <!-- Facebook OG 预览 -->
            <div class="border border-ink-100 rounded-lg overflow-hidden">
              <div class="bg-ink-50 px-3 py-1.5 text-xs flex items-center gap-1.5"><span>📘</span> Facebook / Messenger（OG）</div>
              <div class="p-3">
                <div class="share-platform-preview bg-warn-100 h-32 rounded flex items-center justify-center text-4xl overflow-hidden">👑</div>
                <div class="text-[10px] text-ink-300 mt-2 uppercase">share.kingsquest.com</div>
                <div class="text-sm font-semibold mt-0.5">Join me in epic battle!</div>
                <div class="text-xs text-ink-500 mt-0.5">Download now and get free gems! New players welcome.</div>
              </div>
            </div>

            <!-- Twitter 卡片 预览 -->
            <div class="border border-ink-100 rounded-lg overflow-hidden">
              <div class="bg-ink-50 px-3 py-1.5 text-xs flex items-center gap-1.5"><span>𝕏</span> Twitter 卡片</div>
              <div class="p-3">
                <div class="share-platform-preview bg-warn-100 h-24 rounded-lg flex items-center justify-center text-3xl overflow-hidden">👑</div>
                <div class="mt-2 text-sm font-semibold">Join me in epic battle!</div>
                <div class="text-xs text-ink-500">share.kingsquest.com</div>
              </div>
            </div>

            <!-- Telegram 预览 -->
            <div class="border border-ink-100 rounded-lg overflow-hidden">
              <div class="bg-ink-50 px-3 py-1.5 text-xs flex items-center gap-1.5"><span>✈️</span> Telegram instant view</div>
              <div class="p-3 border-l-4 border-cyan-500 ml-1 pl-3">
                <div class="text-xs text-cyan-600 font-medium">share.kingsquest.com</div>
                <div class="text-sm font-semibold mt-0.5">Join me in epic battle!</div>
                <div class="text-xs text-ink-500 mt-0.5">Download now...</div>
                <div class="share-platform-preview bg-warn-100 h-20 rounded mt-2 flex items-center justify-center text-2xl overflow-hidden">👑</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
}

// Step 3 · 渠道配置（核心：Adapter 模式 + 平台能力 + 自定义参数）
function renderExpertStep3(pkg, game) {
  const enabled = MOCK.CHANNELS.filter((c) => c.enabled);
  const disabled = MOCK.CHANNELS.filter((c) => !c.enabled);

  return `
    <div>
      <h3 class="text-base font-semibold text-ink-900">Step 3 · 渠道配置（Adapter 层）</h3>
      <p class="text-sm text-ink-500 mt-1">客户端传 活动配置编号 后，SDK 读取该配置下的 卡片 + 落地页 组合，再由渠道 Adapter 转换为各平台调用形式。</p>

      <!-- 平台能力矩阵 -->
      <details class="mt-5 bg-ink-50 rounded-lg" open>
        <summary class="px-4 py-3 flex items-center gap-2 cursor-pointer">
          <svg class="chev w-3 h-3 text-ink-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
          <span class="text-sm font-medium">📊 平台能力矩阵（参考）</span>
          <span class="text-xs text-ink-500 ml-2">不同渠道的能力差异，影响 platform_overrides 字段</span>
        </summary>
        <div class="px-4 pb-4">
          <table class="w-full text-xs">
            <thead>
              <tr class="text-ink-500">
                <th class="text-left py-2 font-medium">平台</th>
                <th class="text-center py-2 font-medium">私聊</th>
                <th class="text-center py-2 font-medium">群聊</th>
                <th class="text-left py-2 font-medium">卡片协议</th>
                <th class="text-center py-2 font-medium">富媒体</th>
              </tr>
            </thead>
            <tbody>
              ${MOCK.CHANNELS.slice(0, 7)
                .map(
                  (c) => `
                <tr class="border-t border-ink-100">
                  <td class="py-2"><span class="text-base mr-1">${c.icon}</span>${c.name}</td>
                  <td class="text-center py-2">${UI.capabilityBadge(c.capabilities.dm)}</td>
                  <td class="text-center py-2">${UI.capabilityBadge(c.capabilities.group)}</td>
                  <td class="py-2 font-mono text-[11px]">${c.capabilities.card}</td>
                  <td class="text-center py-2"><span class="badge ${c.capabilities.richMedia === "很强" ? "bg-emerald-100 text-emerald-700" : c.capabilities.richMedia === "强" ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}">${c.capabilities.richMedia}</span></td>
                </tr>
              `,
                )
                .join("")}
            </tbody>
          </table>
        </div>
      </details>

      <!-- 已启用的渠道 -->
      <div class="mt-6">
        <div class="text-sm font-medium text-ink-900 mb-2">已启用渠道（拖动调整顺序，点击展开配置）</div>
        <div class="space-y-2">
          ${enabled
            .map(
              (c, idx) => `
            <details class="border border-ink-100 rounded-lg ${idx === 0 ? "" : ""}">
              <summary class="px-4 py-3 flex items-center gap-3 cursor-pointer hover:bg-ink-50">
                <span class="text-ink-300 cursor-move">≡</span>
                <span class="text-2xl">${c.icon}</span>
                <div class="flex-1">
                  <div class="text-sm font-semibold text-ink-900">${c.name}</div>
                  <div class="text-xs text-ink-500">${c.category_name} · ${c.standard_fields.length + c.custom_fields.length} 个字段</div>
                </div>
                <button onclick="event.preventDefault(); UI.toast('已发起测试分享，请查看调试工具', 'info')" class="px-2.5 py-1 text-xs rounded-md bg-blue-50 text-blue-600 hover:bg-blue-100">🧪 测试</button>
                <label class="relative inline-flex items-center cursor-pointer" onclick="event.stopPropagation()">
                  <input type="checkbox" checked class="sr-only peer" />
                  <div class="w-9 h-5 bg-ink-100 peer-checked:bg-brand-500 rounded-full transition relative">
                    <div class="absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full peer-checked:translate-x-4 transition shadow"></div>
                  </div>
                </label>
                <svg class="chev w-4 h-4 text-ink-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
              </summary>
              <div class="px-4 pb-4 pt-2 border-t border-ink-100 bg-ink-50/50">
                ${renderChannelConfigForm(c)}
              </div>
            </details>
          `,
            )
            .join("")}
        </div>
      </div>

      <!-- 未启用渠道 -->
      <div class="mt-6">
        <div class="text-sm font-medium text-ink-700 mb-2">未启用渠道（点击启用后可配置）</div>
        <div class="flex flex-wrap gap-2">
          ${disabled
            .map(
              (c) => `
            <button onclick="UI.toast('已启用 ${c.name}，请展开配置', 'success')" class="px-3 py-2 border border-ink-100 rounded-lg hover:border-brand-300 hover:bg-brand-50/30 flex items-center gap-2 text-sm">
              <span class="text-base">${c.icon}</span>
              <span>${c.name}</span>
              <span class="text-xs text-brand-500">+ 启用</span>
            </button>
          `,
            )
            .join("")}
        </div>
      </div>
    </div>
  `;
}

function renderChannelConfigForm(c) {
  return `
    <div class="grid grid-cols-2 gap-4">
      <!-- 标准 UTM -->
      <div>
        <div class="text-xs font-semibold text-ink-700 mb-2 flex items-center gap-1">
          <span class="px-1.5 py-0.5 bg-blue-100 text-blue-700 text-[10px] rounded">标准字段</span>
          <span>UTM 追踪参数</span>
        </div>
        <div class="space-y-2">
          ${c.standard_fields
            .map(
              (f) => `
            <div class="flex items-center gap-2">
              <label class="text-xs text-ink-500 w-28 font-mono">${f}</label>
              <input type="text" value="${f === "utm_source" ? c.code : f === "utm_medium" ? c.category : "spring_2026"}" class="flex-1 px-2.5 py-1.5 border border-ink-100 rounded text-xs font-mono" />
            </div>
          `,
            )
            .join("")}
        </div>
      </div>

      <!-- 自定义字段（platform_overrides） -->
      <div>
        <div class="text-xs font-semibold text-ink-700 mb-2 flex items-center gap-1">
          <span class="px-1.5 py-0.5 bg-purple-100 text-purple-700 text-[10px] rounded">渠道特有</span>
          <span>platform_overrides.${c.code}</span>
        </div>
        <div class="space-y-2">
          ${c.custom_fields
            .map(
              (f) => `
            <div class="flex items-center gap-2">
              <label class="text-xs text-ink-500 w-28 font-mono">${f}${["fb_app_id", "phone", "app_key", "client_key"].includes(f) ? '<span class="text-red-500">*</span>' : ""}</label>
              <input type="text" placeholder="${getFieldPlaceholder(c.code, f)}" class="flex-1 px-2.5 py-1.5 border border-ink-100 rounded text-xs font-mono" />
            </div>
          `,
            )
            .join("")}
        </div>
      </div>
    </div>

    <!-- 痛点提示 -->
    ${getChannelTip(c.code)}
  `;
}

function getFieldPlaceholder(channel, field) {
  const map = {
    fb_app_id: "1234567890",
    fb_redirect_uri: "https://...",
    quote: "Check this out!",
    hashtag: "#KingsQuest",
    card_type: "summary_large_image",
    via: "@kingsquest",
    hashtags: "game,mmorpg",
    phone: "+1 555 0100",
    text: "🎮 Join me!",
    instant_view: "true / false",
    liff_id: "1234567890-AbCdEfGh",
    app_key: "your_kakao_app_key",
    template_id: "12345",
    webhook_url: "https://discord.com/api/webhooks/...",
    embed_color: "#5B5BD6",
    subreddit: "r/gaming",
    flair: "Game Promo",
    story_template: "story_v1",
    client_key: "your_tiktok_client_key",
    video_template: "vertical_15s",
    sticker_id: "12345",
    share_via: "linkedin_share",
    app_id: "fb_app_id",
    ref: "share_invite",
  };
  return map[field] || "";
}

function getChannelTip(code) {
  const tips = {
    facebook: { icon: "⚠️", color: "amber", text: "Facebook crawler 缓存 OG meta，修改文案后请到调试工具点击「刷新 FB 缓存」" },
    whatsapp: { icon: "⚠️", color: "amber", text: "WhatsApp 的 OG 缓存最长 24 小时，且无官方刷新接口，建议落地页 URL 带版本号" },
    twitter: { icon: "ℹ️", color: "blue", text: "Twitter 群聊（DM Group）支持有限，部分场景将自动降级为单聊" },
    telegram: { icon: "✨", color: "green", text: "Telegram instant view 支持最强，可启用富媒体增强预览效果" },
    discord: { icon: "ℹ️", color: "blue", text: "建议提供 webhook_url 后，可让用户一键将分享 embed 到目标频道" },
  };
  const t = tips[code];
  if (!t) return "";
  const colorMap = {
    amber: "bg-amber-50 text-amber-800 border-amber-200",
    blue: "bg-blue-50 text-blue-800 border-blue-200",
    green: "bg-emerald-50 text-emerald-800 border-emerald-200",
  };
  return `<div class="mt-3 px-3 py-2 ${colorMap[t.color]} border rounded-lg text-xs flex gap-2"><span>${t.icon}</span><div>${t.text}</div></div>`;
}

// Step 4 · 高级设置
function renderExpertStep4(pkg, game) {
  return `
    <div class="max-w-3xl">
      <h3 class="text-base font-semibold text-ink-900">Step 4 · 高级设置</h3>
      <p class="text-sm text-ink-500 mt-1">归因窗口、短链、回调等系统级参数</p>

      <div class="space-y-6 mt-6">
        <!-- 归因窗口 -->
        <div>
          <label class="block text-sm font-medium text-ink-700 mb-2">归因窗口 (Attribution Window)</label>
          <div class="flex items-center gap-3">
            <input type="range" min="1" max="30" value="7" class="flex-1" oninput="this.nextElementSibling.textContent = this.value + ' 天'" />
            <span class="text-sm font-semibold text-brand-600 w-16 text-center">7 天</span>
          </div>
          <p class="text-xs text-ink-500 mt-1">用户点击分享链接后多久内安装算作有效归因，建议 7-14 天</p>
        </div>

        <!-- 短链 -->
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-ink-700 mb-1">短链有效期</label>
            <div class="flex items-center gap-2">
              <input type="number" value="30" class="w-20 px-3 py-2 border border-ink-100 rounded-lg text-sm" />
              <span class="text-sm text-ink-500">天</span>
            </div>
          </div>
          <div>
            <label class="block text-sm font-medium text-ink-700 mb-1">短链域名</label>
            <select class="w-full px-3 py-2 border border-ink-100 rounded-lg text-sm bg-white">
              <option>https://share.kqst.io（默认）</option>
              <option>https://go.kingsquest.com（自定义）</option>
            </select>
          </div>
        </div>

        <!-- 回调 -->
        <div>
          <label class="block text-sm font-medium text-ink-700 mb-1">回调 URL（可选）</label>
          <input type="url" placeholder="https://api.kingsquest.com/share-callback" class="w-full px-3 py-2 border border-ink-100 rounded-lg text-sm font-mono" />
          <p class="text-xs text-ink-500 mt-1">分享成功 / 归因匹配 / 漏斗事件触发时，系统会以 POST 方式回调此 URL</p>
        </div>

        <!-- 追踪开关 -->
        <div class="bg-ink-50 rounded-lg p-4">
          <div class="flex items-center justify-between">
            <div>
              <div class="text-sm font-medium text-ink-900">8 层漏斗追踪</div>
              <div class="text-xs text-ink-500 mt-1">关闭后将不再上报 Share/Click/Install 等事件</div>
            </div>
            <label class="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" checked class="sr-only peer" />
              <div class="w-11 h-6 bg-ink-100 peer-checked:bg-brand-500 rounded-full transition relative">
                <div class="absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full peer-checked:translate-x-5 transition shadow"></div>
              </div>
            </label>
          </div>
        </div>

        <!-- Crawler Refresh 提醒 -->
        <div class="bg-amber-50 border border-amber-200 rounded-lg p-4">
          <div class="text-sm font-semibold text-amber-900 mb-1 flex items-center gap-1">⚠️ 发布后会自动触发以下操作</div>
          <ul class="text-xs text-amber-800 space-y-1 mt-2">
            <li>• 推送配置到 SDK（5 分钟内全球生效）</li>
            <li>• 调用 Crawler Refresh Service 主动刷新 Facebook / WhatsApp / Telegram 等爬虫缓存</li>
            <li>• 落地页 URL 自动追加版本号 ?v=xxx 防止 CDN 缓存</li>
            <li>• 在调试工具中可立即测试新配置效果</li>
          </ul>
        </div>
      </div>
    </div>
  `;
}

// ---------- 分享配置图片上传：调用系统文件选择器后本地预览 ----------
window.handleShareContentImageFile = function (file) {
  if (!file) return;
  if (!file.type.startsWith("image/")) {
    UI.toast("请选择图片文件", "error");
    return;
  }
  const maxSize = 1024 * 1024;
  if (file.size > maxSize) {
    UI.toast("分享图片不能超过 1MB", "error");
    return;
  }
  const reader = new FileReader();
  reader.onload = () => {
    const dataUrl = reader.result;
    const preview = document.getElementById("share-content-image-preview");
    const fileName = document.getElementById("share-content-image-name");
    if (preview) {
      preview.innerHTML = `<img src="${dataUrl}" alt="分享图片" class="w-full h-full object-cover" />`;
      preview.classList.remove("text-4xl");
    }
    if (fileName) fileName.textContent = `${file.name} · ${(file.size / 1024).toFixed(0)}KB`;
    document.querySelectorAll(".share-platform-preview").forEach(el => {
      el.innerHTML = `<img src="${dataUrl}" alt="平台预览图" class="w-full h-full object-cover" />`;
      el.classList.remove("text-4xl", "text-3xl", "text-2xl");
    });
    UI.toast("分享图片已上传并同步到平台预览", "success");
  };
  reader.readAsDataURL(file);
};

// 从 落地页 详情进入 模版 编辑器：记录上下文用于显示回链横幅
window.openTempleEditorFromLanding = function (templeId, landingPageId) {
  if (!templeId) {
    UI.toast("该 落地页 未关联 模版编号", "warning");
    return;
  }
  window.__templeEditorContext = {
    fromLandingId: landingPageId || "",
    ts: Date.now(),
  };
  navigate(`/ops/templates/${encodeURIComponent(templeId)}`);
};

// __window_exports__
// Expose helpers for cross-page / inline onclick compatibility
;(window as any).audienceRuleLabel = audienceRuleLabel;
;(window as any).buildCardCoverDataUrl = buildCardCoverDataUrl;
;(window as any).buildExperimentAggregateRows = buildExperimentAggregateRows;
;(window as any).buildExperimentAnalysisPackageRows = buildExperimentAnalysisPackageRows;
;(window as any).buildExperimentAnalysisRows = buildExperimentAnalysisRows;
;(window as any).buildExperimentRegionPickerContext = buildExperimentRegionPickerContext;
;(window as any).buildExperimentReportTrendSeries = buildExperimentReportTrendSeries;
;(window as any).buildExperimentReportUpdateMarkSeries = buildExperimentReportUpdateMarkSeries;
;(window as any).buildExperimentRetentionAggregateRows = buildExperimentRetentionAggregateRows;
;(window as any).buildExperimentRetentionPackageRows = buildExperimentRetentionPackageRows;
;(window as any).buildExperimentRetentionRows = buildExperimentRetentionRows;
;(window as any).calculateExperimentShareDataRates = calculateExperimentShareDataRates;
;(window as any).cardIdForConfig = cardIdForConfig;
;(window as any).configId = configId;
;(window as any).configUpdatedTime = configUpdatedTime;
;(window as any).configuredAssetTime = configuredAssetTime;
;(window as any).configuredCardGalleryEmoji = configuredCardGalleryEmoji;
;(window as any).configuredCardGalleryGradient = configuredCardGalleryGradient;
;(window as any).createDemoPackageHistory = createDemoPackageHistory;
;(window as any).formatPackageConfigCallTime = formatPackageConfigCallTime;
;(window as any).getActivityConfigUpdateLogStore = getActivityConfigUpdateLogStore;
;(window as any).getActivityConfigUpdateLogs = getActivityConfigUpdateLogs;
;(window as any).getActivityShareBackPath = getActivityShareBackPath;
;(window as any).getActivityShareDraft = getActivityShareDraft;
;(window as any).getAllShareConfigsForPackage = getAllShareConfigsForPackage;
;(window as any).getChannelTip = getChannelTip;
;(window as any).getConfigByCardKey = getConfigByCardKey;
;(window as any).getConfiguredCardSearchText = getConfiguredCardSearchText;
;(window as any).getConfiguredLandingSearchText = getConfiguredLandingSearchText;
;(window as any).getDirectPackageConfig = getDirectPackageConfig;
;(window as any).getDirectPackageConfigs = getDirectPackageConfigs;
;(window as any).getExperimentAnalysisPackages = getExperimentAnalysisPackages;
;(window as any).getExperimentConfidenceValue = getExperimentConfidenceValue;
;(window as any).getExperimentConfigsForGame = getExperimentConfigsForGame;
;(window as any).getExperimentDefaultGameId = getExperimentDefaultGameId;
;(window as any).getExperimentFunnelAxisLabel = getExperimentFunnelAxisLabel;
;(window as any).getExperimentFunnelLegend = getExperimentFunnelLegend;
;(window as any).getExperimentLabDraft = getExperimentLabDraft;
;(window as any).getExperimentLabGroups = getExperimentLabGroups;
;(window as any).getExperimentLabSelectedGame = getExperimentLabSelectedGame;
;(window as any).getExperimentLanguageLabel = getExperimentLanguageLabel;
;(window as any).getExperimentRateConfidenceInterval = getExperimentRateConfidenceInterval;
;(window as any).getExperimentRegionSelectionLabels = getExperimentRegionSelectionLabels;
;(window as any).getExperimentReportFunnelRows = getExperimentReportFunnelRows;
;(window as any).getExperimentReportTrendDates = getExperimentReportTrendDates;
;(window as any).getExperimentReportTrendRows = getExperimentReportTrendRows;
;(window as any).getExperimentReportUpdateTrendMarks = getExperimentReportUpdateTrendMarks;
;(window as any).getExperimentRetentionMetricDefs = getExperimentRetentionMetricDefs;
;(window as any).getExperimentRetentionRowsForScope = getExperimentRetentionRowsForScope;
;(window as any).getExperimentRetentionScore = getExperimentRetentionScore;
;(window as any).getExperimentRetentionTrendDates = getExperimentRetentionTrendDates;
;(window as any).getExperimentScopeChannels = getExperimentScopeChannels;
;(window as any).getExperimentScopeDraft = getExperimentScopeDraft;
;(window as any).getExperimentScopeLanguages = getExperimentScopeLanguages;
;(window as any).getExperimentScopeRegions = getExperimentScopeRegions;
;(window as any).getExperimentScopeSelectionsFromDom = getExperimentScopeSelectionsFromDom;
;(window as any).getExperimentScopeSummaryFromDom = getExperimentScopeSummaryFromDom;
;(window as any).getExperimentSelectedPackageIdsFromDom = getExperimentSelectedPackageIdsFromDom;
;(window as any).getExperimentStatusMeta = getExperimentStatusMeta;
;(window as any).getExperimentTrendMetricDefs = getExperimentTrendMetricDefs;
;(window as any).getExperimentWeights = getExperimentWeights;
;(window as any).getFieldPlaceholder = getFieldPlaceholder;
;(window as any).getLandingPage = getLandingPage;
;(window as any).getLandingPagesByCreatedDesc = getLandingPagesByCreatedDesc;
;(window as any).getLandingPagesForConfig = getLandingPagesForConfig;
;(window as any).getLinkedShareConfigsForLandingPage = getLinkedShareConfigsForLandingPage;
;(window as any).getOpsVisiblePackages = getOpsVisiblePackages;
;(window as any).getPackageConfigCallStats = getPackageConfigCallStats;
;(window as any).getPackageConfigGames = getPackageConfigGames;
;(window as any).getPackageConfigSelectedGame = getPackageConfigSelectedGame;
;(window as any).getPackageOperationOverview = getPackageOperationOverview;
;(window as any).getPlanConfigsForPackage = getPlanConfigsForPackage;
;(window as any).getSelectedExperimentReportPackageId = getSelectedExperimentReportPackageId;
;(window as any).getSelectedExperimentReportTrendRoles = getSelectedExperimentReportTrendRoles;
;(window as any).getSelectedExperimentRetentionMetricKey = getSelectedExperimentRetentionMetricKey;
;(window as any).getSelectedExperimentRetentionPackageId = getSelectedExperimentRetentionPackageId;
;(window as any).getSelectedExperimentRetentionRoles = getSelectedExperimentRetentionRoles;
;(window as any).getShareActivityLanguageCount = getShareActivityLanguageCount;
;(window as any).getShareActivityLanguageVersions = getShareActivityLanguageVersions;
;(window as any).getShareConfigLanguageCodes = getShareConfigLanguageCodes;
;(window as any).getShareConfigsByCreatedDesc = getShareConfigsByCreatedDesc;
;(window as any).getShareGame = getShareGame;
;(window as any).getSortedConfiguredLandingPages = getSortedConfiguredLandingPages;
;(window as any).getSortedShareConfigs = getSortedShareConfigs;
;(window as any).getTemple = getTemple;
;(window as any).landingPageIdForLandingPage = landingPageIdForLandingPage;
;(window as any).landingPageSourceLabel = landingPageSourceLabel;
;(window as any).packageConfigHistorySortLabel = packageConfigHistorySortLabel;
;(window as any).packageFullName = packageFullName;
;(window as any).packageHistoryPath = packageHistoryPath;
;(window as any).packageSearchText = packageSearchText;
;(window as any).recordActivityConfigUpdate = recordActivityConfigUpdate;
;(window as any).renderActivityShareCardOption = renderActivityShareCardOption;
;(window as any).renderActivityShareCardPicker = renderActivityShareCardPicker;
;(window as any).renderActivityShareInfoForm = renderActivityShareInfoForm;
;(window as any).renderActivityShareLPOption = renderActivityShareLPOption;
;(window as any).renderActivityShareLandingPicker = renderActivityShareLandingPicker;
;(window as any).renderActivityShareSelectionSummary = renderActivityShareSelectionSummary;
;(window as any).renderActivityShareStepper = renderActivityShareStepper;
;(window as any).renderActivityShareSuccess = renderActivityShareSuccess;
;(window as any).renderCardConfigLandingPicker = renderCardConfigLandingPicker;
;(window as any).renderCardConfigPackagePicker = renderCardConfigPackagePicker;
;(window as any).renderCardDetailPreview = renderCardDetailPreview;
;(window as any).renderCardLandingTable = renderCardLandingTable;
;(window as any).renderChannelConfigForm = renderChannelConfigForm;
;(window as any).renderChannelIcons = renderChannelIcons;
;(window as any).renderConfigIdChips = renderConfigIdChips;
;(window as any).renderConfiguredCardLandingCombos = renderConfiguredCardLandingCombos;
;(window as any).renderConfiguredCardRow = renderConfiguredCardRow;
;(window as any).renderConfiguredCardTile = renderConfiguredCardTile;
;(window as any).renderConfiguredLandingRow = renderConfiguredLandingRow;
;(window as any).renderExperimentAnalysisMetric = renderExperimentAnalysisMetric;
;(window as any).renderExperimentAnalysisRow = renderExperimentAnalysisRow;
;(window as any).renderExperimentConfidenceBadge = renderExperimentConfidenceBadge;
;(window as any).renderExperimentConfigLine = renderExperimentConfigLine;
;(window as any).renderExperimentConfigSelector = renderExperimentConfigSelector;
;(window as any).renderExperimentFunnelConclusion = renderExperimentFunnelConclusion;
;(window as any).renderExperimentGroupItem = renderExperimentGroupItem;
;(window as any).renderExperimentInsightLine = renderExperimentInsightLine;
;(window as any).renderExperimentLabAnalysisCharts = renderExperimentLabAnalysisCharts;
;(window as any).renderExperimentLabRetentionCharts = renderExperimentLabRetentionCharts;
;(window as any).renderExperimentPackageConclusion = renderExperimentPackageConclusion;
;(window as any).renderExperimentRegionScopeEntry = renderExperimentRegionScopeEntry;
;(window as any).renderExperimentRetentionAnalysisRow = renderExperimentRetentionAnalysisRow;
;(window as any).renderExperimentRetentionConclusion = renderExperimentRetentionConclusion;
;(window as any).renderExperimentScopeConditionGroup = renderExperimentScopeConditionGroup;
;(window as any).renderExperimentScopeSummaryChips = renderExperimentScopeSummaryChips;
;(window as any).renderExperimentSegmentCard = renderExperimentSegmentCard;
;(window as any).renderExperimentVariantAddPanel = renderExperimentVariantAddPanel;
;(window as any).renderExpertStep = renderExpertStep;
;(window as any).renderExpertStep1 = renderExpertStep1;
;(window as any).renderExpertStep2 = renderExpertStep2;
;(window as any).renderExpertStep3 = renderExpertStep3;
;(window as any).renderExpertStep4 = renderExpertStep4;
;(window as any).renderGameIcon = renderGameIcon;
;(window as any).renderHistoryPagination = renderHistoryPagination;
;(window as any).renderLandingPageCards = renderLandingPageCards;
;(window as any).renderLandingPageIdChips = renderLandingPageIdChips;
;(window as any).renderLandingPageLinkedConfigTable = renderLandingPageLinkedConfigTable;
;(window as any).renderLandingPageMobilePreview = renderLandingPageMobilePreview;
;(window as any).renderLandingPageRules = renderLandingPageRules;
;(window as any).renderLandingPageSourceChips = renderLandingPageSourceChips;
;(window as any).renderOpsModuleTabs = renderOpsModuleTabs;
;(window as any).renderOpsWorkflowHint = renderOpsWorkflowHint;
;(window as any).renderPackageConfigAssetSummary = renderPackageConfigAssetSummary;
;(window as any).renderPackageConfigRow = renderPackageConfigRow;
;(window as any).renderPackageHistoryItem = renderPackageHistoryItem;
;(window as any).renderPackageLandingCards = renderPackageLandingCards;
;(window as any).renderPlanConfigRow = renderPlanConfigRow;
;(window as any).renderShareActivityLanguageChips = renderShareActivityLanguageChips;
;(window as any).renderShareActivityManageCard = renderShareActivityManageCard;
;(window as any).renderShareActivityManageRow = renderShareActivityManageRow;
;(window as any).renderShareActivityPagination = renderShareActivityPagination;
;(window as any).renderShareActivityTabs = renderShareActivityTabs;
;(window as any).renderShareActivityWorkflowStep = renderShareActivityWorkflowStep;
;(window as any).resetActivityShareDraft = resetActivityShareDraft;
;(window as any).resetExperimentLabDraft = resetExperimentLabDraft;
;(window as any).resetExperimentScopeDraft = resetExperimentScopeDraft;
;(window as any).resizeExperimentLabAnalysisCharts = resizeExperimentLabAnalysisCharts;
;(window as any).resizeExperimentLabRetentionCharts = resizeExperimentLabRetentionCharts;
;(window as any).saveExperimentLabGroup = saveExperimentLabGroup;
;(window as any).saveExperimentScopeDraftFromDom = saveExperimentScopeDraftFromDom;
;(window as any).scheduleExperimentLabAnalysisCharts = scheduleExperimentLabAnalysisCharts;
;(window as any).scheduleExperimentLabRetentionCharts = scheduleExperimentLabRetentionCharts;
;(window as any).seedActivityShareEditDraft = seedActivityShareEditDraft;
;(window as any).seedShareCardStateFromConfig = seedShareCardStateFromConfig;
;(window as any).shareConfigBelongsToGame = shareConfigBelongsToGame;
;(window as any).sortPackageConfigHistory = sortPackageConfigHistory;
;(window as any).templeGradientToHex = templeGradientToHex;
;(window as any).updateExperimentGroupStatus = updateExperimentGroupStatus;
